(function($, app, undefined) {
    "use strict";
    app.Gallery = function($el, options) {
        var self = this, $triggers, upArrow, downArrow, leftArrow, rightArrow;
        function events() {
            self.$swinxyzoom.swinxyzoom({
                mode: "dock",
                size: "100%"
            });
            self.$slick.on("init reInit", function(e, slick) {
                $triggers = $el.find(".stage-trigger").on("click", function(e) {
                    e.preventDefault();
                    self.$swinxyzoom.swinxyzoom("load", this.href, this.getAttribute("data-zoom-src"));
                    $(".slick-track .slick-slide").removeClass("slick-active");
                    $(this).closest(".slick-slide").addClass("slick-active");
                });
                $(".slick-track .slick-slide").removeClass("slick-active");
                $(".slick-track .slick-slide").eq(0).addClass("slick-active");
            }).slick({
                slidesToShow: 4,
                prevArrow: leftArrow,
                nextArrow: rightArrow,
                vertical: false,
                responsive: [ {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        dots: true,
                        slidesToShow: 1,
                        vertical: false
                    }
                } ]
            });
        }
        function set() {
            if (options.arrowStyle === "diamond") {
                upArrow = '<div class="prev-arrow"><div class="arrow-diamond"><div class="diamond diamond--contrast"></div><div class="arrow arrow--up arrow--bg arrow--large"></div></div></div>';
                downArrow = '<div class="next-arrow"><div class="arrow-diamond"><div class="diamond diamond--contrast"></div><div class="arrow arrow--down arrow--bg arrow--large"></div></div></div>';
                leftArrow = '<div class="prev-arrow"><div class="arrow-diamond"><div class="diamond diamond--contrast"></div><div class="arrow arrow--left arrow--bg arrow--large"></div></div></div>';
                rightArrow = '<div class="next-arrow"><div class="arrow-diamond"><div class="diamond diamond--contrast"></div><div class="arrow arrow--right arrow--bg arrow--large"></div></div></div>';
            } else {
                upArrow = '<div class="prev-arrow"><div class="arrow arrow--up arrow--medium arrow--gray"></div></div>';
                downArrow = '<div class="next-arrow"><div class="arrow arrow--down arrow--medium arrow--gray"></div></div>';
                leftArrow = '<div class="prev-arrow"><div class="arrow arrow--left arrow--medium arrow--gray"></div></div>';
                rightArrow = '<div class="next-arrow"><div class="arrow arrow--right arrow--medium arrow--gray"></div></div>';
            }
        }
        function els() {
            self.$swinxyzoom = $el.find(".swinxyzoom");
            self.$slick = $el.find(".slick-init--responsive");
            return self.$swinxyzoom.length > 0 && self.$slick.length > 0;
        }
        function init() {
            set();
            if (els()) {
                events();
                return self;
            } else {
                return false;
            }
        }
        return init();
    };
})(jQuery, window.jasleyAshon = window.jasleyAshon || {});

jQuery(function($) {
    "use strict";
    var $reader = new FileReader(), $imgHolder = $("#image-holder"), $img = $("<img>");
    function readURL(input) {
        if (input.files && input.files[0]) {
            $reader.onload = function(e) {
                $imgHolder.addClass("image-upload-visible").append($img);
                $img.attr("src", e.target.result);
            };
            $reader.readAsDataURL(input.files[0]);
        } else {
            $imgHolder.append("Your browser does not support FileReader. Your image will still be uploaded.");
        }
    }
    $(document).on("change", 'input[type="file"]', function() {
        readURL(this);
    });
    $(document).on("click", "[data-toggle-image]", function() {
        $imgHolder.children("img").remove();
        $imgHolder.removeClass("image-upload-visible");
    });
});

jQuery(function($) {
    "use strict";
    var Scrollable = function($el, options) {
        var el = $el[0], className = "scrollable", offset = el.getAttribute("data-scrollable-offset") || 0, elH;
        function setHeight(w, h) {
            var targetHeight = h - offset;
            $el.removeClass(className);
            el.removeAttribute("style");
            elH = $el.height();
            if (elH > h) {
                $el.addClass(className);
                $el.css({
                    height: targetHeight + "px"
                });
            }
        }
        function init() {
            offset = parseInt(offset, 10);
            window.jasleyAshon.resizer.add(setHeight);
        }
        init();
    };
    $.fn.scrollable = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("scrollable") && !destroy) {
                $this.data("scrollable", new Scrollable($this, options));
            } else if ($this.data("scrollable") && destroy) {
                $this.data("scrollable").destroy();
            }
            return $this;
        });
    };
    $("[data-scrollable]").scrollable();
});

(function($, app, undefined) {
    "use strict";
    app.Linkset = function(name, onChange) {
        var self = this, $links, value;
        function setValue(e) {
            $links.removeAttr("data-linkset-selected");
            value = this.getAttribute("data-linkset-value");
            this.setAttribute("data-linkset-selected", true);
            if (e && onChange) {
                onChange.call(self);
            }
        }
        function events() {
            $links.on("click", setValue);
        }
        function setCurrentValue() {
            var $currentLink;
            if (($currentLink = $links.filter("[data-linkset-selected]")).length) {
                setValue.call($currentLink[0]);
            }
        }
        function els() {
            $links = $('[data-linkset-name="' + name + '"]');
            return $links.length;
        }
        function init() {
            if (els()) {
                setCurrentValue();
                events();
            }
        }
        this.destroy = function() {
            $links.off("click", setValue);
        };
        this.val = function() {
            return value;
        };
        init();
    };
})(jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function($, app, undefined) {
    "use strict";
    app.MobileMenu = function(options) {
        var self = this;
        this.$el = $(".main-nav--mobile");
        this.$body = $("body");
        this.close = function() {
            self.$el.removeClass("active");
            self.$body.removeClass("active");
        };
        this.open = function() {
            self.$el.addClass("active");
            self.$body.addClass("active");
        };
    };
})(jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function($, app, undefined) {
    "use strict";
    app.NewsletterPopup = function(options) {
        var self = this, COOKIE_VAL = "opened", cookie = {}, settings, defaults = {
            el: "#newsletter-popup",
            cookieName: "jasleyAshonNewsletterPopup"
        };
        this.open = function() {
            $.magnificPopup.open({
                items: {
                    src: settings.el
                },
                type: "inline",
                closeBtnInside: true,
                preloader: false,
                midClick: true,
                removalDelay: 300,
                mainClass: "mfp-zoom-in mfp-newsletter",
                closeMarkup: '<button title="%title%" class="mfp-close x x--contrast">X</button>'
            }, 0);
            if (event && event.preventDefault) {
                event.preventDefault();
            }
        };
        function normalizeInt(str) {
            if (str === "") {
                return 0;
            } else {
                return parseInt(str, 10);
            }
        }
        function set() {
            settings = $.extend(true, {}, defaults, options);
            settings.days = normalizeInt(settings.days);
            settings.seconds = normalizeInt(settings.seconds);
        }
        function init() {
            set();
            cookie.value = $.cookie(settings.cookieName);
            cookie.enabled = settings.days !== 0;
            if (!settings.enabled || cookie.enabled && cookie.value === COOKIE_VAL) {
                return false;
            } else {
                setTimeout(self.open, settings.seconds * 1e3);
            }
            if (cookie.enabled) {
                $.cookie(settings.cookieName, COOKIE_VAL, {
                    expires: parseInt(settings.days, 10)
                });
            }
        }
        init();
    };
})(window.jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function($, app, undefined) {
    "use strict";
    app.Quickview = function(options, Gallery, galleryOptions) {
        var self = this, $openButtons, settings, gallery, defaults = {
            openButtons: "[data-quickview-open]"
        };
        this.open = function(target) {
            $.magnificPopup.open({
                items: {
                    src: target
                },
                type: "inline",
                closeBtnInside: true,
                preloader: false,
                midClick: true,
                removalDelay: 300,
                mainClass: "mfp-zoom-in",
                callbacks: {
                    open: function() {
                        var id;
                        if (this.currItem) {
                            id = this.currItem.inlineElement[0].getAttribute("data-quickview-id");
                            window.jasleyAshon.galleries[id].$slick.slick("setPosition");
                            window.jasleyAshon.galleries[id].$slick.slick("slickGoTo", 0);
                            $(".slick-track .slick-slide").eq(0).addClass("slick-active");
                        }
                    }
                }
            }, 0);
            if (event && event.preventDefault) {
                event.preventDefault();
            }
        };
        function events() {
            $openButtons.on("click", function(e) {
                e.preventDefault();
                var target = this.getAttribute("data-quickview-open");
                self.open(target);
            });
        }
        function els() {
            $openButtons = $(settings.openButtons);
            return $openButtons.length > 0;
        }
        function set() {
            settings = $.extend(true, {}, defaults, options);
        }
        function init() {
            set();
            if (els()) {
                events();
            }
        }
        init();
    };
})(window.jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function($, app, undefined) {
    "use strict";
    app.Resizer = function(options) {
        var w, h, timeout, settings, callbacks = [], defaults = {
            throttle: 100
        };
        function getDimensions() {
            w = document.documentElement.clientWidth;
            h = document.documentElement.clientHeight;
        }
        function onResize() {
            var i, len;
            getDimensions();
            for (i = 0, len = callbacks.length; i < len; i++) {
                callbacks[i](w, h);
            }
        }
        function throttleResize() {
            clearTimeout(timeout);
            timeout = setTimeout(onResize, settings.throttle);
        }
        function events() {
            $(window).on("resize", throttleResize);
        }
        function set(options) {
            settings = $.extend({}, settings || defaults, options);
        }
        function init() {
            set(options);
            getDimensions();
            events();
            onResize();
        }
        this.add = function(cb, runOnAdd) {
            runOnAdd = true || runOnAdd;
            if (runOnAdd === true) {
                getDimensions();
                cb(w, h);
            }
            callbacks.push(cb);
        };
        this.width = function() {
            return w;
        };
        this.height = function() {
            return h;
        };
        init();
    };
})(window.jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function() {
    function a(a, c, d, e) {
        return new b(a, c, d, e);
    }
    function b(a, b, d, e) {
        this.options = e || {}, this.options.adapters = this.options.adapters || {}, this.obj = a, 
        this.keypath = b, this.callback = d, this.objectPath = [], this.parse(), c(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback);
    }
    function c(a) {
        return "object" == typeof a && null !== a;
    }
    function d(a) {
        throw new Error("[sightglass] " + a);
    }
    a.adapters = {}, b.tokenize = function(a, b, c) {
        var d, e, f = [], g = {
            i: c,
            path: ""
        };
        for (d = 0; d < a.length; d++) e = a.charAt(d), ~b.indexOf(e) ? (f.push(g), g = {
            i: e,
            path: ""
        }) : g.path += e;
        return f.push(g), f;
    }, b.prototype.parse = function() {
        var c, e, f = this.interfaces();
        f.length || d("Must define at least one adapter interface."), ~f.indexOf(this.keypath[0]) ? (c = this.keypath[0], 
        e = this.keypath.substr(1)) : ("undefined" == typeof (c = this.options.root || a.root) && d("Must define a default root adapter."), 
        e = this.keypath), this.tokens = b.tokenize(e, f, c), this.key = this.tokens.pop();
    }, b.prototype.realize = function() {
        var a, b = this.obj, d = !1;
        return this.tokens.forEach(function(e, f) {
            c(b) ? ("undefined" != typeof this.objectPath[f] ? b !== (a = this.objectPath[f]) && (this.set(!1, e, a, this.update.bind(this)), 
            this.set(!0, e, b, this.update.bind(this)), this.objectPath[f] = b) : (this.set(!0, e, b, this.update.bind(this)), 
            this.objectPath[f] = b), b = this.get(e, b)) : (d === !1 && (d = f), (a = this.objectPath[f]) && this.set(!1, e, a, this.update.bind(this)));
        }, this), d !== !1 && this.objectPath.splice(d), b;
    }, b.prototype.update = function() {
        var a, b;
        (a = this.realize()) !== this.target && (c(this.target) && this.set(!1, this.key, this.target, this.callback), 
        c(a) && this.set(!0, this.key, a, this.callback), b = this.value(), this.target = a, 
        this.value() !== b && this.callback());
    }, b.prototype.value = function() {
        return c(this.target) ? this.get(this.key, this.target) : void 0;
    }, b.prototype.setValue = function(a) {
        c(this.target) && this.adapter(this.key).set(this.target, this.key.path, a);
    }, b.prototype.get = function(a, b) {
        return this.adapter(a).get(b, a.path);
    }, b.prototype.set = function(a, b, c, d) {
        var e = a ? "observe" : "unobserve";
        this.adapter(b)[e](c, b.path, d);
    }, b.prototype.interfaces = function() {
        var b = Object.keys(this.options.adapters);
        return Object.keys(a.adapters).forEach(function(a) {
            ~b.indexOf(a) || b.push(a);
        }), b;
    }, b.prototype.adapter = function(b) {
        return this.options.adapters[b.i] || a.adapters[b.i];
    }, b.prototype.unobserve = function() {
        var a;
        this.tokens.forEach(function(b, c) {
            (a = this.objectPath[c]) && this.set(!1, b, a, this.update.bind(this));
        }, this), c(this.target) && this.set(!1, this.key, this.target, this.callback);
    }, "undefined" != typeof module && module.exports ? module.exports = a : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = a;
    }) : this.sightglass = a;
}).call(this), function() {
    var a, b, c, d, e = function(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    }, f = [].slice, g = {}.hasOwnProperty, h = function(a, b) {
        function c() {
            this.constructor = a;
        }
        for (var d in b) g.call(b, d) && (a[d] = b[d]);
        return c.prototype = b.prototype, a.prototype = new c(), a.__super__ = b.prototype, 
        a;
    }, i = [].indexOf || function(a) {
        for (var b = 0, c = this.length; c > b; b++) if (b in this && this[b] === a) return b;
        return -1;
    };
    a = {
        options: [ "prefix", "templateDelimiters", "rootInterface", "preloadData", "handler" ],
        extensions: [ "binders", "formatters", "components", "adapters" ],
        "public": {
            binders: {},
            components: {},
            formatters: {},
            adapters: {},
            prefix: "rv",
            templateDelimiters: [ "{", "}" ],
            rootInterface: ".",
            preloadData: !0,
            handler: function(a, b, c) {
                return this.call(a, b, c.view.models);
            },
            configure: function(b) {
                var c, d, e, f;
                null == b && (b = {});
                for (e in b) if (f = b[e], "binders" === e || "components" === e || "formatters" === e || "adapters" === e) for (d in f) c = f[d], 
                a[e][d] = c; else a["public"][e] = f;
            },
            bind: function(b, c, d) {
                var e;
                return null == c && (c = {}), null == d && (d = {}), e = new a.View(b, c, d), e.bind(), 
                e;
            },
            init: function(b, c, d) {
                var e, f;
                return null == d && (d = {}), null == c && (c = document.createElement("div")), 
                b = a["public"].components[b], c.innerHTML = b.template.call(this, c), e = b.initialize.call(this, c, d), 
                f = new a.View(c, e), f.bind(), f;
            }
        }
    }, window.jQuery || window.$ ? (d = "on" in jQuery.prototype ? [ "on", "off" ] : [ "bind", "unbind" ], 
    b = d[0], c = d[1], a.Util = {
        bindEvent: function(a, c, d) {
            return jQuery(a)[b](c, d);
        },
        unbindEvent: function(a, b, d) {
            return jQuery(a)[c](b, d);
        },
        getInputValue: function(a) {
            var b;
            return b = jQuery(a), "checkbox" === b.attr("type") ? b.is(":checked") : b.val();
        }
    }) : a.Util = {
        bindEvent: function() {
            return "addEventListener" in window ? function(a, b, c) {
                return a.addEventListener(b, c, !1);
            } : function(a, b, c) {
                return a.attachEvent("on" + b, c);
            };
        }(),
        unbindEvent: function() {
            return "removeEventListener" in window ? function(a, b, c) {
                return a.removeEventListener(b, c, !1);
            } : function(a, b, c) {
                return a.detachEvent("on" + b, c);
            };
        }(),
        getInputValue: function(a) {
            var b, c, d, e;
            if ("checkbox" === a.type) return a.checked;
            if ("select-multiple" === a.type) {
                for (e = [], c = 0, d = a.length; d > c; c++) b = a[c], b.selected && e.push(b.value);
                return e;
            }
            return a.value;
        }
    }, a.TypeParser = function() {
        function a() {}
        return a.types = {
            primitive: 0,
            keypath: 1
        }, a.parse = function(a) {
            return /^'.*'$|^".*"$/.test(a) ? {
                type: this.types.primitive,
                value: a.slice(1, -1)
            } : "true" === a ? {
                type: this.types.primitive,
                value: !0
            } : "false" === a ? {
                type: this.types.primitive,
                value: !1
            } : "null" === a ? {
                type: this.types.primitive,
                value: null
            } : "undefined" === a ? {
                type: this.types.primitive,
                value: void 0
            } : isNaN(Number(a)) === !1 ? {
                type: this.types.primitive,
                value: Number(a)
            } : {
                type: this.types.keypath,
                value: a
            };
        }, a;
    }(), a.TextTemplateParser = function() {
        function a() {}
        return a.types = {
            text: 0,
            binding: 1
        }, a.parse = function(a, b) {
            var c, d, e, f, g, h, i;
            for (h = [], f = a.length, c = 0, d = 0; f > d; ) {
                if (c = a.indexOf(b[0], d), 0 > c) {
                    h.push({
                        type: this.types.text,
                        value: a.slice(d)
                    });
                    break;
                }
                if (c > 0 && c > d && h.push({
                    type: this.types.text,
                    value: a.slice(d, c)
                }), d = c + b[0].length, c = a.indexOf(b[1], d), 0 > c) {
                    g = a.slice(d - b[1].length), e = h[h.length - 1], (null != e ? e.type : void 0) === this.types.text ? e.value += g : h.push({
                        type: this.types.text,
                        value: g
                    });
                    break;
                }
                i = a.slice(d, c).trim(), h.push({
                    type: this.types.binding,
                    value: i
                }), d = c + b[1].length;
            }
            return h;
        }, a;
    }(), a.View = function() {
        function b(b, c, d) {
            var f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (this.els = b, this.models = c, null == d && (d = {}), this.update = e(this.update, this), 
            this.publish = e(this.publish, this), this.sync = e(this.sync, this), this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.select = e(this.select, this), this.traverse = e(this.traverse, this), 
            this.build = e(this.build, this), this.buildBinding = e(this.buildBinding, this), 
            this.bindingRegExp = e(this.bindingRegExp, this), this.options = e(this.options, this), 
            this.els.jquery || this.els instanceof Array || (this.els = [ this.els ]), n = a.extensions, 
            j = 0, l = n.length; l > j; j++) {
                if (g = n[j], this[g] = {}, d[g]) {
                    o = d[g];
                    for (f in o) h = o[f], this[g][f] = h;
                }
                p = a["public"][g];
                for (f in p) h = p[f], null == (i = this[g])[f] && (i[f] = h);
            }
            for (q = a.options, k = 0, m = q.length; m > k; k++) g = q[k], this[g] = null != (r = d[g]) ? r : a["public"][g];
            this.build();
        }
        return b.prototype.options = function() {
            var b, c, d, e, f;
            for (c = {}, f = a.extensions.concat(a.options), d = 0, e = f.length; e > d; d++) b = f[d], 
            c[b] = this[b];
            return c;
        }, b.prototype.bindingRegExp = function() {
            return new RegExp("^" + this.prefix + "-");
        }, b.prototype.buildBinding = function(b, c, d, e) {
            var f, g, h, i, j, k, l;
            return j = {}, l = function() {
                var a, b, c, d;
                for (c = e.split("|"), d = [], a = 0, b = c.length; b > a; a++) k = c[a], d.push(k.trim());
                return d;
            }(), f = function() {
                var a, b, c, d;
                for (c = l.shift().split("<"), d = [], a = 0, b = c.length; b > a; a++) g = c[a], 
                d.push(g.trim());
                return d;
            }(), i = f.shift(), j.formatters = l, (h = f.shift()) && (j.dependencies = h.split(/\s+/)), 
            this.bindings.push(new a[b](this, c, d, i, j));
        }, b.prototype.build = function() {
            var b, c, d, e, f;
            for (this.bindings = [], c = function(b) {
                return function(d) {
                    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                    if (3 === d.nodeType) {
                        if (i = a.TextTemplateParser, (g = b.templateDelimiters) && (l = i.parse(d.data, g)).length && (1 !== l.length || l[0].type !== i.types.text)) {
                            for (m = 0, o = l.length; o > m; m++) k = l[m], j = document.createTextNode(k.value), 
                            d.parentNode.insertBefore(j, d), 1 === k.type && b.buildBinding("TextBinding", j, null, k.value);
                            d.parentNode.removeChild(d);
                        }
                    } else 1 === d.nodeType && (e = b.traverse(d));
                    if (!e) {
                        for (q = function() {
                            var a, b, c, e;
                            for (c = d.childNodes, e = [], a = 0, b = c.length; b > a; a++) h = c[a], e.push(h);
                            return e;
                        }(), r = [], n = 0, p = q.length; p > n; n++) f = q[n], r.push(c(f));
                        return r;
                    }
                };
            }(this), f = this.els, d = 0, e = f.length; e > d; d++) b = f[d], c(b);
            this.bindings.sort(function(a, b) {
                var c, d;
                return ((null != (c = b.binder) ? c.priority : void 0) || 0) - ((null != (d = a.binder) ? d.priority : void 0) || 0);
            });
        }, b.prototype.traverse = function(b) {
            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (f = this.bindingRegExp(), g = "SCRIPT" === b.nodeName || "STYLE" === b.nodeName, 
            p = b.attributes, l = 0, n = p.length; n > l; l++) if (c = p[l], f.test(c.name)) {
                if (j = c.name.replace(f, ""), !(e = this.binders[j])) {
                    q = this.binders;
                    for (h in q) k = q[h], "*" !== h && -1 !== h.indexOf("*") && (i = new RegExp("^" + h.replace(/\*/g, ".+") + "$"), 
                    i.test(j) && (e = k));
                }
                e || (e = this.binders["*"]), e.block && (g = !0, d = [ c ]);
            }
            for (r = d || b.attributes, m = 0, o = r.length; o > m; m++) c = r[m], f.test(c.name) && (j = c.name.replace(f, ""), 
            this.buildBinding("Binding", b, j, c.value));
            return g || (j = b.nodeName.toLowerCase(), this.components[j] && !b._bound && (this.bindings.push(new a.ComponentBinding(this, b, j)), 
            g = !0)), g;
        }, b.prototype.select = function(a) {
            var b, c, d, e, f;
            for (e = this.bindings, f = [], c = 0, d = e.length; d > c; c++) b = e[c], a(b) && f.push(b);
            return f;
        }, b.prototype.bind = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.bind());
            return e;
        }, b.prototype.unbind = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.unbind());
            return e;
        }, b.prototype.sync = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push("function" == typeof a.sync ? a.sync() : void 0);
            return e;
        }, b.prototype.publish = function() {
            var a, b, c, d, e;
            for (d = this.select(function(a) {
                var b;
                return null != (b = a.binder) ? b.publishes : void 0;
            }), e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.publish());
            return e;
        }, b.prototype.update = function(a) {
            var b, c, d, e, f, g, h;
            null == a && (a = {});
            for (c in a) d = a[c], this.models[c] = d;
            for (g = this.bindings, h = [], e = 0, f = g.length; f > e; e++) b = g[e], h.push("function" == typeof b.update ? b.update(a) : void 0);
            return h;
        }, b;
    }(), a.Binding = function() {
        function b(a, b, c, d, f) {
            this.view = a, this.el = b, this.type = c, this.keypath = d, this.options = null != f ? f : {}, 
            this.getValue = e(this.getValue, this), this.update = e(this.update, this), this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.publish = e(this.publish, this), this.sync = e(this.sync, this), 
            this.set = e(this.set, this), this.eventHandler = e(this.eventHandler, this), this.formattedValue = e(this.formattedValue, this), 
            this.parseTarget = e(this.parseTarget, this), this.observe = e(this.observe, this), 
            this.setBinder = e(this.setBinder, this), this.formatters = this.options.formatters || [], 
            this.dependencies = [], this.formatterObservers = {}, this.model = void 0, this.setBinder();
        }
        return b.prototype.setBinder = function() {
            var a, b, c, d;
            if (!(this.binder = this.view.binders[this.type])) {
                d = this.view.binders;
                for (a in d) c = d[a], "*" !== a && -1 !== a.indexOf("*") && (b = new RegExp("^" + a.replace(/\*/g, ".+") + "$"), 
                b.test(this.type) && (this.binder = c, this.args = new RegExp("^" + a.replace(/\*/g, "(.+)") + "$").exec(this.type), 
                this.args.shift()));
            }
            return this.binder || (this.binder = this.view.binders["*"]), this.binder instanceof Function ? this.binder = {
                routine: this.binder
            } : void 0;
        }, b.prototype.observe = function(b, c, d) {
            return a.sightglass(b, c, d, {
                root: this.view.rootInterface,
                adapters: this.view.adapters
            });
        }, b.prototype.parseTarget = function() {
            var b;
            return b = a.TypeParser.parse(this.keypath), 0 === b.type ? this.value = b.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync), 
            this.model = this.observer.target);
        }, b.prototype.formattedValue = function(b) {
            var c, d, e, g, h, i, j, k, l, m, n, o, p, q;
            for (q = this.formatters, g = m = 0, o = q.length; o > m; g = ++m) {
                for (h = q[g], e = h.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g), i = e.shift(), 
                h = this.view.formatters[i], e = function() {
                    var b, c, f;
                    for (f = [], b = 0, c = e.length; c > b; b++) d = e[b], f.push(a.TypeParser.parse(d));
                    return f;
                }(), k = [], c = n = 0, p = e.length; p > n; c = ++n) d = e[c], k.push(0 === d.type ? d.value : ((l = this.formatterObservers)[g] || (l[g] = {}), 
                (j = this.formatterObservers[g][c]) ? void 0 : (j = this.observe(this.view.models, d.value, this.sync), 
                this.formatterObservers[g][c] = j), j.value()));
                (null != h ? h.read : void 0) instanceof Function ? b = h.read.apply(h, [ b ].concat(f.call(k))) : h instanceof Function && (b = h.apply(null, [ b ].concat(f.call(k))));
            }
            return b;
        }, b.prototype.eventHandler = function(a) {
            var b, c;
            return c = (b = this).view.handler, function(d) {
                return c.call(a, this, d, b);
            };
        }, b.prototype.set = function(a) {
            var b;
            return a = this.formattedValue(a instanceof Function && !this.binder["function"] ? a.call(this.model) : a), 
            null != (b = this.binder.routine) ? b.call(this, this.el, a) : void 0;
        }, b.prototype.sync = function() {
            var a, b;
            return this.set(function() {
                var c, d, e, f, g, h, i;
                if (this.observer) {
                    if (this.model !== this.observer.target) {
                        for (g = this.dependencies, c = 0, e = g.length; e > c; c++) b = g[c], b.unobserve();
                        if (this.dependencies = [], null != (this.model = this.observer.target) && (null != (h = this.options.dependencies) ? h.length : void 0)) for (i = this.options.dependencies, 
                        d = 0, f = i.length; f > d; d++) a = i[d], b = this.observe(this.model, a, this.sync), 
                        this.dependencies.push(b);
                    }
                    return this.observer.value();
                }
                return this.value;
            }.call(this));
        }, b.prototype.publish = function() {
            var a, b, c, d, e, g, h, i, j;
            if (this.observer) {
                for (d = this.getValue(this.el), h = this.formatters.slice(0).reverse(), e = 0, 
                g = h.length; g > e; e++) b = h[e], a = b.split(/\s+/), c = a.shift(), (null != (i = this.view.formatters[c]) ? i.publish : void 0) && (d = (j = this.view.formatters[c]).publish.apply(j, [ d ].concat(f.call(a))));
                return this.observer.setValue(d);
            }
        }, b.prototype.bind = function() {
            var a, b, c, d, e, f, g;
            if (this.parseTarget(), null != (e = this.binder.bind) && e.call(this, this.el), 
            null != this.model && (null != (f = this.options.dependencies) ? f.length : void 0)) for (g = this.options.dependencies, 
            c = 0, d = g.length; d > c; c++) a = g[c], b = this.observe(this.model, a, this.sync), 
            this.dependencies.push(b);
            return this.view.preloadData ? this.sync() : void 0;
        }, b.prototype.unbind = function() {
            var a, b, c, d, e, f, g, h, i, j;
            for (null != (g = this.binder.unbind) && g.call(this, this.el), null != (h = this.observer) && h.unobserve(), 
            i = this.dependencies, e = 0, f = i.length; f > e; e++) d = i[e], d.unobserve();
            this.dependencies = [], j = this.formatterObservers;
            for (c in j) {
                b = j[c];
                for (a in b) d = b[a], d.unobserve();
            }
            return this.formatterObservers = {};
        }, b.prototype.update = function(a) {
            var b, c;
            return null == a && (a = {}), this.model = null != (b = this.observer) ? b.target : void 0, 
            null != (c = this.binder.update) ? c.call(this, a) : void 0;
        }, b.prototype.getValue = function(b) {
            return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, b) : a.Util.getInputValue(b);
        }, b;
    }(), a.ComponentBinding = function(b) {
        function c(a, b, c) {
            var d, f, g, h, j, k, l;
            for (this.view = a, this.el = b, this.type = c, this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.locals = e(this.locals, this), this.component = this.view.components[this.type], 
            this["static"] = {}, this.observers = {}, this.upstreamObservers = {}, f = a.bindingRegExp(), 
            k = this.el.attributes || [], h = 0, j = k.length; j > h; h++) d = k[h], f.test(d.name) || (g = this.camelCase(d.name), 
            i.call(null != (l = this.component["static"]) ? l : [], g) >= 0 ? this["static"][g] = d.value : this.observers[g] = d.value);
        }
        return h(c, b), c.prototype.sync = function() {}, c.prototype.update = function() {}, 
        c.prototype.publish = function() {}, c.prototype.locals = function() {
            var a, b, c, d, e, f;
            c = {}, e = this["static"];
            for (a in e) d = e[a], c[a] = d;
            f = this.observers;
            for (a in f) b = f[a], c[a] = b.value();
            return c;
        }, c.prototype.camelCase = function(a) {
            return a.replace(/-([a-z])/g, function(a) {
                return a[1].toUpperCase();
            });
        }, c.prototype.bind = function() {
            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
            if (!this.bound) {
                o = this.observers;
                for (c in o) d = o[c], this.observers[c] = this.observe(this.view.models, d, function(a) {
                    return function(b) {
                        return function() {
                            return a.componentView.models[b] = a.observers[b].value();
                        };
                    };
                }(this).call(this, c));
                this.bound = !0;
            }
            if (null != this.componentView) return this.componentView.bind();
            for (this.el.innerHTML = this.component.template.call(this), h = this.component.initialize.call(this, this.el, this.locals()), 
            this.el._bound = !0, g = {}, p = a.extensions, k = 0, m = p.length; m > k; k++) {
                if (f = p[k], g[f] = {}, this.component[f]) {
                    q = this.component[f];
                    for (b in q) i = q[b], g[f][b] = i;
                }
                r = this.view[f];
                for (b in r) i = r[b], null == (j = g[f])[b] && (j[b] = i);
            }
            for (s = a.options, l = 0, n = s.length; n > l; l++) f = s[l], g[f] = null != (t = this.component[f]) ? t : this.view[f];
            this.componentView = new a.View(this.el, h, g), this.componentView.bind(), u = this.observers, 
            v = [];
            for (c in u) e = u[c], v.push(this.upstreamObservers[c] = this.observe(this.componentView.models, c, function(a) {
                return function(b, c) {
                    return function() {
                        return c.setValue(a.componentView.models[b]);
                    };
                };
            }(this).call(this, c, e)));
            return v;
        }, c.prototype.unbind = function() {
            var a, b, c, d, e;
            c = this.upstreamObservers;
            for (a in c) b = c[a], b.unobserve();
            d = this.observers;
            for (a in d) b = d[a], b.unobserve();
            return null != (e = this.componentView) ? e.unbind.call(this) : void 0;
        }, c;
    }(a.Binding), a.TextBinding = function(a) {
        function b(a, b, c, d, f) {
            this.view = a, this.el = b, this.type = c, this.keypath = d, this.options = null != f ? f : {}, 
            this.sync = e(this.sync, this), this.formatters = this.options.formatters || [], 
            this.dependencies = [], this.formatterObservers = {};
        }
        return h(b, a), b.prototype.binder = {
            routine: function(a, b) {
                return a.data = null != b ? b : "";
            }
        }, b.prototype.sync = function() {
            return b.__super__.sync.apply(this, arguments);
        }, b;
    }(a.Binding), a["public"].binders.text = function(a, b) {
        return null != a.textContent ? a.textContent = null != b ? b : "" : a.innerText = null != b ? b : "";
    }, a["public"].binders.html = function(a, b) {
        return a.innerHTML = null != b ? b : "";
    }, a["public"].binders.show = function(a, b) {
        return a.style.display = b ? "" : "none";
    }, a["public"].binders.hide = function(a, b) {
        return a.style.display = b ? "none" : "";
    }, a["public"].binders.enabled = function(a, b) {
        return a.disabled = !b;
    }, a["public"].binders.disabled = function(a, b) {
        return a.disabled = !!b;
    }, a["public"].binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish);
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish);
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) === (null != b ? b.toString() : void 0) : !!b;
        }
    }, a["public"].binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish);
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish);
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) !== (null != b ? b.toString() : void 0) : !b;
        }
    }, a["public"].binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? (this.event = "SELECT" === b.tagName ? "change" : "input", 
            a.Util.bindEvent(b, this.event, this.publish)) : void 0;
        },
        unbind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? a.Util.unbindEvent(b, this.event, this.publish) : void 0;
        },
        routine: function(a, b) {
            var c, d, e, f, g, h, j;
            if ("INPUT" === a.tagName && "radio" === a.type) return a.setAttribute("value", b);
            if (null != window.jQuery) {
                if (a = jQuery(a), (null != b ? b.toString() : void 0) !== (null != (f = a.val()) ? f.toString() : void 0)) return a.val(null != b ? b : "");
            } else if ("select-multiple" === a.type) {
                if (null != b) {
                    for (j = [], d = 0, e = a.length; e > d; d++) c = a[d], j.push(c.selected = (g = c.value, 
                    i.call(b, g) >= 0));
                    return j;
                }
            } else if ((null != b ? b.toString() : void 0) !== (null != (h = a.value) ? h.toString() : void 0)) return a.value = null != b ? b : "";
        }
    }, a["public"].binders["if"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c;
            return null == this.marker ? (b = [ this.view.prefix, this.type ].join("-").replace("--", "-"), 
            c = a.getAttribute(b), this.marker = document.createComment(" rivets: " + this.type + " " + c + " "), 
            this.bound = !1, a.removeAttribute(b), a.parentNode.insertBefore(this.marker, a), 
            a.parentNode.removeChild(a)) : void 0;
        },
        unbind: function() {
            var a;
            return null != (a = this.nested) ? a.unbind() : void 0;
        },
        routine: function(b, c) {
            var d, e, f, g;
            if (!!c == !this.bound) {
                if (c) {
                    f = {}, g = this.view.models;
                    for (d in g) e = g[d], f[d] = e;
                    return (this.nested || (this.nested = new a.View(b, f, this.view.options()))).bind(), 
                    this.marker.parentNode.insertBefore(b, this.marker.nextSibling), this.bound = !0;
                }
                return b.parentNode.removeChild(b), this.nested.unbind(), this.bound = !1;
            }
        },
        update: function(a) {
            var b;
            return null != (b = this.nested) ? b.update(a) : void 0;
        }
    }, a["public"].binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function(b) {
            return a["public"].binders["if"].bind.call(this, b);
        },
        unbind: function() {
            return a["public"].binders["if"].unbind.call(this);
        },
        routine: function(b, c) {
            return a["public"].binders["if"].routine.call(this, b, !c);
        },
        update: function(b) {
            return a["public"].binders["if"].update.call(this, b);
        }
    }, a["public"].binders["on-*"] = {
        "function": !0,
        priority: 1e3,
        unbind: function(b) {
            return this.handler ? a.Util.unbindEvent(b, this.args[0], this.handler) : void 0;
        },
        routine: function(b, c) {
            return this.handler && a.Util.unbindEvent(b, this.args[0], this.handler), a.Util.bindEvent(b, this.args[0], this.handler = this.eventHandler(c));
        }
    }, a["public"].binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c, d, e, f;
            if (null == this.marker) b = [ this.view.prefix, this.type ].join("-").replace("--", "-"), 
            this.marker = document.createComment(" rivets: " + this.type + " "), this.iterated = [], 
            a.removeAttribute(b), a.parentNode.insertBefore(this.marker, a), a.parentNode.removeChild(a); else for (f = this.iterated, 
            d = 0, e = f.length; e > d; d++) c = f[d], c.bind();
        },
        unbind: function() {
            var a, b, c, d, e;
            if (null != this.iterated) {
                for (d = this.iterated, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.unbind());
                return e;
            }
        },
        routine: function(b, c) {
            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            if (j = this.args[0], c = c || [], this.iterated.length > c.length) for (u = Array(this.iterated.length - c.length), 
            o = 0, r = u.length; r > o; o++) f = u[o], n = this.iterated.pop(), n.unbind(), 
            this.marker.parentNode.removeChild(n.els[0]);
            for (g = p = 0, s = c.length; s > p; g = ++p) if (i = c[g], e = {
                index: g
            }, e[j] = i, null == this.iterated[g]) {
                v = this.view.models;
                for (h in v) i = v[h], null == e[h] && (e[h] = i);
                l = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker, 
                k = this.view.options(), k.preloadData = !0, m = b.cloneNode(!0), n = new a.View(m, e, k), 
                n.bind(), this.iterated.push(n), this.marker.parentNode.insertBefore(m, l.nextSibling);
            } else this.iterated[g].models[j] !== i && this.iterated[g].update(e);
            if ("OPTION" === b.nodeName) {
                for (w = this.view.bindings, x = [], q = 0, t = w.length; t > q; q++) d = w[q], 
                x.push(d.el === this.marker.parentNode && "value" === d.type ? d.sync() : void 0);
                return x;
            }
        },
        update: function(a) {
            var b, c, d, e, f, g, h, i;
            b = {};
            for (c in a) d = a[c], c !== this.args[0] && (b[c] = d);
            for (h = this.iterated, i = [], f = 0, g = h.length; g > f; f++) e = h[f], i.push(e.update(b));
            return i;
        }
    }, a["public"].binders["class-*"] = function(a, b) {
        var c;
        return c = " " + a.className + " ", !b == (-1 !== c.indexOf(" " + this.args[0] + " ")) ? a.className = b ? "" + a.className + " " + this.args[0] : c.replace(" " + this.args[0] + " ", " ").trim() : void 0;
    }, a["public"].binders["*"] = function(a, b) {
        return null != b ? a.setAttribute(this.type, b) : a.removeAttribute(this.type);
    }, a["public"].adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function(a) {
            var b, c, d;
            return a.hasOwnProperty(this.id) || (b = this.counter++, Object.defineProperty(a, this.id, {
                value: b
            })), (c = this.weakmap)[d = a[this.id]] || (c[d] = {
                callbacks: {}
            });
        },
        cleanupWeakReference: function(a, b) {
            return Object.keys(a.callbacks).length || a.pointers && Object.keys(a.pointers).length ? void 0 : delete this.weakmap[b];
        },
        stubFunction: function(a, b) {
            var c, d, e;
            return d = a[b], c = this.weakReference(a), e = this.weakmap, a[b] = function() {
                var b, f, g, h, i, j, k, l, m, n;
                h = d.apply(a, arguments), k = c.pointers;
                for (g in k) for (f = k[g], n = null != (l = null != (m = e[g]) ? m.callbacks[f] : void 0) ? l : [], 
                i = 0, j = n.length; j > i; i++) (b = n[i])();
                return h;
            };
        },
        observeMutations: function(a, b, c) {
            var d, e, f, g, h, j;
            if (Array.isArray(a)) {
                if (f = this.weakReference(a), null == f.pointers) for (f.pointers = {}, e = [ "push", "pop", "shift", "unshift", "sort", "reverse", "splice" ], 
                h = 0, j = e.length; j > h; h++) d = e[h], this.stubFunction(a, d);
                if (null == (g = f.pointers)[b] && (g[b] = []), i.call(f.pointers[b], c) < 0) return f.pointers[b].push(c);
            }
        },
        unobserveMutations: function(a, b, c) {
            var d, e, f;
            return Array.isArray(a) && null != a[this.id] && (e = this.weakmap[a[this.id]]) && (f = e.pointers[b]) ? ((d = f.indexOf(c)) >= 0 && f.splice(d, 1), 
            f.length || delete e.pointers[b], this.cleanupWeakReference(e, a[this.id])) : void 0;
        },
        observe: function(a, b, c) {
            var d, e, f;
            return d = this.weakReference(a).callbacks, null == d[b] && (d[b] = [], e = Object.getOwnPropertyDescriptor(a, b), 
            (null != e ? e.get : void 0) || (null != e ? e.set : void 0) || (f = a[b], Object.defineProperty(a, b, {
                enumerable: !0,
                get: function() {
                    return f;
                },
                set: function(e) {
                    return function(g) {
                        var h, j, k, l;
                        if (g !== f && (e.unobserveMutations(f, a[e.id], b), f = g, h = e.weakmap[a[e.id]])) {
                            if (d = h.callbacks, d[b]) for (l = d[b].slice(), j = 0, k = l.length; k > j; j++) c = l[j], 
                            i.call(d[b], c) >= 0 && c();
                            return e.observeMutations(g, a[e.id], b);
                        }
                    };
                }(this)
            }))), i.call(d[b], c) < 0 && d[b].push(c), this.observeMutations(a[b], a[this.id], b);
        },
        unobserve: function(a, b, c) {
            var d, e, f;
            return (f = this.weakmap[a[this.id]]) && (d = f.callbacks[b]) ? ((e = d.indexOf(c)) >= 0 && (d.splice(e, 1), 
            d.length || delete f.callbacks[b]), this.unobserveMutations(a[b], a[this.id], b), 
            this.cleanupWeakReference(f, a[this.id])) : void 0;
        },
        get: function(a, b) {
            return a[b];
        },
        set: function(a, b, c) {
            return a[b] = c;
        }
    }, a.factory = function(b) {
        return a.sightglass = b, a["public"]._ = a, a["public"];
    }, "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = a.factory(require("sightglass")) : "function" == typeof define && define.amd ? define([ "sightglass" ], function(b) {
        return this.rivets = a.factory(b);
    }) : this.rivets = a.factory(sightglass);
}.call(this), function() {
    var a, b, c, d, e, f, g = function(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    };
    b = function() {
        function a() {
            this.update = g(this.update, this);
        }
        return a.prototype.update = function(a) {
            var b, c, e;
            for (c in a) e = a[c], "items" !== c && (this[c] = e);
            return this.items = function() {
                var c, e, f, g;
                for (f = a.items, g = [], c = 0, e = f.length; e > c; c++) b = f[c], g.push(new d(b));
                return g;
            }();
        }, a;
    }(), d = function() {
        function a(a) {
            this.propertyArray = g(this.propertyArray, this), this.update = g(this.update, this), 
            this.update(a);
        }
        return a.prototype.update = function(a) {
            var b, d;
            for (b in a) d = a[b], "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties);
        }, a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties, d = [];
            for (a in c) b = c[a], d.push({
                name: a,
                value: b
            });
            return d;
        }, a;
    }(), c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null
        },
        cart: new b()
    }, c.init = function(a, b) {
        return null == b && (b = {}), c.configure(b), c.Utils.log("Initialising CartJS."), 
        c.cart.update(a), c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'), 
        c.Data.init()), c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'), 
        $(document).on("cart.requestStarted", function() {
            return $("body").addClass(c.settings.requestBodyClass);
        }), $(document).on("cart.requestComplete", function() {
            return $("body").removeClass(c.settings.requestBodyClass);
        })), c.Rivets.init();
    }, c.configure = function(a) {
        return null == a && (a = {}), c.Utils.extend(c.settings, a);
    }, null == window.console && (window.console = {}, window.console.log = function() {}), 
    c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments);
        },
        error: function() {
            return c.Utils.console(console.error, arguments);
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b), 
            b.unshift("[CartJS]:"), a.apply(console, b)) : void 0;
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"), f = {};
            for (d in a) e = a[d], f["" + b + "[" + d + "]"] = null != c ? c : e;
            return f;
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"), e = {};
            for (d in a) g = a[d], f = d.replace("" + b + "[", "").replace("]", ""), e[f] = null != c ? c : g;
            return e;
        },
        extend: function(a, b) {
            var c, d;
            for (c in b) d = b[c], a[c] = d;
            return a;
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a) return a;
            c = new a.constructor();
            for (b in a) c[b] = clone(a[b]);
            return c;
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a);
        },
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [ a ] : [];
        },
        formatMoney: function(a, b, d, e) {
            var f, g;
            return null == e && (e = ""), e || (e = c.settings.currency), null != window.Currency && e !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, e), 
            null != (null != (f = window.Currency) ? f.moneyFormats : void 0) && e in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[e][d])), 
            null != (null != (g = window.Shopify) ? g.formatMoney : void 0) ? Shopify.formatMoney(a, b) : a;
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? Shopify.Image.getSizedImageUrl(a, b) : a;
        }
    }, f = [], e = !1, c.Queue = {
        add: function(a, b, d) {
            var g;
            return null == d && (d = {}), g = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            }, d.updateCart && g.success.push(c.cart.update), f.push(g), e ? void 0 : (jQuery(document).trigger("cart.requestStarted", [ c.cart ]), 
            c.Queue.process());
        },
        process: function() {
            var a;
            return f.length ? (e = !0, a = f.shift(), a.complete = c.Queue.process, jQuery.ajax(a)) : (e = !1, 
            void jQuery(document).trigger("cart.requestComplete", [ c.cart ]));
        }
    }, c.Core = {
        getCart: function(a) {
            return null == a && (a = {}), a.type = "GET", a.updateCart = !0, c.Queue.add("/cart.js", {}, a);
        },
        addItem: function(a, b, d, e) {
            var f;
            return null == b && (b = 1), null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), 
            f.id = a, f.quantity = b, c.Queue.add("/cart/add.js", f, e), c.Core.getCart();
        },
        updateItem: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.line = a, 
            null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        removeItem: function(a, b) {
            return null == b && (b = {}), c.Core.updateItem(a, 0, {}, b);
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.id = a, 
            null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                updates: a
            }, b);
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}), d = {
                id: a,
                quantity: 0
            }, b.updateCart = !0, c.Queue.add("/cart/change.js", d, b);
        },
        clear: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/clear.js", {}, a);
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b;
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}), e = {}, e[a] = b, c.Core.setAttributes(e, d);
        },
        getAttributes: function() {
            return c.cart.attributes;
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b);
        },
        clearAttributes: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a);
        },
        getNote: function() {
            return c.cart.note;
        },
        setNote: function(a, b) {
            return null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                note: a
            }, b);
        }
    }, a = jQuery(document), c.Data = {
        init: function() {
            return c.Data.setEventListeners("on"), c.Data.render(null, c.cart);
        },
        destroy: function() {
            return c.Data.setEventListeners("off");
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add), a[b]("click", "[data-cart-remove]", c.Data.remove), 
            a[b]("click", "[data-cart-remove-id]", c.Data.removeById), a[b]("click", "[data-cart-update]", c.Data.update), 
            a[b]("click", "[data-cart-update-id]", c.Data.updateById), a[b]("click", "[data-cart-clear]", c.Data.clear), 
            a[b]("change", "[data-cart-toggle]", c.Data.toggle), a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute), 
            a[b]("submit", "[data-cart-submit]", c.Data.submit), a[b]("cart.requestComplete", c.Data.render);
        },
        add: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"));
        },
        remove: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.removeItem(b.attr("data-cart-remove"));
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.removeItemById(b.attr("data-cart-remove-id"));
        },
        update: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"));
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"));
        },
        clear: function(a) {
            return a.preventDefault(), c.Core.clear();
        },
        toggle: function() {
            var a, b;
            return a = jQuery(this), b = a.attr("data-cart-toggle"), a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b);
        },
        toggleAttribute: function() {
            var a, b;
            return a = jQuery(this), b = a.attr("data-cart-toggle-attribute"), c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "");
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(), b = jQuery(this).serializeArray(), d = void 0, f = void 0, 
            e = {}, jQuery.each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : e[b.name] = b.value;
            }), c.Core.addItem(d, f, c.Utils.unwrapKeys(e));
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            }, jQuery("[data-cart-render]").each(function() {
                var a;
                return a = jQuery(this), a.html(d[a.attr("data-cart-render")]);
            });
        }
    }, "rivets" in window ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews(), null != c.IE8 ? c.IE8.init() : void 0;
        },
        destroy: function() {
            return c.Rivets.unbindViews(), null != c.IE8 ? c.IE8.destroy() : void 0;
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."), c.Rivets.unbindViews(), 
            c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels), null != window.Currency && (c.Rivets.model.Currency = window.Currency), 
            jQuery("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind(jQuery(this), c.Rivets.model), c.Rivets.boundViews.push(a);
            });
        },
        unbindViews: function() {
            var a, b, d, e;
            for (e = c.Rivets.boundViews, b = 0, d = e.length; d > b; b++) a = e[b], a.unbind();
            return c.Rivets.boundViews = [];
        }
    }, rivets.formatters.eq = function(a, b) {
        return a === b;
    }, rivets.formatters.lt = function(a, b) {
        return b > a;
    }, rivets.formatters.gt = function(a, b) {
        return a > b;
    }, rivets.formatters.not = function(a) {
        return !a;
    }, rivets.formatters.empty = function(a) {
        return !a.length;
    }, rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b);
    }, rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b);
    }, rivets.formatters.prepend = function(a, b) {
        return b + a;
    }, rivets.formatters.append = function(a, b) {
        return a + b;
    }, rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b);
    }, rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b);
    }, rivets.formatters.productImageSize = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b);
    }) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    }, c.factory = function(a) {
        return a.init = c.init, a.configure = c.configure, a.cart = c.cart, a.settings = c.settings, 
        a.getCart = c.Core.getCart, a.addItem = c.Core.addItem, a.updateItem = c.Core.updateItem, 
        a.updateItemById = c.Core.updateItemById, a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById, 
        a.removeItem = c.Core.removeItem, a.removeItemById = c.Core.removeItemById, a.clear = c.Core.clear, 
        a.getAttribute = c.Core.getAttribute, a.setAttribute = c.Core.setAttribute, a.getAttributes = c.Core.getAttributes, 
        a.setAttributes = c.Core.setAttributes, a.clearAttributes = c.Core.clearAttributes, 
        a.getNote = c.Core.getNote, a.setNote = c.Core.setNote, a.render = c.Data.render;
    }, "object" == typeof exports ? c.factory(exports) : "function" == typeof define && define.amd ? define([ "exports" ], function(a) {
        return c.factory(this.CartJS = a), a;
    }) : c.factory(this.CartJS = {});
}.call(this);

(function($, app, undefined) {
    "use strict";
    app.Scroller = function(options) {
        var self = this, $scrollTopEl, $scrollEl, throttleID, noop = function() {}, pos = 0, $scrollToTopButton, scrollToTopButtonIsActive = false, callbacks = [], settings, defaults = {
            scrollTopEl: window,
            scrollEl: "body, html",
            anchorOffset: 0,
            anchorActiveClass: "anchor-active",
            activeClass: "active",
            threshold: 100,
            scrollToTopButton: "#scroll-to-top-button",
            throttle: 25,
            speed: 1,
            ease: $.easing.easeOutQuint ? "easeOutQuart" : "swing"
        };
        function scrollTo(targetPos, cb) {
            var dist = Math.abs(targetPos - pos), time = dist / settings.speed - Math.round(dist / settings.speed) / 2;
            $scrollEl.animate({
                scrollTop: targetPos
            }, time, settings.ease, cb || noop);
        }
        function toggleTopButton(pos) {
            if (pos > settings.threshold && !scrollToTopButtonIsActive) {
                requestAnimationFrame(function() {
                    $scrollToTopButton.addClass(settings.activeClass);
                });
                scrollToTopButtonIsActive = true;
            } else if (pos <= settings.threshold && scrollToTopButtonIsActive) {
                requestAnimationFrame(function() {
                    $scrollToTopButton.removeClass(settings.activeClass);
                });
                scrollToTopButtonIsActive = false;
            }
        }
        function scrollBy(i) {
            scrollTo(pos + i);
        }
        function scrollToTop(e) {
            e.preventDefault();
            scrollTo(0);
        }
        function onScroll() {
            var i, len;
            pos = $scrollTopEl.scrollTop();
            toggleTopButton(pos);
            for (i = 0, len = callbacks.length; i < len; i++) {
                callbacks[i](pos);
            }
            throttleID = null;
        }
        function throttleScroll(e) {
            if (!throttleID) {
                throttleID = setTimeout(onScroll, settings.throttle);
            }
        }
        function events() {
            $(window).on("scroll", throttleScroll);
            $scrollToTopButton.on("click", scrollToTop);
        }
        function els() {
            $scrollEl = $(settings.scrollEl);
            $scrollTopEl = $(settings.scrollTopEl);
            $scrollToTopButton = $(settings.scrollToTopButton);
        }
        function set(options) {
            return $.extend({}, defaults, options);
        }
        function initDirective() {
            $('a[href^="#"]:not(a[href="#"])').each(function() {
                self.addAnchor(this, true);
            });
        }
        function init() {
            settings = set(options);
            els();
            events();
            initDirective();
        }
        function scrollToAnchor(targetName) {
            var parsedTargetName, $target, targetPos;
            parsedTargetName = targetName.replace("#", "");
            if (parsedTargetName === "top") {
                targetPos = 0;
            } else {
                $target = $('a[name="' + parsedTargetName + '"], #' + parsedTargetName).eq(0);
                targetPos = Math.round($target.offset().top - settings.anchorOffset);
            }
            scrollTo(targetPos, function() {
                if ($target) {
                    $target.addClass(settings.anchorActiveClass);
                }
            });
        }
        function addHash(hash) {
            if (location.hash === hash) {
                scrollToAnchor(hash);
            }
        }
        this.scrollBy = function(i) {
            scrollBy(i);
        };
        this.scrollTo = function(i) {
            scrollTo(i);
        };
        this.addAnchor = function(selector, preventDefault) {
            var $el = $(selector), targetName;
            if (!$el.length) {
                return false;
            }
            targetName = $el[0].getAttribute("href");
            addHash(targetName);
            $el.on("click", function(e) {
                if (preventDefault) {
                    e.preventDefault();
                }
                scrollToAnchor(targetName);
            });
        };
        this.add = function(fn) {
            callbacks.push(fn);
        };
        init();
    };
})(window.jQuery, window.jasleyAshon = window.jasleyAshon || {});

jQuery(function($) {
    "use strict";
    var $mobileMenu = $(".main-nav--mobile");
    var $desktopMenu = $(".main-nav");
    var runOnInit = true;
    function disableMobileTabIndexes() {
        $mobileMenu.find("a").each(function() {
            var $this = $(this);
            $this.data("href", this.getAttribute("href"));
            this.removeAttribute("href");
        });
    }
    function enableMobileTabIndexes() {
        $mobileMenu.find("a").on("focus", function() {
            window.jasleyAshon.mobileMenu.open();
        }).each(function() {
            var $this = $(this);
            if ($this.data("href")) {
                this.setAttribute("href", $this.data("href"));
            }
        });
    }
    function disableDesktopTabIndexes() {
        $desktopMenu.find("[tabindex]").each(function() {
            var $this = $(this);
            $this.data("tabindex", this.getAttribute("tabindex"));
            this.setAttribute("tabindex", "-1");
        });
    }
    function enableDesktopTabIndexes() {
        $desktopMenu.find("[tabindex]").each(function() {
            var $this = $(this);
            if ($this.data("tabindex")) {
                this.setAttribute("tabindex", $this.data("tabindex"));
            }
        });
    }
    window.key("esc", function() {
        window.jasleyAshon.mobileMenu.close();
    });
    window.jasleyAshon.resizer.add(function(w, h) {
        if (w >= 1024) {
            enableDesktopTabIndexes();
            disableMobileTabIndexes();
        } else {
            disableDesktopTabIndexes();
            enableMobileTabIndexes();
        }
    }, runOnInit);
});

jQuery(function($) {
    "use strict";
    $("#currencies").chosen({
        disable_search: true,
        width: "100%"
    });
    $(".sortby-wrapper select").chosen({
        disable_search: true,
        width: "100%"
    });
});

jQuery(function($) {
    "use strict";
    var i, len, $html = $("html"), features = [ "ontouchstart" in document ? "has-touch" : "no-touch", navigator.userAgent.match(/ipad/gi) ? "ipad" : "not-ipad" ];
    $html.addClass(features.join(" "));
});

jQuery(function($) {
    "use strict";
    function readyFaders() {
        setTimeout(function() {
            $(".fader").addClass("ready");
        }, 500);
    }
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        readyFaders();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

(function() {
    "use strict";
    if (window.addEventListener) {
        document.addEventListener("DOMContentLoaded", function() {
            if (window.FastClick) {
                window.FastClick.attach(document.body);
            }
        }, false);
    }
})();

jQuery(function($) {
    "use strict";
    $("[data-flash]").flash();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        $("[data-flash]").flash();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    var hasTouch = "ontouchstart" in document, isIE8 = navigator.userAgent.match(/ie 8/gi);
    function onImageLoad() {
        var $this = $(this), $bg = $this.parent(".bg");
        if ($bg.length) {
            $bg.imgLiquid({
                onFinish: function() {
                    setTimeout(function() {
                        $bg.addClass("active");
                    }, 500);
                }
            });
        } else {
            $this.addClass("loaded");
        }
    }
    function loadImages() {
        this.src = this.getAttribute("data-src");
        onImageLoad.call(this);
    }
    $(".quickview img[data-src]").each(loadImages);
    if (!hasTouch && !isIE8 && $(document).height() > $(window).height() + 200) {
        $("img[data-src]").unveil(200, onImageLoad);
    } else {
        $("img[data-src]").each(loadImages);
    }
});

jQuery(function($) {
    "use strict";
    var $win = $(window), w = $win.width(), disableCurrent, actions = {};
    disableCurrent = {
        mobile: function() {
            return w < 768;
        },
        tablet: function() {
            return w >= 768 && w < 1024;
        },
        desktop: function() {
            return w >= 1024;
        }
    };
    function disable(target) {
        var layouts = target.getAttribute("data-disable"), layout, i, len, block = false;
        if (!layouts) {
            return block;
        }
        layouts = layouts.split(" ");
        for (i = 0, len = layouts.length; i < len; i++) {
            layout = layouts[i];
            if (disableCurrent[layout]()) {
                block = true;
                break;
            }
        }
        return block;
    }
    function showhide(att, action) {
        return function(e) {
            if (!disable(this)) {
                e.preventDefault();
                var $target = $(this.getAttribute(att));
                $target[action]("active");
            }
        };
    }
    actions = {
        show: function() {
            return showhide("data-show", "addClass");
        },
        hide: function() {
            return showhide("data-hide", "removeClass");
        }
    };
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
    function onResize(e) {
        w = $win.width();
    }
    function bindCallbacks(action) {
        var callback = actions[action]();
        $("[data-" + action + "]").each(function(i) {
            var $this = $(this);
            if (!$this.data("showHideIsBound")) {
                $this.data("showHideIsBound", true);
                $this.on("click", callback);
            }
        });
    }
    function initResize() {
        $win.on("resize", debounce(onResize, 100));
    }
    function initShowHide() {
        bindCallbacks("show");
        bindCallbacks("hide");
    }
    initResize();
    initShowHide();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {});
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    var ua = navigator.userAgent;
    if ("ontouchstart" in document || ua.match(/msie 8/gi) || ua.match(/msie 9/gi) || ua.match(/msie 10/gi) || ua.match(/msie 11/gi) || ua.match(/Trident/gi) && ua.match(/rv:11\.0/gi)) {
        return;
    }
    $.stellar({
        horizontalScrolling: false,
        verticalOffset: 40,
        parallaxBackgrounds: true,
        parallaxElements: false,
        responsive: true
    });
});

jQuery(function($) {
    "use strict";
    function initModalTriggers() {
        $("[data-modal-trigger]").magnificPopup({
            disableOn: 767,
            type: "inline",
            mainClass: "mfp-zoom-in mfp-default",
            removalDelay: 300,
            preloader: false,
            closeBtnInside: true,
            midClick: true,
            fixedContentPos: "auto",
            closeMarkup: '<button title="%title%" class="mfp-close x x--contrast">X</button>'
        });
    }
    initModalTriggers();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        initModalTriggers();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    $("[data-increment]").incrementer();
    $("[data-decrement]").decrementer();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        $("[data-increment]").incrementer();
        $("[data-decrement]").decrementer();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    function initSlicks() {
        $(".slick-init").each(function() {
            var $this = $(this), id = this.id, $nav = $('[data-slick-nav-for="#' + id + '"]');
            $this.slick({
                adaptiveHeight: true,
                arrows: true,
                dots: true,
                prevArrow: '<div class="prev-arrow"><i class="fa fa-chevron-left"></i></div>',
                nextArrow: '<div class="next-arrow"><i class="fa fa-chevron-right"></i></div>',
                responsive: [ {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                } ]
            });
            if (!$nav.length) {
                return false;
            }
            $nav.on("click", "a", function(e) {
                e.preventDefault();
                var i = $nav.find("li").index($(this).parent());
                $this.slick("slickGoTo", [ i ]);
            });
            $this.on("beforeChange", function(e, slick, currentSlide, nextSlide) {
                var $lis = $nav.find("li");
                $lis.find("a").removeClass("current").end().eq(nextSlide).find("a").addClass("current");
            });
        });
    }
    initSlicks();
});

jQuery(function($) {
    "use strict";
    $("[data-togglegroup]").toggleGroup();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new MutationObserver(function(mutations, observer) {
        $("[data-togglegroup]").toggleGroup();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    $("[data-toggle]").toggler();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        $("[data-toggle]").toggler();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

jQuery(function($) {
    "use strict";
    function initVideoTriggers() {
        $(".video-trigger").magnificPopup({
            disableOn: 767,
            type: "iframe",
            mainClass: "mfp-zoom-in mfp-video",
            removalDelay: 300,
            preloader: false,
            fixedContentPos: "auto"
        });
    }
    initVideoTriggers();
    if (!window.MutationObserver) {
        return false;
    }
    var observer = new window.MutationObserver(function(mutations, observer) {
        initVideoTriggers();
    });
    observer.observe(document, {
        subtree: true,
        childList: true
    });
});

(function($) {
    "use strict";
    function ClickOff($el, cb, except) {
        var self = this, el = $el[0], handler;
        function coCreateHandler(cb, except) {
            return function coBoundHandler(e) {
                var $target = $(e.target), $exceptEl = [], targetInExc = false;
                if (except) {
                    $exceptEl = typeof except === "string" ? $(except) : except;
                    targetInExc = $exceptEl.find(e.target).length;
                }
                if (e.target !== el && !$exceptEl.is(e.target) && !$target.closest($el).length && !targetInExc) {
                    cb(e);
                }
            };
        }
        function coBindHandler(handler) {
            $(document).on("click", handler);
        }
        function coUnbindHandler(handler) {
            $(document).off("click", handler);
        }
        function coUpdateHandler(cb, except) {
            if (handler) {
                coUnbindHandler(handler);
            }
            handler = coCreateHandler(cb, except);
            coBindHandler(handler);
        }
        function coDestroy() {}
        function coInit() {
            self.checkCallback(cb, except);
        }
        self.checkCallback = function(cb, except) {
            var isFn = typeof cb === "function", isFalsy = !cb;
            if (isFn) {
                coUpdateHandler(cb, except);
            } else if (isFalsy && handler) {
                coUnbindHandler(handler);
            }
        };
        coInit();
    }
    $.fn.clickoff = function(cb, except) {
        return this.each(function(i) {
            var $el = $(this);
            if (!$el.data("clickoff")) {
                if (typeof cb === "function") {
                    $el.data("clickoff", new ClickOff($el, cb, except));
                }
            } else {
                $el.data("clickoff").checkCallback(cb, except);
            }
            return $el;
        });
    };
})(jQuery);

(function($) {
    "use strict";
    var Flasher = function($el, options) {
        var settings = {}, defaults = {
            duration: .5,
            delay: .5
        };
        function normalize(str) {
            var num;
            num = parseFloat(str);
            num = num * 1e3;
            return num;
        }
        function set(options) {
            var dataDelay = $el[0].getAttribute("data-flash-delay"), dataDur = $el[0].getAttribute("data-flash-duration");
            if (dataDelay) {
                settings = $.extend({}, defaults, {
                    delay: dataDelay
                });
            }
            if (dataDur) {
                settings = $.extend({}, settings || defaults, {
                    duration: dataDur
                });
            }
            settings = options ? $.extend({}, settings || defaults, options) : $.extend({}, settings || defaults);
            settings.delay = normalize(settings.delay);
            settings.duration = normalize(settings.duration);
        }
        function init(options) {
            set(options);
            setTimeout(function() {
                $el.addClass("flash");
                setTimeout(function() {
                    $el.removeClass("flash");
                }, settings.duration);
            }, settings.delay);
        }
        init(options);
    };
    $.fn.flash = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("flash") && !destroy) {
                $this.data("flash", new Flasher($this, options));
            } else if ($this.data("flash") && destroy) {
                $this.data("flash").destroy();
            }
            return $this;
        });
    };
})(jQuery);

(function($, app, undefined) {
    "use strict";
    function Operator($el, action) {
        var el = $el[0], target, $target, max, min;
        var methods = {
            increment: function() {
                var curVal = parseInt(target.value, 10);
                var val = curVal + 1;
                if (max !== null) {
                    val = Math.min(val, max);
                }
                target.value = val;
                $target.trigger("change");
            },
            decrement: function() {
                var curVal = parseInt(target.value, 10);
                var val = Math.max(curVal - 1, min);
                target.value = val;
                $target.trigger("change");
            }
        };
        target = document.getElementById(el.getAttribute("data-" + action));
        $target = $(target);
        max = el.getAttribute("data-max");
        min = el.getAttribute("data-min");
        if (min === null) {
            min = 0;
        }
        if (max !== null) {
            max = parseInt(max, 10);
        }
        function onclick(e) {
            e.preventDefault();
            methods[action]();
        }
        this.destroy = function() {
            $el.off("click", onclick);
        };
        $el.off("click", onclick).on("click", onclick);
    }
    $.fn.incrementer = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("incrementer") && !destroy) {
                $this.data("incrementer", new Operator($this, "increment"));
            } else if ($this.data("incrementer") && destroy) {
                $this.data("incrementer").destroy();
                $this.removeData("incrementer");
            }
            return $this;
        });
    };
    $.fn.decrementer = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("decrementer") && !destroy) {
                $this.data("decrementer", new Operator($this, "decrement"));
            } else if ($this.data("decrementer") && destroy) {
                $this.data("decrementer").destroy();
                $this.removeData("decrementer");
            }
            return $this;
        });
    };
})(jQuery);

(function($) {
    "use strict";
    function ToggleGroup($el, options) {
        var self = this, initialHTML = $el[0].outerHTML, $toggles, $targets, settings, defaults = {
            activeClass: "active",
            toggles: "[data-togglegroup-toggle]",
            targets: "[data-togglegroup-target]",
            allowCloseAll: true,
            allowOpenAll: false
        };
        function tgClose(i) {
            if (i >= 0) {
                $toggles.eq(i).removeClass(settings.activeClass);
                $targets.eq(i).removeClass(settings.activeClass);
                return;
            }
            $toggles.removeClass(settings.activeClass);
            $targets.removeClass(settings.activeClass);
            if (settings.onClose) {
                settings.onClose();
            }
        }
        function tgOpen(i) {
            if (!settings.allowOpenAll) {
                tgClose();
            }
            $toggles.eq(i).addClass(settings.activeClass);
            $targets.eq(i).addClass(settings.activeClass);
            if (settings.onOpen) {
                settings.onOpen();
            }
        }
        function tgToggle(e) {
            var $this = $(this), i = $toggles.index(this), isOpen = $this.hasClass(settings.activeClass);
            e.preventDefault();
            if (settings.allowCloseAll) {
                if (isOpen) {
                    tgClose(i);
                } else {
                    tgOpen(i);
                }
            } else if (!isOpen) {
                tgOpen(i);
            }
        }
        function tgDestroy() {
            $el.replaceWith(initialHTML);
            $toggles.off("click", tgToggle);
            $el.removeData("toggleGroup");
        }
        function tgSet(options) {
            var dataConfig = $el[0].getAttribute("data-togglegroup-config"), config;
            if (dataConfig) {
                config = JSON.parse(dataConfig);
                settings = $.extend({}, defaults, config);
            }
            settings = options ? $.extend({}, settings || defaults, options) : $.extend({}, settings || defaults);
        }
        function tgInit(options) {
            tgSet(options);
            $toggles = $el.find(settings.toggles);
            $targets = $el.find(settings.targets);
            $toggles.on("click", tgToggle);
            if (!settings.allowCloseAll) {
                tgOpen(0);
            }
            self.destroy = tgDestroy;
        }
        tgInit(options);
    }
    $.fn.toggleGroup = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("toggleGroup") && !destroy) {
                $this.data("toggleGroup", new ToggleGroup($this, options));
            } else if ($this.data("toggleGroup") && destroy) {
                $this.data("toggleGroup").destroy();
            }
            return $this;
        });
    };
})(jQuery);

(function($) {
    "use strict";
    var render;
    if (window.requestAnimationFrame) {
        render = function(fn) {
            window.requestAnimationFrame(fn);
        };
    } else {
        render = function(fn) {
            fn();
        };
    }
    var Toggler = function($el, options) {
        var $target, $opposite, $close, $clickoff, el, settings = {}, defaults = {
            clickoff: false,
            activeClass: "active",
            manualBind: false
        };
        function close() {
            render(function() {
                $target.removeClass(settings.activeClass);
                $el.removeClass(settings.activeClass);
                if ($close) {
                    $close.removeClass(settings.activeClass);
                }
                if ($opposite) {
                    $opposite.addClass(settings.activeClass);
                }
                if (settings.clickoff) {}
                $el.trigger("close.toggler");
            });
        }
        function open() {
            render(function() {
                $target.addClass(settings.activeClass);
                $el.addClass(settings.activeClass);
                if ($close) {
                    $close.addClass(settings.activeClass);
                }
                if ($opposite) {
                    $opposite.removeClass(settings.activeClass);
                }
                if (settings.clickoff) {
                    $clickoff.clickoff(close, $el);
                }
                $el.trigger("open.toggler");
            });
        }
        function toggle(e) {
            if (settings.breakpoint && $(window).width() < settings.breakpoint) {
                return true;
            }
            e.preventDefault();
            if ($target.hasClass(settings.activeClass)) {
                close();
            } else {
                open();
            }
        }
        function events() {
            $el.off("click", toggle).on("click", toggle);
            if ($close) {
                $close.on("click", close);
            }
        }
        function els() {
            $target = $(settings.target);
            $opposite = settings.opposite ? $(settings.opposite) : false;
            if (settings.clickoff) {
                $clickoff = $(typeof settings.clickoff !== "function" ? settings.clickoff : settings.clickoff());
            }
            $close = settings.close ? $(settings.close) : false;
        }
        function set(options) {
            var atts, att, dataset, i, len;
            el = $el[0];
            var dataTarget = el.getAttribute("data-toggle"), dataInvert = el.getAttribute("data-toggle-invert"), dataClickoff = el.getAttribute("data-toggle-clickoff"), dataConfig = el.getAttribute("data-toggle-config"), dataBreakpoint = el.getAttribute("data-toggle-breakpoint"), config;
            if (dataTarget) {
                settings = $.extend({}, defaults, {
                    target: dataTarget
                });
            }
            if (dataInvert) {
                settings = $.extend({}, settings || defaults, {
                    opposite: dataInvert
                });
            }
            if (dataClickoff) {
                settings = $.extend({}, settings || defaults, {
                    clickoff: dataClickoff
                });
            }
            if (dataBreakpoint) {
                settings = $.extend({}, settings || defaults, {
                    breakpoint: parseInt(dataBreakpoint, 10)
                });
            }
            if (dataConfig) {
                config = JSON.parse(dataConfig);
                settings = $.extend({}, settings || defaults, config);
            }
            settings = options ? $.extend({}, settings || defaults, options) : $.extend({}, settings || defaults);
        }
        function init(options) {
            set(options);
            els();
            events();
        }
        init(options);
    };
    $.fn.toggler = function(options) {
        return this.each(function() {
            var destroy = options === false || options === "destroy", $this = $(this);
            if (!$this.data("toggler") && !destroy) {
                $this.data("toggler", new Toggler($this, options));
            } else if ($this.data("toggler") && destroy) {
                $this.data("toggler").destroy();
            }
            return $this;
        });
    };
})(jQuery);

(function($, app, undefined) {
    "use strict";
    app.init = function(options) {
        app.settings = options;
        app.resizer = new app.Resizer();
        app.scroller = new app.Scroller({
            scrollToTopButton: app.settings.scrollToTopButton
        });
        app.newsletterPopup = new app.NewsletterPopup(app.settings.newsletterPopup);
        app.galleries = {};
        $("[data-gallery]").each(function() {
            var id = this.getAttribute("data-gallery");
            app.galleries[id] = new app.Gallery($(this), options);
        });
        app.quickview = new app.Quickview(app.settings.quickview, app.Gallery, options);
        app.mobileMenu = new app.MobileMenu();
    };
})(jQuery, window.jasleyAshon = window.jasleyAshon || {});

(function() {
    var $, AbstractChosen, Chosen, SelectParser, _ref, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
        for (var key in parent) {
            if (__hasProp.call(parent, key)) child[key] = parent[key];
        }
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    SelectParser = function() {
        function SelectParser() {
            this.options_index = 0;
            this.parsed = [];
        }
        SelectParser.prototype.add_node = function(child) {
            if (child.nodeName.toUpperCase() === "OPTGROUP") {
                return this.add_group(child);
            } else {
                return this.add_option(child);
            }
        };
        SelectParser.prototype.add_group = function(group) {
            var group_position, option, _i, _len, _ref, _results;
            group_position = this.parsed.length;
            this.parsed.push({
                array_index: group_position,
                group: true,
                label: this.escapeExpression(group.label),
                children: 0,
                disabled: group.disabled,
                classes: group.className
            });
            _ref = group.childNodes;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                _results.push(this.add_option(option, group_position, group.disabled));
            }
            return _results;
        };
        SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
            if (option.nodeName.toUpperCase() === "OPTION") {
                if (option.text !== "") {
                    if (group_position != null) {
                        this.parsed[group_position].children += 1;
                    }
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        value: option.value,
                        text: option.text,
                        html: option.innerHTML,
                        selected: option.selected,
                        disabled: group_disabled === true ? group_disabled : option.disabled,
                        group_array_index: group_position,
                        classes: option.className,
                        style: option.style.cssText
                    });
                } else {
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                }
                return this.options_index += 1;
            }
        };
        SelectParser.prototype.escapeExpression = function(text) {
            var map, unsafe_chars;
            if (text == null || text === false) {
                return "";
            }
            if (!/[\&\<\>\"\'\`]/.test(text)) {
                return text;
            }
            map = {
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            };
            unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
            return text.replace(unsafe_chars, function(chr) {
                return map[chr] || "&amp;";
            });
        };
        return SelectParser;
    }();
    SelectParser.select_to_array = function(select) {
        var child, parser, _i, _len, _ref;
        parser = new SelectParser();
        _ref = select.childNodes;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            child = _ref[_i];
            parser.add_node(child);
        }
        return parser.parsed;
    };
    AbstractChosen = function() {
        function AbstractChosen(form_field, options) {
            this.form_field = form_field;
            this.options = options != null ? options : {};
            if (!AbstractChosen.browser_is_supported()) {
                return;
            }
            this.is_multiple = this.form_field.multiple;
            this.set_default_text();
            this.set_default_values();
            this.setup();
            this.set_up_html();
            this.register_observers();
            this.on_ready();
        }
        AbstractChosen.prototype.set_default_values = function() {
            var _this = this;
            this.click_test_action = function(evt) {
                return _this.test_active_click(evt);
            };
            this.activate_action = function(evt) {
                return _this.activate_field(evt);
            };
            this.active_field = false;
            this.mouse_on_container = false;
            this.results_showing = false;
            this.result_highlighted = null;
            this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
            this.disable_search_threshold = this.options.disable_search_threshold || 0;
            this.disable_search = this.options.disable_search || false;
            this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
            this.group_search = this.options.group_search != null ? this.options.group_search : true;
            this.search_contains = this.options.search_contains || false;
            this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
            this.max_selected_options = this.options.max_selected_options || Infinity;
            this.inherit_select_classes = this.options.inherit_select_classes || false;
            this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
            return this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
        };
        AbstractChosen.prototype.set_default_text = function() {
            if (this.form_field.getAttribute("data-placeholder")) {
                this.default_text = this.form_field.getAttribute("data-placeholder");
            } else if (this.is_multiple) {
                this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
            } else {
                this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
            }
            return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };
        AbstractChosen.prototype.mouse_enter = function() {
            return this.mouse_on_container = true;
        };
        AbstractChosen.prototype.mouse_leave = function() {
            return this.mouse_on_container = false;
        };
        AbstractChosen.prototype.input_focus = function(evt) {
            var _this = this;
            if (this.is_multiple) {
                if (!this.active_field) {
                    return setTimeout(function() {
                        return _this.container_mousedown();
                    }, 50);
                }
            } else {
                if (!this.active_field) {
                    return this.activate_field();
                }
            }
        };
        AbstractChosen.prototype.input_blur = function(evt) {
            var _this = this;
            if (!this.mouse_on_container) {
                this.active_field = false;
                return setTimeout(function() {
                    return _this.blur_test();
                }, 100);
            }
        };
        AbstractChosen.prototype.results_option_build = function(options) {
            var content, data, _i, _len, _ref;
            content = "";
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                data = _ref[_i];
                if (data.group) {
                    content += this.result_add_group(data);
                } else {
                    content += this.result_add_option(data);
                }
                if (options != null ? options.first : void 0) {
                    if (data.selected && this.is_multiple) {
                        this.choice_build(data);
                    } else if (data.selected && !this.is_multiple) {
                        this.single_set_selected_text(data.text);
                    }
                }
            }
            return content;
        };
        AbstractChosen.prototype.result_add_option = function(option) {
            var classes, option_el;
            if (!option.search_match) {
                return "";
            }
            if (!this.include_option_in_results(option)) {
                return "";
            }
            classes = [];
            if (!option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("active-result");
            }
            if (option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("disabled-result");
            }
            if (option.selected) {
                classes.push("result-selected");
            }
            if (option.group_array_index != null) {
                classes.push("group-option");
            }
            if (option.classes !== "") {
                classes.push(option.classes);
            }
            option_el = document.createElement("li");
            option_el.className = classes.join(" ");
            option_el.style.cssText = option.style;
            option_el.setAttribute("data-option-array-index", option.array_index);
            option_el.innerHTML = option.search_text;
            return this.outerHTML(option_el);
        };
        AbstractChosen.prototype.result_add_group = function(group) {
            var classes, group_el;
            if (!(group.search_match || group.group_match)) {
                return "";
            }
            if (!(group.active_options > 0)) {
                return "";
            }
            classes = [];
            classes.push("group-result");
            if (group.classes) {
                classes.push(group.classes);
            }
            group_el = document.createElement("li");
            group_el.className = classes.join(" ");
            group_el.innerHTML = group.search_text;
            return this.outerHTML(group_el);
        };
        AbstractChosen.prototype.results_update_field = function() {
            this.set_default_text();
            if (!this.is_multiple) {
                this.results_reset_cleanup();
            }
            this.result_clear_highlight();
            this.results_build();
            if (this.results_showing) {
                return this.winnow_results();
            }
        };
        AbstractChosen.prototype.reset_single_select_options = function() {
            var result, _i, _len, _ref, _results;
            _ref = this.results_data;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                result = _ref[_i];
                if (result.selected) {
                    _results.push(result.selected = false);
                } else {
                    _results.push(void 0);
                }
            }
            return _results;
        };
        AbstractChosen.prototype.results_toggle = function() {
            if (this.results_showing) {
                return this.results_hide();
            } else {
                return this.results_show();
            }
        };
        AbstractChosen.prototype.results_search = function(evt) {
            if (this.results_showing) {
                return this.winnow_results();
            } else {
                return this.results_show();
            }
        };
        AbstractChosen.prototype.winnow_results = function() {
            var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
            this.no_results_clear();
            results = 0;
            searchText = this.get_search_text();
            escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            zregex = new RegExp(escapedSearchText, "i");
            regex = this.get_search_regex(escapedSearchText);
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                option.search_match = false;
                results_group = null;
                if (this.include_option_in_results(option)) {
                    if (option.group) {
                        option.group_match = false;
                        option.active_options = 0;
                    }
                    if (option.group_array_index != null && this.results_data[option.group_array_index]) {
                        results_group = this.results_data[option.group_array_index];
                        if (results_group.active_options === 0 && results_group.search_match) {
                            results += 1;
                        }
                        results_group.active_options += 1;
                    }
                    if (!(option.group && !this.group_search)) {
                        option.search_text = option.group ? option.label : option.text;
                        option.search_match = this.search_string_match(option.search_text, regex);
                        if (option.search_match && !option.group) {
                            results += 1;
                        }
                        if (option.search_match) {
                            if (searchText.length) {
                                startpos = option.search_text.search(zregex);
                                text = option.search_text.substr(0, startpos + searchText.length) + "</em>" + option.search_text.substr(startpos + searchText.length);
                                option.search_text = text.substr(0, startpos) + "<em>" + text.substr(startpos);
                            }
                            if (results_group != null) {
                                results_group.group_match = true;
                            }
                        } else if (option.group_array_index != null && this.results_data[option.group_array_index].search_match) {
                            option.search_match = true;
                        }
                    }
                }
            }
            this.result_clear_highlight();
            if (results < 1 && searchText.length) {
                this.update_results_content("");
                return this.no_results(searchText);
            } else {
                this.update_results_content(this.results_option_build());
                return this.winnow_results_set_highlight();
            }
        };
        AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
            var regex_anchor;
            regex_anchor = this.search_contains ? "" : "^";
            return new RegExp(regex_anchor + escaped_search_string, "i");
        };
        AbstractChosen.prototype.search_string_match = function(search_string, regex) {
            var part, parts, _i, _len;
            if (regex.test(search_string)) {
                return true;
            } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
                parts = search_string.replace(/\[|\]/g, "").split(" ");
                if (parts.length) {
                    for (_i = 0, _len = parts.length; _i < _len; _i++) {
                        part = parts[_i];
                        if (regex.test(part)) {
                            return true;
                        }
                    }
                }
            }
        };
        AbstractChosen.prototype.choices_count = function() {
            var option, _i, _len, _ref;
            if (this.selected_option_count != null) {
                return this.selected_option_count;
            }
            this.selected_option_count = 0;
            _ref = this.form_field.options;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                if (option.selected) {
                    this.selected_option_count += 1;
                }
            }
            return this.selected_option_count;
        };
        AbstractChosen.prototype.choices_click = function(evt) {
            evt.preventDefault();
            if (!(this.results_showing || this.is_disabled)) {
                return this.results_show();
            }
        };
        AbstractChosen.prototype.keyup_checker = function(evt) {
            var stroke, _ref;
            stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
            this.search_field_scale();
            switch (stroke) {
              case 8:
                if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                    return this.keydown_backstroke();
                } else if (!this.pending_backstroke) {
                    this.result_clear_highlight();
                    return this.results_search();
                }
                break;

              case 13:
                evt.preventDefault();
                if (this.results_showing) {
                    return this.result_select(evt);
                }
                break;

              case 27:
                if (this.results_showing) {
                    this.results_hide();
                }
                return true;

              case 9:
              case 38:
              case 40:
              case 16:
              case 91:
              case 17:
                break;

              default:
                return this.results_search();
            }
        };
        AbstractChosen.prototype.clipboard_event_checker = function(evt) {
            var _this = this;
            return setTimeout(function() {
                return _this.results_search();
            }, 50);
        };
        AbstractChosen.prototype.container_width = function() {
            if (this.options.width != null) {
                return this.options.width;
            } else {
                return "" + this.form_field.offsetWidth + "px";
            }
        };
        AbstractChosen.prototype.include_option_in_results = function(option) {
            if (this.is_multiple && (!this.display_selected_options && option.selected)) {
                return false;
            }
            if (!this.display_disabled_options && option.disabled) {
                return false;
            }
            if (option.empty) {
                return false;
            }
            return true;
        };
        AbstractChosen.prototype.search_results_touchstart = function(evt) {
            this.touch_started = true;
            return this.search_results_mouseover(evt);
        };
        AbstractChosen.prototype.search_results_touchmove = function(evt) {
            this.touch_started = false;
            return this.search_results_mouseout(evt);
        };
        AbstractChosen.prototype.search_results_touchend = function(evt) {
            if (this.touch_started) {
                return this.search_results_mouseup(evt);
            }
        };
        AbstractChosen.prototype.outerHTML = function(element) {
            var tmp;
            if (element.outerHTML) {
                return element.outerHTML;
            }
            tmp = document.createElement("div");
            tmp.appendChild(element);
            return tmp.innerHTML;
        };
        AbstractChosen.browser_is_supported = function() {
            if (window.navigator.appName === "Microsoft Internet Explorer") {
                return document.documentMode >= 8;
            }
            if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
                return false;
            }
            if (/Android/i.test(window.navigator.userAgent)) {
                if (/Mobile/i.test(window.navigator.userAgent)) {
                    return false;
                }
            }
            return true;
        };
        AbstractChosen.default_multiple_text = "Select Some Options";
        AbstractChosen.default_single_text = "Select an Option";
        AbstractChosen.default_no_result_text = "No results match";
        return AbstractChosen;
    }();
    $ = jQuery;
    $.fn.extend({
        chosen: function(options) {
            if (!AbstractChosen.browser_is_supported()) {
                return this;
            }
            return this.each(function(input_field) {
                var $this, chosen;
                $this = $(this);
                chosen = $this.data("chosen");
                if (options === "destroy" && chosen instanceof Chosen) {
                    chosen.destroy();
                } else if (!(chosen instanceof Chosen)) {
                    $this.data("chosen", new Chosen(this, options));
                }
            });
        }
    });
    Chosen = function(_super) {
        __extends(Chosen, _super);
        function Chosen() {
            _ref = Chosen.__super__.constructor.apply(this, arguments);
            return _ref;
        }
        Chosen.prototype.setup = function() {
            this.form_field_jq = $(this.form_field);
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
        };
        Chosen.prototype.set_up_html = function() {
            var container_classes, container_props;
            container_classes = [ "chosen-container" ];
            container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
            if (this.inherit_select_classes && this.form_field.className) {
                container_classes.push(this.form_field.className);
            }
            if (this.is_rtl) {
                container_classes.push("chosen-rtl");
            }
            container_props = {
                "class": container_classes.join(" "),
                style: "width: " + this.container_width() + ";",
                title: this.form_field.title
            };
            if (this.form_field.id.length) {
                container_props.id = this.form_field.id.replace(/[^\w]/g, "_") + "_chosen";
            }
            this.container = $("<div />", container_props);
            if (this.is_multiple) {
                this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
            } else {
                this.container.html('<a class="chosen-single chosen-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
            }
            this.form_field_jq.hide().after(this.container);
            this.dropdown = this.container.find("div.chosen-drop").first();
            this.search_field = this.container.find("input").first();
            this.search_results = this.container.find("ul.chosen-results").first();
            this.search_field_scale();
            this.search_no_results = this.container.find("li.no-results").first();
            if (this.is_multiple) {
                this.search_choices = this.container.find("ul.chosen-choices").first();
                this.search_container = this.container.find("li.search-field").first();
            } else {
                this.search_container = this.container.find("div.chosen-search").first();
                this.selected_item = this.container.find(".chosen-single").first();
            }
            this.results_build();
            this.set_tab_index();
            return this.set_label_behavior();
        };
        Chosen.prototype.on_ready = function() {
            return this.form_field_jq.trigger("chosen:ready", {
                chosen: this
            });
        };
        Chosen.prototype.register_observers = function() {
            var _this = this;
            this.container.bind("touchstart.chosen", function(evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind("touchend.chosen", function(evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind("mousedown.chosen", function(evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind("mouseup.chosen", function(evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind("mouseenter.chosen", function(evt) {
                _this.mouse_enter(evt);
            });
            this.container.bind("mouseleave.chosen", function(evt) {
                _this.mouse_leave(evt);
            });
            this.search_results.bind("mouseup.chosen", function(evt) {
                _this.search_results_mouseup(evt);
            });
            this.search_results.bind("mouseover.chosen", function(evt) {
                _this.search_results_mouseover(evt);
            });
            this.search_results.bind("mouseout.chosen", function(evt) {
                _this.search_results_mouseout(evt);
            });
            this.search_results.bind("mousewheel.chosen DOMMouseScroll.chosen", function(evt) {
                _this.search_results_mousewheel(evt);
            });
            this.search_results.bind("touchstart.chosen", function(evt) {
                _this.search_results_touchstart(evt);
            });
            this.search_results.bind("touchmove.chosen", function(evt) {
                _this.search_results_touchmove(evt);
            });
            this.search_results.bind("touchend.chosen", function(evt) {
                _this.search_results_touchend(evt);
            });
            this.form_field_jq.bind("chosen:updated.chosen", function(evt) {
                _this.results_update_field(evt);
            });
            this.form_field_jq.bind("chosen:activate.chosen", function(evt) {
                _this.activate_field(evt);
            });
            this.form_field_jq.bind("chosen:open.chosen", function(evt) {
                _this.container_mousedown(evt);
            });
            this.form_field_jq.bind("chosen:close.chosen", function(evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind("blur.chosen", function(evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind("keyup.chosen", function(evt) {
                _this.keyup_checker(evt);
            });
            this.search_field.bind("keydown.chosen", function(evt) {
                _this.keydown_checker(evt);
            });
            this.search_field.bind("focus.chosen", function(evt) {
                _this.input_focus(evt);
            });
            this.search_field.bind("cut.chosen", function(evt) {
                _this.clipboard_event_checker(evt);
            });
            this.search_field.bind("paste.chosen", function(evt) {
                _this.clipboard_event_checker(evt);
            });
            if (this.is_multiple) {
                return this.search_choices.bind("click.chosen", function(evt) {
                    _this.choices_click(evt);
                });
            } else {
                return this.container.bind("click.chosen", function(evt) {
                    evt.preventDefault();
                });
            }
        };
        Chosen.prototype.destroy = function() {
            $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
            if (this.search_field[0].tabIndex) {
                this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
            }
            this.container.remove();
            this.form_field_jq.removeData("chosen");
            return this.form_field_jq.show();
        };
        Chosen.prototype.search_field_disabled = function() {
            this.is_disabled = this.form_field_jq[0].disabled;
            if (this.is_disabled) {
                this.container.addClass("chosen-disabled");
                this.search_field[0].disabled = true;
                if (!this.is_multiple) {
                    this.selected_item.unbind("focus.chosen", this.activate_action);
                }
                return this.close_field();
            } else {
                this.container.removeClass("chosen-disabled");
                this.search_field[0].disabled = false;
                if (!this.is_multiple) {
                    return this.selected_item.bind("focus.chosen", this.activate_action);
                }
            }
        };
        Chosen.prototype.container_mousedown = function(evt) {
            if (!this.is_disabled) {
                if (evt && evt.type === "mousedown" && !this.results_showing) {
                    evt.preventDefault();
                }
                if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
                    if (!this.active_field) {
                        if (this.is_multiple) {
                            this.search_field.val("");
                        }
                        $(this.container[0].ownerDocument).bind("click.chosen", this.click_test_action);
                        this.results_show();
                    } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chosen-single").length)) {
                        evt.preventDefault();
                        this.results_toggle();
                    }
                    return this.activate_field();
                }
            }
        };
        Chosen.prototype.container_mouseup = function(evt) {
            if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
                return this.results_reset(evt);
            }
        };
        Chosen.prototype.search_results_mousewheel = function(evt) {
            var delta;
            if (evt.originalEvent) {
                delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
            }
            if (delta != null) {
                evt.preventDefault();
                if (evt.type === "DOMMouseScroll") {
                    delta = delta * 40;
                }
                return this.search_results.scrollTop(delta + this.search_results.scrollTop());
            }
        };
        Chosen.prototype.blur_test = function(evt) {
            if (!this.active_field && this.container.hasClass("chosen-container-active")) {
                return this.close_field();
            }
        };
        Chosen.prototype.close_field = function() {
            $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
            this.active_field = false;
            this.results_hide();
            this.container.removeClass("chosen-container-active");
            this.clear_backstroke();
            this.show_search_field_default();
            return this.search_field_scale();
        };
        Chosen.prototype.activate_field = function() {
            this.container.addClass("chosen-container-active");
            this.active_field = true;
            this.search_field.val(this.search_field.val());
            return this.search_field.focus();
        };
        Chosen.prototype.test_active_click = function(evt) {
            var active_container;
            active_container = $(evt.target).closest(".chosen-container");
            if (active_container.length && this.container[0] === active_container[0]) {
                return this.active_field = true;
            } else {
                return this.close_field();
            }
        };
        Chosen.prototype.results_build = function() {
            this.parsing = true;
            this.selected_option_count = null;
            this.results_data = SelectParser.select_to_array(this.form_field);
            if (this.is_multiple) {
                this.search_choices.find("li.search-choice").remove();
            } else if (!this.is_multiple) {
                this.single_set_selected_text();
                if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
                    this.search_field[0].readOnly = true;
                    this.container.addClass("chosen-container-single-nosearch");
                } else {
                    this.search_field[0].readOnly = false;
                    this.container.removeClass("chosen-container-single-nosearch");
                }
            }
            this.update_results_content(this.results_option_build({
                first: true
            }));
            this.search_field_disabled();
            this.show_search_field_default();
            this.search_field_scale();
            return this.parsing = false;
        };
        Chosen.prototype.result_do_highlight = function(el) {
            var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
            if (el.length) {
                this.result_clear_highlight();
                this.result_highlight = el;
                this.result_highlight.addClass("highlighted");
                maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
                visible_top = this.search_results.scrollTop();
                visible_bottom = maxHeight + visible_top;
                high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                high_bottom = high_top + this.result_highlight.outerHeight();
                if (high_bottom >= visible_bottom) {
                    return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
                } else if (high_top < visible_top) {
                    return this.search_results.scrollTop(high_top);
                }
            }
        };
        Chosen.prototype.result_clear_highlight = function() {
            if (this.result_highlight) {
                this.result_highlight.removeClass("highlighted");
            }
            return this.result_highlight = null;
        };
        Chosen.prototype.results_show = function() {
            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen: this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.search_field.val());
            this.winnow_results();
            return this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen: this
            });
        };
        Chosen.prototype.update_results_content = function(content) {
            return this.search_results.html(content);
        };
        Chosen.prototype.results_hide = function() {
            if (this.results_showing) {
                this.result_clear_highlight();
                this.container.removeClass("chosen-with-drop");
                this.form_field_jq.trigger("chosen:hiding_dropdown", {
                    chosen: this
                });
            }
            return this.results_showing = false;
        };
        Chosen.prototype.set_tab_index = function(el) {
            var ti;
            if (this.form_field.tabIndex) {
                ti = this.form_field.tabIndex;
                this.form_field.tabIndex = -1;
                return this.search_field[0].tabIndex = ti;
            }
        };
        Chosen.prototype.set_label_behavior = function() {
            var _this = this;
            this.form_field_label = this.form_field_jq.parents("label");
            if (!this.form_field_label.length && this.form_field.id.length) {
                this.form_field_label = $("label[for='" + this.form_field.id + "']");
            }
            if (this.form_field_label.length > 0) {
                return this.form_field_label.bind("click.chosen", function(evt) {
                    if (_this.is_multiple) {
                        return _this.container_mousedown(evt);
                    } else {
                        return _this.activate_field();
                    }
                });
            }
        };
        Chosen.prototype.show_search_field_default = function() {
            if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
                this.search_field.val(this.default_text);
                return this.search_field.addClass("default");
            } else {
                this.search_field.val("");
                return this.search_field.removeClass("default");
            }
        };
        Chosen.prototype.search_results_mouseup = function(evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target.length) {
                this.result_highlight = target;
                this.result_select(evt);
                return this.search_field.focus();
            }
        };
        Chosen.prototype.search_results_mouseover = function(evt) {
            var target;
            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target) {
                return this.result_do_highlight(target);
            }
        };
        Chosen.prototype.search_results_mouseout = function(evt) {
            if ($(evt.target).hasClass("active-result" || $(evt.target).parents(".active-result").first())) {
                return this.result_clear_highlight();
            }
        };
        Chosen.prototype.choice_build = function(item) {
            var choice, close_link, _this = this;
            choice = $("<li />", {
                "class": "search-choice"
            }).html("<span>" + item.html + "</span>");
            if (item.disabled) {
                choice.addClass("search-choice-disabled");
            } else {
                close_link = $("<a />", {
                    "class": "search-choice-close",
                    "data-option-array-index": item.array_index
                });
                close_link.bind("click.chosen", function(evt) {
                    return _this.choice_destroy_link_click(evt);
                });
                choice.append(close_link);
            }
            return this.search_container.before(choice);
        };
        Chosen.prototype.choice_destroy_link_click = function(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (!this.is_disabled) {
                return this.choice_destroy($(evt.target));
            }
        };
        Chosen.prototype.choice_destroy = function(link) {
            if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
                this.show_search_field_default();
                if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
                    this.results_hide();
                }
                link.parents("li").first().remove();
                return this.search_field_scale();
            }
        };
        Chosen.prototype.results_reset = function() {
            this.reset_single_select_options();
            this.form_field.options[0].selected = true;
            this.single_set_selected_text();
            this.show_search_field_default();
            this.results_reset_cleanup();
            this.form_field_jq.trigger("change");
            if (this.active_field) {
                return this.results_hide();
            }
        };
        Chosen.prototype.results_reset_cleanup = function() {
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.selected_item.find("abbr").remove();
        };
        Chosen.prototype.result_select = function(evt) {
            var high, item;
            if (this.result_highlight) {
                high = this.result_highlight;
                this.result_clear_highlight();
                if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                    this.form_field_jq.trigger("chosen:maxselected", {
                        chosen: this
                    });
                    return false;
                }
                if (this.is_multiple) {
                    high.removeClass("active-result");
                } else {
                    this.reset_single_select_options();
                }
                item = this.results_data[high[0].getAttribute("data-option-array-index")];
                item.selected = true;
                this.form_field.options[item.options_index].selected = true;
                this.selected_option_count = null;
                if (this.is_multiple) {
                    this.choice_build(item);
                } else {
                    this.single_set_selected_text(item.text);
                }
                if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
                    this.results_hide();
                }
                this.search_field.val("");
                if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
                    this.form_field_jq.trigger("change", {
                        selected: this.form_field.options[item.options_index].value
                    });
                }
                this.current_selectedIndex = this.form_field.selectedIndex;
                return this.search_field_scale();
            }
        };
        Chosen.prototype.single_set_selected_text = function(text) {
            if (text == null) {
                text = this.default_text;
            }
            if (text === this.default_text) {
                this.selected_item.addClass("chosen-default");
            } else {
                this.single_deselect_control_build();
                this.selected_item.removeClass("chosen-default");
            }
            return this.selected_item.find("span").text(text);
        };
        Chosen.prototype.result_deselect = function(pos) {
            var result_data;
            result_data = this.results_data[pos];
            if (!this.form_field.options[result_data.options_index].disabled) {
                result_data.selected = false;
                this.form_field.options[result_data.options_index].selected = false;
                this.selected_option_count = null;
                this.result_clear_highlight();
                if (this.results_showing) {
                    this.winnow_results();
                }
                this.form_field_jq.trigger("change", {
                    deselected: this.form_field.options[result_data.options_index].value
                });
                this.search_field_scale();
                return true;
            } else {
                return false;
            }
        };
        Chosen.prototype.single_deselect_control_build = function() {
            if (!this.allow_single_deselect) {
                return;
            }
            if (!this.selected_item.find("abbr").length) {
                this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>');
            }
            return this.selected_item.addClass("chosen-single-with-deselect");
        };
        Chosen.prototype.get_search_text = function() {
            if (this.search_field.val() === this.default_text) {
                return "";
            } else {
                return $("<div/>").text($.trim(this.search_field.val())).html();
            }
        };
        Chosen.prototype.winnow_results_set_highlight = function() {
            var do_high, selected_results;
            selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
            if (do_high != null) {
                return this.result_do_highlight(do_high);
            }
        };
        Chosen.prototype.no_results = function(terms) {
            var no_results_html;
            no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
            no_results_html.find("span").first().html(terms);
            this.search_results.append(no_results_html);
            return this.form_field_jq.trigger("chosen:no_results", {
                chosen: this
            });
        };
        Chosen.prototype.no_results_clear = function() {
            return this.search_results.find(".no-results").remove();
        };
        Chosen.prototype.keydown_arrow = function() {
            var next_sib;
            if (this.results_showing && this.result_highlight) {
                next_sib = this.result_highlight.nextAll("li.active-result").first();
                if (next_sib) {
                    return this.result_do_highlight(next_sib);
                }
            } else {
                return this.results_show();
            }
        };
        Chosen.prototype.keyup_arrow = function() {
            var prev_sibs;
            if (!this.results_showing && !this.is_multiple) {
                return this.results_show();
            } else if (this.result_highlight) {
                prev_sibs = this.result_highlight.prevAll("li.active-result");
                if (prev_sibs.length) {
                    return this.result_do_highlight(prev_sibs.first());
                } else {
                    if (this.choices_count() > 0) {
                        this.results_hide();
                    }
                    return this.result_clear_highlight();
                }
            }
        };
        Chosen.prototype.keydown_backstroke = function() {
            var next_available_destroy;
            if (this.pending_backstroke) {
                this.choice_destroy(this.pending_backstroke.find("a").first());
                return this.clear_backstroke();
            } else {
                next_available_destroy = this.search_container.siblings("li.search-choice").last();
                if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
                    this.pending_backstroke = next_available_destroy;
                    if (this.single_backstroke_delete) {
                        return this.keydown_backstroke();
                    } else {
                        return this.pending_backstroke.addClass("search-choice-focus");
                    }
                }
            }
        };
        Chosen.prototype.clear_backstroke = function() {
            if (this.pending_backstroke) {
                this.pending_backstroke.removeClass("search-choice-focus");
            }
            return this.pending_backstroke = null;
        };
        Chosen.prototype.keydown_checker = function(evt) {
            var stroke, _ref1;
            stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
            this.search_field_scale();
            if (stroke !== 8 && this.pending_backstroke) {
                this.clear_backstroke();
            }
            switch (stroke) {
              case 8:
                this.backstroke_length = this.search_field.val().length;
                break;

              case 9:
                if (this.results_showing && !this.is_multiple) {
                    this.result_select(evt);
                }
                this.mouse_on_container = false;
                break;

              case 13:
                if (this.results_showing) {
                    evt.preventDefault();
                }
                break;

              case 32:
                if (this.disable_search) {
                    evt.preventDefault();
                }
                break;

              case 38:
                evt.preventDefault();
                this.keyup_arrow();
                break;

              case 40:
                evt.preventDefault();
                this.keydown_arrow();
                break;
            }
        };
        Chosen.prototype.search_field_scale = function() {
            var div, f_width, h, style, style_block, styles, w, _i, _len;
            if (this.is_multiple) {
                h = 0;
                w = 0;
                style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
                styles = [ "font-size", "font-style", "font-weight", "font-family", "line-height", "text-transform", "letter-spacing" ];
                for (_i = 0, _len = styles.length; _i < _len; _i++) {
                    style = styles[_i];
                    style_block += style + ":" + this.search_field.css(style) + ";";
                }
                div = $("<div />", {
                    style: style_block
                });
                div.text(this.search_field.val());
                $("body").append(div);
                w = div.width() + 25;
                div.remove();
                f_width = this.container.outerWidth();
                if (w > f_width - 10) {
                    w = f_width - 10;
                }
                return this.search_field.css({
                    width: w + "px"
                });
            }
        };
        return Chosen;
    }(AbstractChosen);
}).call(this);

function FastClick(layer, options) {
    "use strict";
    var oldOnClick;
    options = options || {};
    this.trackingClick = false;
    this.trackingClickStart = 0;
    this.targetElement = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.lastTouchIdentifier = 0;
    this.touchBoundary = options.touchBoundary || 10;
    this.layer = layer;
    this.tapDelay = options.tapDelay || 200;
    if (FastClick.notNeeded(layer)) {
        return;
    }
    function bind(method, context) {
        return function() {
            return method.apply(context, arguments);
        };
    }
    var methods = [ "onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel" ];
    var context = this;
    for (var i = 0, l = methods.length; i < l; i++) {
        context[methods[i]] = bind(context[methods[i]], context);
    }
    if (deviceIsAndroid) {
        layer.addEventListener("mouseover", this.onMouse, true);
        layer.addEventListener("mousedown", this.onMouse, true);
        layer.addEventListener("mouseup", this.onMouse, true);
    }
    layer.addEventListener("click", this.onClick, true);
    layer.addEventListener("touchstart", this.onTouchStart, false);
    layer.addEventListener("touchmove", this.onTouchMove, false);
    layer.addEventListener("touchend", this.onTouchEnd, false);
    layer.addEventListener("touchcancel", this.onTouchCancel, false);
    if (!Event.prototype.stopImmediatePropagation) {
        layer.removeEventListener = function(type, callback, capture) {
            var rmv = Node.prototype.removeEventListener;
            if (type === "click") {
                rmv.call(layer, type, callback.hijacked || callback, capture);
            } else {
                rmv.call(layer, type, callback, capture);
            }
        };
        layer.addEventListener = function(type, callback, capture) {
            var adv = Node.prototype.addEventListener;
            if (type === "click") {
                adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
                    if (!event.propagationStopped) {
                        callback(event);
                    }
                }), capture);
            } else {
                adv.call(layer, type, callback, capture);
            }
        };
    }
    if (typeof layer.onclick === "function") {
        oldOnClick = layer.onclick;
        layer.addEventListener("click", function(event) {
            oldOnClick(event);
        }, false);
        layer.onclick = null;
    }
}

var deviceIsAndroid = navigator.userAgent.indexOf("Android") > 0;

var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent);

var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

var deviceIsIOSWithBadTarget = deviceIsIOS && /OS ([6-9]|\d{2})_\d/.test(navigator.userAgent);

var deviceIsBlackBerry10 = navigator.userAgent.indexOf("BB10") > 0;

FastClick.prototype.needsClick = function(target) {
    "use strict";
    switch (target.nodeName.toLowerCase()) {
      case "button":
      case "select":
      case "textarea":
        if (target.disabled) {
            return true;
        }
        break;

      case "input":
        if (deviceIsIOS && target.type === "file" || target.disabled) {
            return true;
        }
        break;

      case "label":
      case "video":
        return true;
    }
    return /\bneedsclick\b/.test(target.className);
};

FastClick.prototype.needsFocus = function(target) {
    "use strict";
    switch (target.nodeName.toLowerCase()) {
      case "textarea":
        return true;

      case "select":
        return !deviceIsAndroid;

      case "input":
        switch (target.type) {
          case "button":
          case "checkbox":
          case "file":
          case "image":
          case "radio":
          case "submit":
            return false;
        }
        return !target.disabled && !target.readOnly;

      default:
        return /\bneedsfocus\b/.test(target.className);
    }
};

FastClick.prototype.sendClick = function(targetElement, event) {
    "use strict";
    var clickEvent, touch;
    if (document.activeElement && document.activeElement !== targetElement) {
        document.activeElement.blur();
    }
    touch = event.changedTouches[0];
    clickEvent = document.createEvent("MouseEvents");
    clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
    clickEvent.forwardedTouchEvent = true;
    targetElement.dispatchEvent(clickEvent);
};

FastClick.prototype.determineEventType = function(targetElement) {
    "use strict";
    if (deviceIsAndroid && targetElement.tagName.toLowerCase() === "select") {
        return "mousedown";
    }
    return "click";
};

FastClick.prototype.focus = function(targetElement) {
    "use strict";
    var length;
    if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf("date") !== 0 && targetElement.type !== "time") {
        length = targetElement.value.length;
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
};

FastClick.prototype.updateScrollParent = function(targetElement) {
    "use strict";
    var scrollParent, parentElement;
    scrollParent = targetElement.fastClickScrollParent;
    if (!scrollParent || !scrollParent.contains(targetElement)) {
        parentElement = targetElement;
        do {
            if (parentElement.scrollHeight > parentElement.offsetHeight) {
                scrollParent = parentElement;
                targetElement.fastClickScrollParent = parentElement;
                break;
            }
            parentElement = parentElement.parentElement;
        } while (parentElement);
    }
    if (scrollParent) {
        scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
    }
};

FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
    "use strict";
    if (eventTarget.nodeType === Node.TEXT_NODE) {
        return eventTarget.parentNode;
    }
    return eventTarget;
};

FastClick.prototype.onTouchStart = function(event) {
    "use strict";
    var targetElement, touch, selection;
    if (event.targetTouches.length > 1) {
        return true;
    }
    targetElement = this.getTargetElementFromEventTarget(event.target);
    touch = event.targetTouches[0];
    if (deviceIsIOS) {
        selection = window.getSelection();
        if (selection.rangeCount && !selection.isCollapsed) {
            return true;
        }
        if (!deviceIsIOS4) {
            if (touch.identifier === this.lastTouchIdentifier) {
                event.preventDefault();
                return false;
            }
            this.lastTouchIdentifier = touch.identifier;
            this.updateScrollParent(targetElement);
        }
    }
    this.trackingClick = true;
    this.trackingClickStart = event.timeStamp;
    this.targetElement = targetElement;
    this.touchStartX = touch.pageX;
    this.touchStartY = touch.pageY;
    if (event.timeStamp - this.lastClickTime < this.tapDelay) {
        event.preventDefault();
    }
    return true;
};

FastClick.prototype.touchHasMoved = function(event) {
    "use strict";
    var touch = event.changedTouches[0], boundary = this.touchBoundary;
    if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
        return true;
    }
    return false;
};

FastClick.prototype.onTouchMove = function(event) {
    "use strict";
    if (!this.trackingClick) {
        return true;
    }
    if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
        this.trackingClick = false;
        this.targetElement = null;
    }
    return true;
};

FastClick.prototype.findControl = function(labelElement) {
    "use strict";
    if (labelElement.control !== undefined) {
        return labelElement.control;
    }
    if (labelElement.htmlFor) {
        return document.getElementById(labelElement.htmlFor);
    }
    return labelElement.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
};

FastClick.prototype.onTouchEnd = function(event) {
    "use strict";
    var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
    if (!this.trackingClick) {
        return true;
    }
    if (event.timeStamp - this.lastClickTime < this.tapDelay) {
        this.cancelNextClick = true;
        return true;
    }
    this.cancelNextClick = false;
    this.lastClickTime = event.timeStamp;
    trackingClickStart = this.trackingClickStart;
    this.trackingClick = false;
    this.trackingClickStart = 0;
    if (deviceIsIOSWithBadTarget) {
        touch = event.changedTouches[0];
        targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
        targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
    }
    targetTagName = targetElement.tagName.toLowerCase();
    if (targetTagName === "label") {
        forElement = this.findControl(targetElement);
        if (forElement) {
            this.focus(targetElement);
            if (deviceIsAndroid) {
                return false;
            }
            targetElement = forElement;
        }
    } else if (this.needsFocus(targetElement)) {
        if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === "input") {
            this.targetElement = null;
            return false;
        }
        this.focus(targetElement);
        this.sendClick(targetElement, event);
        if (!deviceIsIOS || targetTagName !== "select") {
            this.targetElement = null;
            event.preventDefault();
        }
        return false;
    }
    if (deviceIsIOS && !deviceIsIOS4) {
        scrollParent = targetElement.fastClickScrollParent;
        if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
            return true;
        }
    }
    if (!this.needsClick(targetElement)) {
        event.preventDefault();
        this.sendClick(targetElement, event);
    }
    return false;
};

FastClick.prototype.onTouchCancel = function() {
    "use strict";
    this.trackingClick = false;
    this.targetElement = null;
};

FastClick.prototype.onMouse = function(event) {
    "use strict";
    if (!this.targetElement) {
        return true;
    }
    if (event.forwardedTouchEvent) {
        return true;
    }
    if (!event.cancelable) {
        return true;
    }
    if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        } else {
            event.propagationStopped = true;
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
    }
    return true;
};

FastClick.prototype.onClick = function(event) {
    "use strict";
    var permitted;
    if (this.trackingClick) {
        this.targetElement = null;
        this.trackingClick = false;
        return true;
    }
    if (event.target.type === "submit" && event.detail === 0) {
        return true;
    }
    permitted = this.onMouse(event);
    if (!permitted) {
        this.targetElement = null;
    }
    return permitted;
};

FastClick.prototype.destroy = function() {
    "use strict";
    var layer = this.layer;
    if (deviceIsAndroid) {
        layer.removeEventListener("mouseover", this.onMouse, true);
        layer.removeEventListener("mousedown", this.onMouse, true);
        layer.removeEventListener("mouseup", this.onMouse, true);
    }
    layer.removeEventListener("click", this.onClick, true);
    layer.removeEventListener("touchstart", this.onTouchStart, false);
    layer.removeEventListener("touchmove", this.onTouchMove, false);
    layer.removeEventListener("touchend", this.onTouchEnd, false);
    layer.removeEventListener("touchcancel", this.onTouchCancel, false);
};

FastClick.notNeeded = function(layer) {
    "use strict";
    var metaViewport;
    var chromeVersion;
    var blackberryVersion;
    if (typeof window.ontouchstart === "undefined") {
        return true;
    }
    chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [ , 0 ])[1];
    if (chromeVersion) {
        if (deviceIsAndroid) {
            metaViewport = document.querySelector("meta[name=viewport]");
            if (metaViewport) {
                if (metaViewport.content.indexOf("user-scalable=no") !== -1) {
                    return true;
                }
                if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
                    return true;
                }
            }
        } else {
            return true;
        }
    }
    if (deviceIsBlackBerry10) {
        blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
        if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
            metaViewport = document.querySelector("meta[name=viewport]");
            if (metaViewport) {
                if (metaViewport.content.indexOf("user-scalable=no") !== -1) {
                    return true;
                }
                if (document.documentElement.scrollWidth <= window.outerWidth) {
                    return true;
                }
            }
        }
    }
    if (layer.style.msTouchAction === "none") {
        return true;
    }
    return false;
};

FastClick.attach = function(layer, options) {
    "use strict";
    return new FastClick(layer, options);
};

if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
    define(function() {
        "use strict";
        return FastClick;
    });
} else if (typeof module !== "undefined" && module.exports) {
    module.exports = FastClick.attach;
    module.exports.FastClick = FastClick;
} else {
    window.FastClick = FastClick;
}

var imgLiquid = imgLiquid || {
    VER: "0.9.944"
};

imgLiquid.bgs_Available = false;

imgLiquid.bgs_CheckRunned = false;

imgLiquid.injectCss = ".imgLiquid img {visibility:hidden}";

(function($) {
    function checkBgsIsavailable() {
        if (imgLiquid.bgs_CheckRunned) return; else imgLiquid.bgs_CheckRunned = true;
        var spanBgs = $('<span style="background-size:cover" />');
        $("body").append(spanBgs);
        !function() {
            var bgs_Check = spanBgs[0];
            if (!bgs_Check || !window.getComputedStyle) return;
            var compStyle = window.getComputedStyle(bgs_Check, null);
            if (!compStyle || !compStyle.backgroundSize) return;
            imgLiquid.bgs_Available = compStyle.backgroundSize === "cover";
        }();
        spanBgs.remove();
    }
    $.fn.extend({
        imgLiquid: function(options) {
            this.defaults = {
                fill: true,
                verticalAlign: "center",
                horizontalAlign: "center",
                useBackgroundSize: true,
                useDataHtmlAttr: true,
                responsive: true,
                delay: 0,
                fadeInTime: 0,
                removeBoxBackground: true,
                hardPixels: true,
                responsiveCheckTime: 500,
                timecheckvisibility: 500,
                onStart: null,
                onFinish: null,
                onItemStart: null,
                onItemFinish: null,
                onItemError: null
            };
            checkBgsIsavailable();
            var imgLiquidRoot = this;
            this.options = options;
            this.settings = $.extend({}, this.defaults, this.options);
            if (this.settings.onStart) this.settings.onStart();
            return this.each(function($i) {
                var settings = imgLiquidRoot.settings, $imgBoxCont = $(this), $img = $("img:first", $imgBoxCont);
                if (!$img.length) {
                    onError();
                    return;
                }
                if (!$img.data("imgLiquid_settings")) {
                    settings = $.extend({}, imgLiquidRoot.settings, getSettingsOverwrite());
                } else {
                    $imgBoxCont.removeClass("imgLiquid_error").removeClass("imgLiquid_ready");
                    settings = $.extend({}, $img.data("imgLiquid_settings"), imgLiquidRoot.options);
                }
                $img.data("imgLiquid_settings", settings);
                if (settings.onItemStart) settings.onItemStart($i, $imgBoxCont, $img);
                if (imgLiquid.bgs_Available && settings.useBackgroundSize) processBgSize(); else processOldMethod();
                function processBgSize() {
                    if ($imgBoxCont.css("background-image").indexOf(encodeURI($img.attr("src"))) === -1) {
                        $imgBoxCont.css({
                            "background-image": 'url("' + encodeURI($img.attr("src")) + '")' + ', url("http://placehold.it/2100x1400?text=Aspect+Ratio+3+:+2")'
                        });
                    }
                    $imgBoxCont.css({
                        "background-size": settings.fill ? "cover" : "contain",
                        "background-repeat": "no-repeat"
                    });
                    $("img", $imgBoxCont).css({
                        display: "none"
                    });
                    if (settings.onItemFinish) settings.onItemFinish($i, $imgBoxCont, $img);
                    $imgBoxCont.addClass("imgLiquid_bgSize");
                    $imgBoxCont.addClass("imgLiquid_ready");
                    checkFinish();
                }
                function processOldMethod() {
                    if ($img.data("oldSrc") && $img.data("oldSrc") !== $img.attr("src")) {
                        var $imgCopy = $img.clone().removeAttr("style");
                        $imgCopy.data("imgLiquid_settings", $img.data("imgLiquid_settings"));
                        $img.parent().prepend($imgCopy);
                        $img.remove();
                        $img = $imgCopy;
                        $img[0].width = 0;
                        setTimeout(processOldMethod, 10);
                        return;
                    }
                    if ($img.data("imgLiquid_oldProcessed")) {
                        makeOldProcess();
                        return;
                    }
                    $img.data("imgLiquid_oldProcessed", false);
                    $img.data("oldSrc", $img.attr("src"));
                    $("img:not(:first)", $imgBoxCont).css("display", "none");
                    $imgBoxCont.css({
                        overflow: "hidden"
                    });
                    $img.fadeTo(0, 0).removeAttr("width").removeAttr("height").css({
                        visibility: "visible",
                        "max-width": "none",
                        "max-height": "none",
                        width: "auto",
                        height: "auto",
                        display: "block"
                    });
                    $img.on("error", onError);
                    $img[0].onerror = onError;
                    function onLoad() {
                        if ($img.data("imgLiquid_error") || $img.data("imgLiquid_loaded") || $img.data("imgLiquid_oldProcessed")) return;
                        if ($imgBoxCont.is(":visible") && $img[0].complete && $img[0].width > 0 && $img[0].height > 0) {
                            $img.data("imgLiquid_loaded", true);
                            setTimeout(makeOldProcess, $i * settings.delay);
                        } else {
                            setTimeout(onLoad, settings.timecheckvisibility);
                        }
                    }
                    onLoad();
                    checkResponsive();
                }
                function checkResponsive() {
                    if (!settings.responsive && !$img.data("imgLiquid_oldProcessed")) return;
                    if (!$img.data("imgLiquid_settings")) return;
                    settings = $img.data("imgLiquid_settings");
                    $imgBoxCont.actualSize = $imgBoxCont.get(0).offsetWidth + $imgBoxCont.get(0).offsetHeight / 1e4;
                    if ($imgBoxCont.sizeOld && $imgBoxCont.actualSize !== $imgBoxCont.sizeOld) makeOldProcess();
                    $imgBoxCont.sizeOld = $imgBoxCont.actualSize;
                    setTimeout(checkResponsive, settings.responsiveCheckTime);
                }
                function onError() {
                    $img.data("imgLiquid_error", true);
                    $imgBoxCont.addClass("imgLiquid_error");
                    if (settings.onItemError) settings.onItemError($i, $imgBoxCont, $img);
                    checkFinish();
                }
                function getSettingsOverwrite() {
                    var SettingsOverwrite = {};
                    if (imgLiquidRoot.settings.useDataHtmlAttr) {
                        var dif = $imgBoxCont.attr("data-imgLiquid-fill"), ha = $imgBoxCont.attr("data-imgLiquid-horizontalAlign"), va = $imgBoxCont.attr("data-imgLiquid-verticalAlign");
                        if (dif === "true" || dif === "false") SettingsOverwrite.fill = Boolean(dif === "true");
                        if (ha !== undefined && (ha === "left" || ha === "center" || ha === "right" || ha.indexOf("%") !== -1)) SettingsOverwrite.horizontalAlign = ha;
                        if (va !== undefined && (va === "top" || va === "bottom" || va === "center" || va.indexOf("%") !== -1)) SettingsOverwrite.verticalAlign = va;
                    }
                    if (imgLiquid.isIE && imgLiquidRoot.settings.ieFadeInDisabled) SettingsOverwrite.fadeInTime = 0;
                    return SettingsOverwrite;
                }
                function makeOldProcess() {
                    var w, h, wn, hn, ha, va, hdif, vdif, margT = 0, margL = 0, $imgCW = $imgBoxCont.width(), $imgCH = $imgBoxCont.height();
                    if ($img.data("owidth") === undefined) $img.data("owidth", $img[0].width);
                    if ($img.data("oheight") === undefined) $img.data("oheight", $img[0].height);
                    if (settings.fill === $imgCW / $imgCH >= $img.data("owidth") / $img.data("oheight")) {
                        w = "100%";
                        h = "auto";
                        wn = Math.floor($imgCW);
                        hn = Math.floor($imgCW * ($img.data("oheight") / $img.data("owidth")));
                    } else {
                        w = "auto";
                        h = "100%";
                        wn = Math.floor($imgCH * ($img.data("owidth") / $img.data("oheight")));
                        hn = Math.floor($imgCH);
                    }
                    ha = settings.horizontalAlign.toLowerCase();
                    hdif = $imgCW - wn;
                    if (ha === "left") margL = 0;
                    if (ha === "center") margL = hdif * .5;
                    if (ha === "right") margL = hdif;
                    if (ha.indexOf("%") !== -1) {
                        ha = parseInt(ha.replace("%", ""), 10);
                        if (ha > 0) margL = hdif * ha * .01;
                    }
                    va = settings.verticalAlign.toLowerCase();
                    vdif = $imgCH - hn;
                    if (va === "left") margT = 0;
                    if (va === "center") margT = vdif * .5;
                    if (va === "bottom") margT = vdif;
                    if (va.indexOf("%") !== -1) {
                        va = parseInt(va.replace("%", ""), 10);
                        if (va > 0) margT = vdif * va * .01;
                    }
                    if (settings.hardPixels) {
                        w = wn;
                        h = hn;
                    }
                    $img.css({
                        width: w,
                        height: h,
                        "margin-left": Math.floor(margL),
                        "margin-top": Math.floor(margT)
                    });
                    if (!$img.data("imgLiquid_oldProcessed")) {
                        $img.fadeTo(settings.fadeInTime, 1);
                        $img.data("imgLiquid_oldProcessed", true);
                        if (settings.removeBoxBackground) $imgBoxCont.css("background-image", "none");
                        $imgBoxCont.addClass("imgLiquid_nobgSize");
                        $imgBoxCont.addClass("imgLiquid_ready");
                    }
                    if (settings.onItemFinish) settings.onItemFinish($i, $imgBoxCont, $img);
                    checkFinish();
                }
                function checkFinish() {
                    if ($i === imgLiquidRoot.length - 1) if (imgLiquidRoot.settings.onFinish) imgLiquidRoot.settings.onFinish();
                }
            });
        }
    });
})(jQuery);

!function() {
    var css = imgLiquid.injectCss, head = document.getElementsByTagName("head")[0], style = document.createElement("style");
    style.type = "text/css";
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
}();

(function(factory) {
    if (typeof define === "function" && define.amd) {
        define([ "jquery" ], factory);
    } else if (typeof exports === "object") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(function($) {
    var pluses = /\+/g;
    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }
    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }
    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }
    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
        }
        try {
            s = decodeURIComponent(s.replace(pluses, " "));
            return config.json ? JSON.parse(s) : s;
        } catch (e) {}
    }
    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }
    var config = $.cookie = function(key, value, options) {
        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);
            if (typeof options.expires === "number") {
                var days = options.expires, t = options.expires = new Date();
                t.setMilliseconds(t.getMilliseconds() + days * 864e5);
            }
            return document.cookie = [ encode(key), "=", stringifyCookieValue(value), options.expires ? "; expires=" + options.expires.toUTCString() : "", options.path ? "; path=" + options.path : "", options.domain ? "; domain=" + options.domain : "", options.secure ? "; secure" : "" ].join("");
        }
        var result = key ? undefined : {}, cookies = document.cookie ? document.cookie.split("; ") : [], i = 0, l = cookies.length;
        for (;i < l; i++) {
            var parts = cookies[i].split("="), name = decode(parts.shift()), cookie = parts.join("=");
            if (key === name) {
                result = read(cookie, value);
                break;
            }
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }
        return result;
    };
    config.defaults = {};
    $.removeCookie = function(key, options) {
        $.cookie(key, "", $.extend({}, options, {
            expires: -1
        }));
        return !$.cookie(key);
    };
});

(function($, undefined) {
    "use strict";
    $.fn.delayedHover = function(inCallback, outCallback, delay) {
        this.each(function(i, el) {
            var timer, $el = $(el);
            $el.on("mouseenter", function() {
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                } else {
                    timer = setTimeout(function() {
                        timer = null;
                        inCallback.call(el);
                    }, delay);
                }
            }).on("mouseleave", function() {
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                } else {
                    timer = setTimeout(function() {
                        timer = null;
                        outCallback.call(el);
                    }, delay);
                }
            });
        });
    };
})(jQuery);

jQuery.easing["jswing"] = jQuery.easing["swing"];

jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    swing: function(x, t, b, c, d) {
        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
    },
    easeInQuad: function(x, t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    easeOutQuad: function(x, t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutQuad: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    easeInCubic: function(x, t, b, c, d) {
        return c * (t /= d) * t * t + b;
    },
    easeOutCubic: function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOutCubic: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    },
    easeInQuart: function(x, t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
    },
    easeOutQuart: function(x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOutQuart: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    },
    easeInQuint: function(x, t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    easeOutQuint: function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOutQuint: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    easeInSine: function(x, t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOutSine: function(x, t, b, c, d) {
        return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOutSine: function(x, t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    },
    easeInExpo: function(x, t, b, c, d) {
        return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    },
    easeOutExpo: function(x, t, b, c, d) {
        return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOutExpo: function(x, t, b, c, d) {
        if (t == 0) return b;
        if (t == d) return b + c;
        if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    easeInCirc: function(x, t, b, c, d) {
        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    },
    easeOutCirc: function(x, t, b, c, d) {
        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    },
    easeInOutCirc: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    },
    easeInElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOutElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    easeInOutElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d / 2) == 2) return b + c;
        if (!p) p = d * (.3 * 1.5);
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
    },
    easeInBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    easeOutBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    easeInOutBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    easeInBounce: function(x, t, b, c, d) {
        return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
    },
    easeOutBounce: function(x, t, b, c, d) {
        if ((t /= d) < 1 / 2.75) {
            return c * (7.5625 * t * t) + b;
        } else if (t < 2 / 2.75) {
            return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
        } else if (t < 2.5 / 2.75) {
            return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
        } else {
            return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
        }
    },
    easeInOutBounce: function(x, t, b, c, d) {
        if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
        return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
    }
});

(function(factory) {
    if (typeof define === "function" && define.amd) {
        define([ "jquery" ], factory);
    } else if (typeof exports === "object") {
        factory(require("jquery"));
    } else {
        factory(window.jQuery || window.Zepto);
    }
})(function($) {
    var CLOSE_EVENT = "Close", BEFORE_CLOSE_EVENT = "BeforeClose", AFTER_CLOSE_EVENT = "AfterClose", BEFORE_APPEND_EVENT = "BeforeAppend", MARKUP_PARSE_EVENT = "MarkupParse", OPEN_EVENT = "Open", CHANGE_EVENT = "Change", NS = "mfp", EVENT_NS = "." + NS, READY_CLASS = "mfp-ready", REMOVING_CLASS = "mfp-removing", PREVENT_CLOSE_CLASS = "mfp-prevent-close";
    var mfp, MagnificPopup = function() {}, _isJQ = !!window.jQuery, _prevStatus, _window = $(window), _document, _prevContentType, _wrapClasses, _currPopupType;
    var _mfpOn = function(name, f) {
        mfp.ev.on(NS + name + EVENT_NS, f);
    }, _getEl = function(className, appendTo, html, raw) {
        var el = document.createElement("div");
        el.className = "mfp-" + className;
        if (html) {
            el.innerHTML = html;
        }
        if (!raw) {
            el = $(el);
            if (appendTo) {
                el.appendTo(appendTo);
            }
        } else if (appendTo) {
            appendTo.appendChild(el);
        }
        return el;
    }, _mfpTrigger = function(e, data) {
        mfp.ev.triggerHandler(NS + e, data);
        if (mfp.st.callbacks) {
            e = e.charAt(0).toLowerCase() + e.slice(1);
            if (mfp.st.callbacks[e]) {
                mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [ data ]);
            }
        }
    }, _getCloseBtn = function(type) {
        if (type !== _currPopupType || !mfp.currTemplate.closeBtn) {
            mfp.currTemplate.closeBtn = $(mfp.st.closeMarkup.replace("%title%", mfp.st.tClose));
            _currPopupType = type;
        }
        return mfp.currTemplate.closeBtn;
    }, _checkInstance = function() {
        if (!$.magnificPopup.instance) {
            mfp = new MagnificPopup();
            mfp.init();
            $.magnificPopup.instance = mfp;
        }
    }, supportsTransitions = function() {
        var s = document.createElement("p").style, v = [ "ms", "O", "Moz", "Webkit" ];
        if (s["transition"] !== undefined) {
            return true;
        }
        while (v.length) {
            if (v.pop() + "Transition" in s) {
                return true;
            }
        }
        return false;
    };
    MagnificPopup.prototype = {
        constructor: MagnificPopup,
        init: function() {
            var appVersion = navigator.appVersion;
            mfp.isIE7 = appVersion.indexOf("MSIE 7.") !== -1;
            mfp.isIE8 = appVersion.indexOf("MSIE 8.") !== -1;
            mfp.isLowIE = mfp.isIE7 || mfp.isIE8;
            mfp.isAndroid = /android/gi.test(appVersion);
            mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion);
            mfp.supportsTransition = supportsTransitions();
            mfp.probablyMobile = mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent);
            _document = $(document);
            mfp.popupsCache = {};
        },
        open: function(data) {
            var i;
            if (data.isObj === false) {
                mfp.items = data.items.toArray();
                mfp.index = 0;
                var items = data.items, item;
                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    if (item.parsed) {
                        item = item.el[0];
                    }
                    if (item === data.el[0]) {
                        mfp.index = i;
                        break;
                    }
                }
            } else {
                mfp.items = $.isArray(data.items) ? data.items : [ data.items ];
                mfp.index = data.index || 0;
            }
            if (mfp.isOpen) {
                mfp.updateItemHTML();
                return;
            }
            mfp.types = [];
            _wrapClasses = "";
            if (data.mainEl && data.mainEl.length) {
                mfp.ev = data.mainEl.eq(0);
            } else {
                mfp.ev = _document;
            }
            if (data.key) {
                if (!mfp.popupsCache[data.key]) {
                    mfp.popupsCache[data.key] = {};
                }
                mfp.currTemplate = mfp.popupsCache[data.key];
            } else {
                mfp.currTemplate = {};
            }
            mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data);
            mfp.fixedContentPos = mfp.st.fixedContentPos === "auto" ? !mfp.probablyMobile : mfp.st.fixedContentPos;
            if (mfp.st.modal) {
                mfp.st.closeOnContentClick = false;
                mfp.st.closeOnBgClick = false;
                mfp.st.showCloseBtn = false;
                mfp.st.enableEscapeKey = false;
            }
            if (!mfp.bgOverlay) {
                mfp.bgOverlay = _getEl("bg").on("click" + EVENT_NS, function() {
                    mfp.close();
                });
                mfp.wrap = _getEl("wrap").attr("tabindex", -1).on("click" + EVENT_NS, function(e) {
                    if (mfp._checkIfClose(e.target)) {
                        mfp.close();
                    }
                });
                mfp.container = _getEl("container", mfp.wrap);
            }
            mfp.contentContainer = _getEl("content");
            if (mfp.st.preloader) {
                mfp.preloader = _getEl("preloader", mfp.container, mfp.st.tLoading);
            }
            var modules = $.magnificPopup.modules;
            for (i = 0; i < modules.length; i++) {
                var n = modules[i];
                n = n.charAt(0).toUpperCase() + n.slice(1);
                mfp["init" + n].call(mfp);
            }
            _mfpTrigger("BeforeOpen");
            if (mfp.st.showCloseBtn) {
                if (!mfp.st.closeBtnInside) {
                    mfp.wrap.append(_getCloseBtn());
                } else {
                    _mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
                        values.close_replaceWith = _getCloseBtn(item.type);
                    });
                    _wrapClasses += " mfp-close-btn-in";
                }
            }
            if (mfp.st.alignTop) {
                _wrapClasses += " mfp-align-top";
            }
            if (mfp.fixedContentPos) {
                mfp.wrap.css({
                    overflow: mfp.st.overflowY,
                    overflowX: "hidden",
                    overflowY: mfp.st.overflowY
                });
            } else {
                mfp.wrap.css({
                    top: _window.scrollTop(),
                    position: "absolute"
                });
            }
            if (mfp.st.fixedBgPos === false || mfp.st.fixedBgPos === "auto" && !mfp.fixedContentPos) {
                mfp.bgOverlay.css({
                    height: _document.height(),
                    position: "absolute"
                });
            }
            if (mfp.st.enableEscapeKey) {
                _document.on("keyup" + EVENT_NS, function(e) {
                    if (e.keyCode === 27) {
                        mfp.close();
                    }
                });
            }
            _window.on("resize" + EVENT_NS, function() {
                mfp.updateSize();
            });
            if (!mfp.st.closeOnContentClick) {
                _wrapClasses += " mfp-auto-cursor";
            }
            if (_wrapClasses) mfp.wrap.addClass(_wrapClasses);
            var windowHeight = mfp.wH = _window.height();
            var windowStyles = {};
            if (mfp.fixedContentPos) {
                if (mfp._hasScrollBar(windowHeight)) {
                    var s = mfp._getScrollbarSize();
                    if (s) {
                        windowStyles.marginRight = s;
                    }
                }
            }
            if (mfp.fixedContentPos) {
                if (!mfp.isIE7) {
                    windowStyles.overflow = "hidden";
                } else {
                    $("body, html").css("overflow", "hidden");
                }
            }
            var classesToadd = mfp.st.mainClass;
            if (mfp.isIE7) {
                classesToadd += " mfp-ie7";
            }
            if (classesToadd) {
                mfp._addClassToMFP(classesToadd);
            }
            mfp.updateItemHTML();
            _mfpTrigger("BuildControls");
            $("html").css(windowStyles);
            mfp.bgOverlay.add(mfp.wrap).prependTo(mfp.st.prependTo || $(document.body));
            mfp._lastFocusedEl = document.activeElement;
            setTimeout(function() {
                if (mfp.content) {
                    mfp._addClassToMFP(READY_CLASS);
                    mfp._setFocus();
                } else {
                    mfp.bgOverlay.addClass(READY_CLASS);
                }
                _document.on("focusin" + EVENT_NS, mfp._onFocusIn);
            }, 16);
            mfp.isOpen = true;
            mfp.updateSize(windowHeight);
            _mfpTrigger(OPEN_EVENT);
            return data;
        },
        close: function() {
            if (!mfp.isOpen) return;
            _mfpTrigger(BEFORE_CLOSE_EVENT);
            mfp.isOpen = false;
            if (mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition) {
                mfp._addClassToMFP(REMOVING_CLASS);
                setTimeout(function() {
                    mfp._close();
                }, mfp.st.removalDelay);
            } else {
                mfp._close();
            }
        },
        _close: function() {
            _mfpTrigger(CLOSE_EVENT);
            var classesToRemove = REMOVING_CLASS + " " + READY_CLASS + " ";
            mfp.bgOverlay.detach();
            mfp.wrap.detach();
            mfp.container.empty();
            if (mfp.st.mainClass) {
                classesToRemove += mfp.st.mainClass + " ";
            }
            mfp._removeClassFromMFP(classesToRemove);
            if (mfp.fixedContentPos) {
                var windowStyles = {
                    marginRight: ""
                };
                if (mfp.isIE7) {
                    $("body, html").css("overflow", "");
                } else {
                    windowStyles.overflow = "";
                }
                $("html").css(windowStyles);
            }
            _document.off("keyup" + EVENT_NS + " focusin" + EVENT_NS);
            mfp.ev.off(EVENT_NS);
            mfp.wrap.attr("class", "mfp-wrap").removeAttr("style");
            mfp.bgOverlay.attr("class", "mfp-bg");
            mfp.container.attr("class", "mfp-container");
            if (mfp.st.showCloseBtn && (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
                if (mfp.currTemplate.closeBtn) mfp.currTemplate.closeBtn.detach();
            }
            if (mfp._lastFocusedEl) {
                $(mfp._lastFocusedEl).focus();
            }
            mfp.currItem = null;
            mfp.content = null;
            mfp.currTemplate = null;
            mfp.prevHeight = 0;
            _mfpTrigger(AFTER_CLOSE_EVENT);
        },
        updateSize: function(winHeight) {
            if (mfp.isIOS) {
                var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
                var height = window.innerHeight * zoomLevel;
                mfp.wrap.css("height", height);
                mfp.wH = height;
            } else {
                mfp.wH = winHeight || _window.height();
            }
            if (!mfp.fixedContentPos) {
                mfp.wrap.css("height", mfp.wH);
            }
            _mfpTrigger("Resize");
        },
        updateItemHTML: function() {
            var item = mfp.items[mfp.index];
            mfp.contentContainer.detach();
            if (mfp.content) mfp.content.detach();
            if (!item.parsed) {
                item = mfp.parseEl(mfp.index);
            }
            var type = item.type;
            _mfpTrigger("BeforeChange", [ mfp.currItem ? mfp.currItem.type : "", type ]);
            mfp.currItem = item;
            if (!mfp.currTemplate[type]) {
                var markup = mfp.st[type] ? mfp.st[type].markup : false;
                _mfpTrigger("FirstMarkupParse", markup);
                if (markup) {
                    mfp.currTemplate[type] = $(markup);
                } else {
                    mfp.currTemplate[type] = true;
                }
            }
            if (_prevContentType && _prevContentType !== item.type) {
                mfp.container.removeClass("mfp-" + _prevContentType + "-holder");
            }
            var newContent = mfp["get" + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
            mfp.appendContent(newContent, type);
            item.preloaded = true;
            _mfpTrigger(CHANGE_EVENT, item);
            _prevContentType = item.type;
            mfp.container.prepend(mfp.contentContainer);
            _mfpTrigger("AfterChange");
        },
        appendContent: function(newContent, type) {
            mfp.content = newContent;
            if (newContent) {
                if (mfp.st.showCloseBtn && mfp.st.closeBtnInside && mfp.currTemplate[type] === true) {
                    if (!mfp.content.find(".mfp-close").length) {
                        mfp.content.append(_getCloseBtn());
                    }
                } else {
                    mfp.content = newContent;
                }
            } else {
                mfp.content = "";
            }
            _mfpTrigger(BEFORE_APPEND_EVENT);
            mfp.container.addClass("mfp-" + type + "-holder");
            mfp.contentContainer.append(mfp.content);
        },
        parseEl: function(index) {
            var item = mfp.items[index], type;
            if (item.tagName) {
                item = {
                    el: $(item)
                };
            } else {
                type = item.type;
                item = {
                    data: item,
                    src: item.src
                };
            }
            if (item.el) {
                var types = mfp.types;
                for (var i = 0; i < types.length; i++) {
                    if (item.el.hasClass("mfp-" + types[i])) {
                        type = types[i];
                        break;
                    }
                }
                item.src = item.el.attr("data-mfp-src");
                if (!item.src) {
                    item.src = item.el.attr("href");
                }
            }
            item.type = type || mfp.st.type || "inline";
            item.index = index;
            item.parsed = true;
            mfp.items[index] = item;
            _mfpTrigger("ElementParse", item);
            return mfp.items[index];
        },
        addGroup: function(el, options) {
            var eHandler = function(e) {
                e.mfpEl = this;
                mfp._openClick(e, el, options);
            };
            if (!options) {
                options = {};
            }
            var eName = "click.magnificPopup";
            options.mainEl = el;
            if (options.items) {
                options.isObj = true;
                el.off(eName).on(eName, eHandler);
            } else {
                options.isObj = false;
                if (options.delegate) {
                    el.off(eName).on(eName, options.delegate, eHandler);
                } else {
                    options.items = el;
                    el.off(eName).on(eName, eHandler);
                }
            }
        },
        _openClick: function(e, el, options) {
            var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;
            if (!midClick && (e.which === 2 || e.ctrlKey || e.metaKey)) {
                return;
            }
            var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;
            if (disableOn) {
                if ($.isFunction(disableOn)) {
                    if (!disableOn.call(mfp)) {
                        return true;
                    }
                } else {
                    if (_window.width() < disableOn) {
                        return true;
                    }
                }
            }
            if (e.type) {
                e.preventDefault();
                if (mfp.isOpen) {
                    e.stopPropagation();
                }
            }
            options.el = $(e.mfpEl);
            if (options.delegate) {
                options.items = el.find(options.delegate);
            }
            mfp.open(options);
        },
        updateStatus: function(status, text) {
            if (mfp.preloader) {
                if (_prevStatus !== status) {
                    mfp.container.removeClass("mfp-s-" + _prevStatus);
                }
                if (!text && status === "loading") {
                    text = mfp.st.tLoading;
                }
                var data = {
                    status: status,
                    text: text
                };
                _mfpTrigger("UpdateStatus", data);
                status = data.status;
                text = data.text;
                mfp.preloader.html(text);
                mfp.preloader.find("a").on("click", function(e) {
                    e.stopImmediatePropagation();
                });
                mfp.container.addClass("mfp-s-" + status);
                _prevStatus = status;
            }
        },
        _checkIfClose: function(target) {
            if ($(target).hasClass(PREVENT_CLOSE_CLASS)) {
                return;
            }
            var closeOnContent = mfp.st.closeOnContentClick;
            var closeOnBg = mfp.st.closeOnBgClick;
            if (closeOnContent && closeOnBg) {
                return true;
            } else {
                if (!mfp.content || $(target).hasClass("mfp-close") || mfp.preloader && target === mfp.preloader[0]) {
                    return true;
                }
                if (target !== mfp.content[0] && !$.contains(mfp.content[0], target)) {
                    if (closeOnBg) {
                        if ($.contains(document, target)) {
                            return true;
                        }
                    }
                } else if (closeOnContent) {
                    return true;
                }
            }
            return false;
        },
        _addClassToMFP: function(cName) {
            mfp.bgOverlay.addClass(cName);
            mfp.wrap.addClass(cName);
        },
        _removeClassFromMFP: function(cName) {
            this.bgOverlay.removeClass(cName);
            mfp.wrap.removeClass(cName);
        },
        _hasScrollBar: function(winHeight) {
            return (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height());
        },
        _setFocus: function() {
            (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
        },
        _onFocusIn: function(e) {
            if (e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target)) {
                mfp._setFocus();
                return false;
            }
        },
        _parseMarkup: function(template, values, item) {
            var arr;
            if (item.data) {
                values = $.extend(item.data, values);
            }
            _mfpTrigger(MARKUP_PARSE_EVENT, [ template, values, item ]);
            $.each(values, function(key, value) {
                if (value === undefined || value === false) {
                    return true;
                }
                arr = key.split("_");
                if (arr.length > 1) {
                    var el = template.find(EVENT_NS + "-" + arr[0]);
                    if (el.length > 0) {
                        var attr = arr[1];
                        if (attr === "replaceWith") {
                            if (el[0] !== value[0]) {
                                el.replaceWith(value);
                            }
                        } else if (attr === "img") {
                            if (el.is("img")) {
                                el.attr("src", value);
                            } else {
                                el.replaceWith('<img src="' + value + '" class="' + el.attr("class") + '" />');
                            }
                        } else {
                            el.attr(arr[1], value);
                        }
                    }
                } else {
                    template.find(EVENT_NS + "-" + key).html(value);
                }
            });
        },
        _getScrollbarSize: function() {
            if (mfp.scrollbarSize === undefined) {
                var scrollDiv = document.createElement("div");
                scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
                document.body.appendChild(scrollDiv);
                mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
            }
            return mfp.scrollbarSize;
        }
    };
    $.magnificPopup = {
        instance: null,
        proto: MagnificPopup.prototype,
        modules: [],
        open: function(options, index) {
            _checkInstance();
            if (!options) {
                options = {};
            } else {
                options = $.extend(true, {}, options);
            }
            options.isObj = true;
            options.index = index || 0;
            return this.instance.open(options);
        },
        close: function() {
            return $.magnificPopup.instance && $.magnificPopup.instance.close();
        },
        registerModule: function(name, module) {
            if (module.options) {
                $.magnificPopup.defaults[name] = module.options;
            }
            $.extend(this.proto, module.proto);
            this.modules.push(name);
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: false,
            mainClass: "",
            preloader: true,
            focus: "",
            closeOnContentClick: false,
            closeOnBgClick: true,
            closeBtnInside: true,
            showCloseBtn: true,
            enableEscapeKey: true,
            modal: false,
            alignTop: false,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading..."
        }
    };
    $.fn.magnificPopup = function(options) {
        _checkInstance();
        var jqEl = $(this);
        if (typeof options === "string") {
            if (options === "open") {
                var items, itemOpts = _isJQ ? jqEl.data("magnificPopup") : jqEl[0].magnificPopup, index = parseInt(arguments[1], 10) || 0;
                if (itemOpts.items) {
                    items = itemOpts.items[index];
                } else {
                    items = jqEl;
                    if (itemOpts.delegate) {
                        items = items.find(itemOpts.delegate);
                    }
                    items = items.eq(index);
                }
                mfp._openClick({
                    mfpEl: items
                }, jqEl, itemOpts);
            } else {
                if (mfp.isOpen) mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
            }
        } else {
            options = $.extend(true, {}, options);
            if (_isJQ) {
                jqEl.data("magnificPopup", options);
            } else {
                jqEl[0].magnificPopup = options;
            }
            mfp.addGroup(jqEl, options);
        }
        return jqEl;
    };
    var INLINE_NS = "inline", _hiddenClass, _inlinePlaceholder, _lastInlineElement, _putInlineElementsBack = function() {
        if (_lastInlineElement) {
            _inlinePlaceholder.after(_lastInlineElement.addClass(_hiddenClass)).detach();
            _lastInlineElement = null;
        }
    };
    $.magnificPopup.registerModule(INLINE_NS, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function() {
                mfp.types.push(INLINE_NS);
                _mfpOn(CLOSE_EVENT + "." + INLINE_NS, function() {
                    _putInlineElementsBack();
                });
            },
            getInline: function(item, template) {
                _putInlineElementsBack();
                if (item.src) {
                    var inlineSt = mfp.st.inline, el = $(item.src);
                    if (el.length) {
                        var parent = el[0].parentNode;
                        if (parent && parent.tagName) {
                            if (!_inlinePlaceholder) {
                                _hiddenClass = inlineSt.hiddenClass;
                                _inlinePlaceholder = _getEl(_hiddenClass);
                                _hiddenClass = "mfp-" + _hiddenClass;
                            }
                            _lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
                        }
                        mfp.updateStatus("ready");
                    } else {
                        mfp.updateStatus("error", inlineSt.tNotFound);
                        el = $("<div>");
                    }
                    item.inlineElement = el;
                    return el;
                }
                mfp.updateStatus("ready");
                mfp._parseMarkup(template, {}, item);
                return template;
            }
        }
    });
    var AJAX_NS = "ajax", _ajaxCur, _removeAjaxCursor = function() {
        if (_ajaxCur) {
            $(document.body).removeClass(_ajaxCur);
        }
    }, _destroyAjaxRequest = function() {
        _removeAjaxCursor();
        if (mfp.req) {
            mfp.req.abort();
        }
    };
    $.magnificPopup.registerModule(AJAX_NS, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                mfp.types.push(AJAX_NS);
                _ajaxCur = mfp.st.ajax.cursor;
                _mfpOn(CLOSE_EVENT + "." + AJAX_NS, _destroyAjaxRequest);
                _mfpOn("BeforeChange." + AJAX_NS, _destroyAjaxRequest);
            },
            getAjax: function(item) {
                if (_ajaxCur) {
                    $(document.body).addClass(_ajaxCur);
                }
                mfp.updateStatus("loading");
                var opts = $.extend({
                    url: item.src,
                    success: function(data, textStatus, jqXHR) {
                        var temp = {
                            data: data,
                            xhr: jqXHR
                        };
                        _mfpTrigger("ParseAjax", temp);
                        mfp.appendContent($(temp.data), AJAX_NS);
                        item.finished = true;
                        _removeAjaxCursor();
                        mfp._setFocus();
                        setTimeout(function() {
                            mfp.wrap.addClass(READY_CLASS);
                        }, 16);
                        mfp.updateStatus("ready");
                        _mfpTrigger("AjaxContentAdded");
                    },
                    error: function() {
                        _removeAjaxCursor();
                        item.finished = item.loadError = true;
                        mfp.updateStatus("error", mfp.st.ajax.tError.replace("%url%", item.src));
                    }
                }, mfp.st.ajax.settings);
                mfp.req = $.ajax(opts);
                return "";
            }
        }
    });
    var _imgInterval, _getTitle = function(item) {
        if (item.data && item.data.title !== undefined) return item.data.title;
        var src = mfp.st.image.titleSrc;
        if (src) {
            if ($.isFunction(src)) {
                return src.call(mfp, item);
            } else if (item.el) {
                return item.el.attr(src) || "";
            }
        }
        return "";
    };
    $.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + "<figure>" + '<div class="mfp-img"></div>' + "<figcaption>" + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</figcaption>" + "</figure>" + "</div>",
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: true,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var imgSt = mfp.st.image, ns = ".image";
                mfp.types.push("image");
                _mfpOn(OPEN_EVENT + ns, function() {
                    if (mfp.currItem.type === "image" && imgSt.cursor) {
                        $(document.body).addClass(imgSt.cursor);
                    }
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    if (imgSt.cursor) {
                        $(document.body).removeClass(imgSt.cursor);
                    }
                    _window.off("resize" + EVENT_NS);
                });
                _mfpOn("Resize" + ns, mfp.resizeImage);
                if (mfp.isLowIE) {
                    _mfpOn("AfterChange", mfp.resizeImage);
                }
            },
            resizeImage: function() {
                var item = mfp.currItem;
                if (!item || !item.img) return;
                if (mfp.st.image.verticalFit) {
                    var decr = 0;
                    if (mfp.isLowIE) {
                        decr = parseInt(item.img.css("padding-top"), 10) + parseInt(item.img.css("padding-bottom"), 10);
                    }
                    item.img.css("max-height", mfp.wH - decr);
                }
            },
            _onImageHasSize: function(item) {
                if (item.img) {
                    item.hasSize = true;
                    if (_imgInterval) {
                        clearInterval(_imgInterval);
                    }
                    item.isCheckingImgSize = false;
                    _mfpTrigger("ImageHasSize", item);
                    if (item.imgHidden) {
                        if (mfp.content) mfp.content.removeClass("mfp-loading");
                        item.imgHidden = false;
                    }
                }
            },
            findImageSize: function(item) {
                var counter = 0, img = item.img[0], mfpSetInterval = function(delay) {
                    if (_imgInterval) {
                        clearInterval(_imgInterval);
                    }
                    _imgInterval = setInterval(function() {
                        if (img.naturalWidth > 0) {
                            mfp._onImageHasSize(item);
                            return;
                        }
                        if (counter > 200) {
                            clearInterval(_imgInterval);
                        }
                        counter++;
                        if (counter === 3) {
                            mfpSetInterval(10);
                        } else if (counter === 40) {
                            mfpSetInterval(50);
                        } else if (counter === 100) {
                            mfpSetInterval(500);
                        }
                    }, delay);
                };
                mfpSetInterval(1);
            },
            getImage: function(item, template) {
                var guard = 0, onLoadComplete = function() {
                    if (item) {
                        if (item.img[0].complete) {
                            item.img.off(".mfploader");
                            if (item === mfp.currItem) {
                                mfp._onImageHasSize(item);
                                mfp.updateStatus("ready");
                            }
                            item.hasSize = true;
                            item.loaded = true;
                            _mfpTrigger("ImageLoadComplete");
                        } else {
                            guard++;
                            if (guard < 200) {
                                setTimeout(onLoadComplete, 100);
                            } else {
                                onLoadError();
                            }
                        }
                    }
                }, onLoadError = function() {
                    if (item) {
                        item.img.off(".mfploader");
                        if (item === mfp.currItem) {
                            mfp._onImageHasSize(item);
                            mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src));
                        }
                        item.hasSize = true;
                        item.loaded = true;
                        item.loadError = true;
                    }
                }, imgSt = mfp.st.image;
                var el = template.find(".mfp-img");
                if (el.length) {
                    var img = document.createElement("img");
                    img.className = "mfp-img";
                    if (item.el && item.el.find("img").length) {
                        img.alt = item.el.find("img").attr("alt");
                    }
                    item.img = $(img).on("load.mfploader", onLoadComplete).on("error.mfploader", onLoadError);
                    img.src = item.src;
                    if (el.is("img")) {
                        item.img = item.img.clone();
                    }
                    img = item.img[0];
                    if (img.naturalWidth > 0) {
                        item.hasSize = true;
                    } else if (!img.width) {
                        item.hasSize = false;
                    }
                }
                mfp._parseMarkup(template, {
                    title: _getTitle(item),
                    img_replaceWith: item.img
                }, item);
                mfp.resizeImage();
                if (item.hasSize) {
                    if (_imgInterval) clearInterval(_imgInterval);
                    if (item.loadError) {
                        template.addClass("mfp-loading");
                        mfp.updateStatus("error", imgSt.tError.replace("%url%", item.src));
                    } else {
                        template.removeClass("mfp-loading");
                        mfp.updateStatus("ready");
                    }
                    return template;
                }
                mfp.updateStatus("loading");
                item.loading = true;
                if (!item.hasSize) {
                    item.imgHidden = true;
                    template.addClass("mfp-loading");
                    mfp.findImageSize(item);
                }
                return template;
            }
        }
    });
    var hasMozTransform, getHasMozTransform = function() {
        if (hasMozTransform === undefined) {
            hasMozTransform = document.createElement("p").style.MozTransform !== undefined;
        }
        return hasMozTransform;
    };
    $.magnificPopup.registerModule("zoom", {
        options: {
            enabled: false,
            easing: "ease-in-out",
            duration: 300,
            opener: function(element) {
                return element.is("img") ? element : element.find("img");
            }
        },
        proto: {
            initZoom: function() {
                var zoomSt = mfp.st.zoom, ns = ".zoom", image;
                if (!zoomSt.enabled || !mfp.supportsTransition) {
                    return;
                }
                var duration = zoomSt.duration, getElToAnimate = function(image) {
                    var newImg = image.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"), transition = "all " + zoomSt.duration / 1e3 + "s " + zoomSt.easing, cssObj = {
                        position: "fixed",
                        zIndex: 9999,
                        left: 0,
                        top: 0,
                        "-webkit-backface-visibility": "hidden"
                    }, t = "transition";
                    cssObj["-webkit-" + t] = cssObj["-moz-" + t] = cssObj["-o-" + t] = cssObj[t] = transition;
                    newImg.css(cssObj);
                    return newImg;
                }, showMainContent = function() {
                    mfp.content.css("visibility", "visible");
                }, openTimeout, animatedImg;
                _mfpOn("BuildControls" + ns, function() {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);
                        mfp.content.css("visibility", "hidden");
                        image = mfp._getItemToZoom();
                        if (!image) {
                            showMainContent();
                            return;
                        }
                        animatedImg = getElToAnimate(image);
                        animatedImg.css(mfp._getOffset());
                        mfp.wrap.append(animatedImg);
                        openTimeout = setTimeout(function() {
                            animatedImg.css(mfp._getOffset(true));
                            openTimeout = setTimeout(function() {
                                showMainContent();
                                setTimeout(function() {
                                    animatedImg.remove();
                                    image = animatedImg = null;
                                    _mfpTrigger("ZoomAnimationEnded");
                                }, 16);
                            }, duration);
                        }, 16);
                    }
                });
                _mfpOn(BEFORE_CLOSE_EVENT + ns, function() {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);
                        mfp.st.removalDelay = duration;
                        if (!image) {
                            image = mfp._getItemToZoom();
                            if (!image) {
                                return;
                            }
                            animatedImg = getElToAnimate(image);
                        }
                        animatedImg.css(mfp._getOffset(true));
                        mfp.wrap.append(animatedImg);
                        mfp.content.css("visibility", "hidden");
                        setTimeout(function() {
                            animatedImg.css(mfp._getOffset());
                        }, 16);
                    }
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    if (mfp._allowZoom()) {
                        showMainContent();
                        if (animatedImg) {
                            animatedImg.remove();
                        }
                        image = null;
                    }
                });
            },
            _allowZoom: function() {
                return mfp.currItem.type === "image";
            },
            _getItemToZoom: function() {
                if (mfp.currItem.hasSize) {
                    return mfp.currItem.img;
                } else {
                    return false;
                }
            },
            _getOffset: function(isLarge) {
                var el;
                if (isLarge) {
                    el = mfp.currItem.img;
                } else {
                    el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
                }
                var offset = el.offset();
                var paddingTop = parseInt(el.css("padding-top"), 10);
                var paddingBottom = parseInt(el.css("padding-bottom"), 10);
                offset.top -= $(window).scrollTop() - paddingTop;
                var obj = {
                    width: el.width(),
                    height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
                };
                if (getHasMozTransform()) {
                    obj["-moz-transform"] = obj["transform"] = "translate(" + offset.left + "px," + offset.top + "px)";
                } else {
                    obj.left = offset.left;
                    obj.top = offset.top;
                }
                return obj;
            }
        }
    });
    var IFRAME_NS = "iframe", _emptyPage = "//about:blank", _fixIframeBugs = function(isShowing) {
        if (mfp.currTemplate[IFRAME_NS]) {
            var el = mfp.currTemplate[IFRAME_NS].find("iframe");
            if (el.length) {
                if (!isShowing) {
                    el[0].src = _emptyPage;
                }
                if (mfp.isIE8) {
                    el.css("display", isShowing ? "block" : "none");
                }
            }
        }
    };
    $.magnificPopup.registerModule(IFRAME_NS, {
        options: {
            markup: '<div class="mfp-iframe-scaler">' + '<div class="mfp-close"></div>' + '<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>' + "</div>",
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function() {
                mfp.types.push(IFRAME_NS);
                _mfpOn("BeforeChange", function(e, prevType, newType) {
                    if (prevType !== newType) {
                        if (prevType === IFRAME_NS) {
                            _fixIframeBugs();
                        } else if (newType === IFRAME_NS) {
                            _fixIframeBugs(true);
                        }
                    }
                });
                _mfpOn(CLOSE_EVENT + "." + IFRAME_NS, function() {
                    _fixIframeBugs();
                });
            },
            getIframe: function(item, template) {
                var embedSrc = item.src;
                var iframeSt = mfp.st.iframe;
                $.each(iframeSt.patterns, function() {
                    if (embedSrc.indexOf(this.index) > -1) {
                        if (this.id) {
                            if (typeof this.id === "string") {
                                embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id) + this.id.length, embedSrc.length);
                            } else {
                                embedSrc = this.id.call(this, embedSrc);
                            }
                        }
                        embedSrc = this.src.replace("%id%", embedSrc);
                        return false;
                    }
                });
                var dataObj = {};
                if (iframeSt.srcAction) {
                    dataObj[iframeSt.srcAction] = embedSrc;
                }
                mfp._parseMarkup(template, dataObj, item);
                mfp.updateStatus("ready");
                return template;
            }
        }
    });
    var _getLoopedId = function(index) {
        var numSlides = mfp.items.length;
        if (index > numSlides - 1) {
            return index - numSlides;
        } else if (index < 0) {
            return numSlides + index;
        }
        return index;
    }, _replaceCurrTotal = function(text, curr, total) {
        return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
    };
    $.magnificPopup.registerModule("gallery", {
        options: {
            enabled: false,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [ 0, 2 ],
            navigateByImgClick: true,
            arrows: true,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function() {
                var gSt = mfp.st.gallery, ns = ".mfp-gallery", supportsFastClick = Boolean($.fn.mfpFastClick);
                mfp.direction = true;
                if (!gSt || !gSt.enabled) return false;
                _wrapClasses += " mfp-gallery";
                _mfpOn(OPEN_EVENT + ns, function() {
                    if (gSt.navigateByImgClick) {
                        mfp.wrap.on("click" + ns, ".mfp-img", function() {
                            if (mfp.items.length > 1) {
                                mfp.next();
                                return false;
                            }
                        });
                    }
                    _document.on("keydown" + ns, function(e) {
                        if (e.keyCode === 37) {
                            mfp.prev();
                        } else if (e.keyCode === 39) {
                            mfp.next();
                        }
                    });
                });
                _mfpOn("UpdateStatus" + ns, function(e, data) {
                    if (data.text) {
                        data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
                    }
                });
                _mfpOn(MARKUP_PARSE_EVENT + ns, function(e, element, values, item) {
                    var l = mfp.items.length;
                    values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : "";
                });
                _mfpOn("BuildControls" + ns, function() {
                    if (mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
                        var markup = gSt.arrowMarkup, arrowLeft = mfp.arrowLeft = $(markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, "left")).addClass(PREVENT_CLOSE_CLASS), arrowRight = mfp.arrowRight = $(markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, "right")).addClass(PREVENT_CLOSE_CLASS);
                        var eName = supportsFastClick ? "mfpFastClick" : "click";
                        arrowLeft[eName](function() {
                            mfp.prev();
                        });
                        arrowRight[eName](function() {
                            mfp.next();
                        });
                        if (mfp.isIE7) {
                            _getEl("b", arrowLeft[0], false, true);
                            _getEl("a", arrowLeft[0], false, true);
                            _getEl("b", arrowRight[0], false, true);
                            _getEl("a", arrowRight[0], false, true);
                        }
                        mfp.container.append(arrowLeft.add(arrowRight));
                    }
                });
                _mfpOn(CHANGE_EVENT + ns, function() {
                    if (mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);
                    mfp._preloadTimeout = setTimeout(function() {
                        mfp.preloadNearbyImages();
                        mfp._preloadTimeout = null;
                    }, 16);
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    _document.off(ns);
                    mfp.wrap.off("click" + ns);
                    if (mfp.arrowLeft && supportsFastClick) {
                        mfp.arrowLeft.add(mfp.arrowRight).destroyMfpFastClick();
                    }
                    mfp.arrowRight = mfp.arrowLeft = null;
                });
            },
            next: function() {
                mfp.direction = true;
                mfp.index = _getLoopedId(mfp.index + 1);
                mfp.updateItemHTML();
            },
            prev: function() {
                mfp.direction = false;
                mfp.index = _getLoopedId(mfp.index - 1);
                mfp.updateItemHTML();
            },
            goTo: function(newIndex) {
                mfp.direction = newIndex >= mfp.index;
                mfp.index = newIndex;
                mfp.updateItemHTML();
            },
            preloadNearbyImages: function() {
                var p = mfp.st.gallery.preload, preloadBefore = Math.min(p[0], mfp.items.length), preloadAfter = Math.min(p[1], mfp.items.length), i;
                for (i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
                    mfp._preloadItem(mfp.index + i);
                }
                for (i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
                    mfp._preloadItem(mfp.index - i);
                }
            },
            _preloadItem: function(index) {
                index = _getLoopedId(index);
                if (mfp.items[index].preloaded) {
                    return;
                }
                var item = mfp.items[index];
                if (!item.parsed) {
                    item = mfp.parseEl(index);
                }
                _mfpTrigger("LazyLoad", item);
                if (item.type === "image") {
                    item.img = $('<img class="mfp-img" />').on("load.mfploader", function() {
                        item.hasSize = true;
                    }).on("error.mfploader", function() {
                        item.hasSize = true;
                        item.loadError = true;
                        _mfpTrigger("LazyLoadError", item);
                    }).attr("src", item.src);
                }
                item.preloaded = true;
            }
        }
    });
    var RETINA_NS = "retina";
    $.magnificPopup.registerModule(RETINA_NS, {
        options: {
            replaceSrc: function(item) {
                return item.src.replace(/\.\w+$/, function(m) {
                    return "@2x" + m;
                });
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                if (window.devicePixelRatio > 1) {
                    var st = mfp.st.retina, ratio = st.ratio;
                    ratio = !isNaN(ratio) ? ratio : ratio();
                    if (ratio > 1) {
                        _mfpOn("ImageHasSize" + "." + RETINA_NS, function(e, item) {
                            item.img.css({
                                "max-width": item.img[0].naturalWidth / ratio,
                                width: "100%"
                            });
                        });
                        _mfpOn("ElementParse" + "." + RETINA_NS, function(e, item) {
                            item.src = st.replaceSrc(item, ratio);
                        });
                    }
                }
            }
        }
    });
    (function() {
        var ghostClickDelay = 1e3, supportsTouch = "ontouchstart" in window, unbindTouchMove = function() {
            _window.off("touchmove" + ns + " touchend" + ns);
        }, eName = "mfpFastClick", ns = "." + eName;
        $.fn.mfpFastClick = function(callback) {
            return $(this).each(function() {
                var elem = $(this), lock;
                if (supportsTouch) {
                    var timeout, startX, startY, pointerMoved, point, numPointers;
                    elem.on("touchstart" + ns, function(e) {
                        pointerMoved = false;
                        numPointers = 1;
                        point = e.originalEvent ? e.originalEvent.touches[0] : e.touches[0];
                        startX = point.clientX;
                        startY = point.clientY;
                        _window.on("touchmove" + ns, function(e) {
                            point = e.originalEvent ? e.originalEvent.touches : e.touches;
                            numPointers = point.length;
                            point = point[0];
                            if (Math.abs(point.clientX - startX) > 10 || Math.abs(point.clientY - startY) > 10) {
                                pointerMoved = true;
                                unbindTouchMove();
                            }
                        }).on("touchend" + ns, function(e) {
                            unbindTouchMove();
                            if (pointerMoved || numPointers > 1) {
                                return;
                            }
                            lock = true;
                            e.preventDefault();
                            clearTimeout(timeout);
                            timeout = setTimeout(function() {
                                lock = false;
                            }, ghostClickDelay);
                            callback();
                        });
                    });
                }
                elem.on("click" + ns, function() {
                    if (!lock) {
                        callback();
                    }
                });
            });
        };
        $.fn.destroyMfpFastClick = function() {
            $(this).off("touchstart" + ns + " click" + ns);
            if (supportsTouch) _window.off("touchmove" + ns + " touchend" + ns);
        };
    })();
    _checkInstance();
});

(function($, window, document, undefined) {
    var pluginName = "stellar", defaults = {
        scrollProperty: "scroll",
        positionProperty: "position",
        horizontalScrolling: true,
        verticalScrolling: true,
        horizontalOffset: 0,
        verticalOffset: 0,
        responsive: false,
        parallaxBackgrounds: true,
        parallaxElements: true,
        hideDistantElements: true,
        hideElement: function($elem) {
            $elem.hide();
        },
        showElement: function($elem) {
            $elem.show();
        }
    }, scrollProperty = {
        scroll: {
            getLeft: function($elem) {
                return $elem.scrollLeft();
            },
            setLeft: function($elem, val) {
                $elem.scrollLeft(val);
            },
            getTop: function($elem) {
                return $elem.scrollTop();
            },
            setTop: function($elem, val) {
                $elem.scrollTop(val);
            }
        },
        position: {
            getLeft: function($elem) {
                return parseInt($elem.css("left"), 10) * -1;
            },
            getTop: function($elem) {
                return parseInt($elem.css("top"), 10) * -1;
            }
        },
        margin: {
            getLeft: function($elem) {
                return parseInt($elem.css("margin-left"), 10) * -1;
            },
            getTop: function($elem) {
                return parseInt($elem.css("margin-top"), 10) * -1;
            }
        },
        transform: {
            getLeft: function($elem) {
                var computedTransform = getComputedStyle($elem[0])[prefixedTransform];
                return computedTransform !== "none" ? parseInt(computedTransform.match(/(-?[0-9]+)/g)[4], 10) * -1 : 0;
            },
            getTop: function($elem) {
                var computedTransform = getComputedStyle($elem[0])[prefixedTransform];
                return computedTransform !== "none" ? parseInt(computedTransform.match(/(-?[0-9]+)/g)[5], 10) * -1 : 0;
            }
        }
    }, positionProperty = {
        position: {
            setLeft: function($elem, left) {
                $elem.css("left", left);
            },
            setTop: function($elem, top) {
                $elem.css("top", top);
            }
        },
        transform: {
            setPosition: function($elem, left, startingLeft, top, startingTop) {
                $elem[0].style[prefixedTransform] = "translate3d(" + (left - startingLeft) + "px, " + (top - startingTop) + "px, 0)";
            }
        }
    }, vendorPrefix = function() {
        var prefixes = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/, style = $("script")[0].style, prefix = "", prop;
        for (prop in style) {
            if (prefixes.test(prop)) {
                prefix = prop.match(prefixes)[0];
                break;
            }
        }
        if ("WebkitOpacity" in style) {
            prefix = "Webkit";
        }
        if ("KhtmlOpacity" in style) {
            prefix = "Khtml";
        }
        return function(property) {
            return prefix + (prefix.length > 0 ? property.charAt(0).toUpperCase() + property.slice(1) : property);
        };
    }(), prefixedTransform = vendorPrefix("transform"), supportsBackgroundPositionXY = $("<div />", {
        style: "background:#fff"
    }).css("background-position-x") !== undefined, setBackgroundPosition = supportsBackgroundPositionXY ? function($elem, x, y) {
        $elem.css({
            "background-position-x": x,
            "background-position-y": y
        });
    } : function($elem, x, y) {
        $elem.css("background-position", x + " " + y);
    }, getBackgroundPosition = supportsBackgroundPositionXY ? function($elem) {
        return [ $elem.css("background-position-x"), $elem.css("background-position-y") ];
    } : function($elem) {
        return $elem.css("background-position").split(" ");
    }, requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 1e3 / 60);
    };
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }
    Plugin.prototype = {
        init: function() {
            this.options.name = pluginName + "_" + Math.floor(Math.random() * 1e9);
            this._defineElements();
            this._defineGetters();
            this._defineSetters();
            this._handleWindowLoadAndResize();
            this._detectViewport();
            this.refresh({
                firstLoad: true
            });
            if (this.options.scrollProperty === "scroll") {
                this._handleScrollEvent();
            } else {
                this._startAnimationLoop();
            }
        },
        _defineElements: function() {
            if (this.element === document.body) this.element = window;
            this.$scrollElement = $(this.element);
            this.$element = this.element === window ? $("body") : this.$scrollElement;
            this.$viewportElement = this.options.viewportElement !== undefined ? $(this.options.viewportElement) : this.$scrollElement[0] === window || this.options.scrollProperty === "scroll" ? this.$scrollElement : this.$scrollElement.parent();
        },
        _defineGetters: function() {
            var self = this, scrollPropertyAdapter = scrollProperty[self.options.scrollProperty];
            this._getScrollLeft = function() {
                return scrollPropertyAdapter.getLeft(self.$scrollElement);
            };
            this._getScrollTop = function() {
                return scrollPropertyAdapter.getTop(self.$scrollElement);
            };
        },
        _defineSetters: function() {
            var self = this, scrollPropertyAdapter = scrollProperty[self.options.scrollProperty], positionPropertyAdapter = positionProperty[self.options.positionProperty], setScrollLeft = scrollPropertyAdapter.setLeft, setScrollTop = scrollPropertyAdapter.setTop;
            this._setScrollLeft = typeof setScrollLeft === "function" ? function(val) {
                setScrollLeft(self.$scrollElement, val);
            } : $.noop;
            this._setScrollTop = typeof setScrollTop === "function" ? function(val) {
                setScrollTop(self.$scrollElement, val);
            } : $.noop;
            this._setPosition = positionPropertyAdapter.setPosition || function($elem, left, startingLeft, top, startingTop) {
                if (self.options.horizontalScrolling) {
                    positionPropertyAdapter.setLeft($elem, left, startingLeft);
                }
                if (self.options.verticalScrolling) {
                    positionPropertyAdapter.setTop($elem, top, startingTop);
                }
            };
        },
        _handleWindowLoadAndResize: function() {
            var self = this, $window = $(window);
            if (self.options.responsive) {
                $window.bind("load." + this.name, function() {
                    self.refresh();
                });
            }
            $window.bind("resize." + this.name, function() {
                self._detectViewport();
                if (self.options.responsive) {
                    self.refresh();
                }
            });
        },
        refresh: function(options) {
            var self = this, oldLeft = self._getScrollLeft(), oldTop = self._getScrollTop();
            if (!options || !options.firstLoad) {
                this._reset();
            }
            this._setScrollLeft(0);
            this._setScrollTop(0);
            this._setOffsets();
            this._findParticles();
            this._findBackgrounds();
            if (options && options.firstLoad && /WebKit/.test(navigator.userAgent)) {
                $(window).load(function() {
                    var oldLeft = self._getScrollLeft(), oldTop = self._getScrollTop();
                    self._setScrollLeft(oldLeft + 1);
                    self._setScrollTop(oldTop + 1);
                    self._setScrollLeft(oldLeft);
                    self._setScrollTop(oldTop);
                });
            }
            this._setScrollLeft(oldLeft);
            this._setScrollTop(oldTop);
        },
        _detectViewport: function() {
            var viewportOffsets = this.$viewportElement.offset(), hasOffsets = viewportOffsets !== null && viewportOffsets !== undefined;
            this.viewportWidth = this.$viewportElement.width();
            this.viewportHeight = this.$viewportElement.height();
            this.viewportOffsetTop = hasOffsets ? viewportOffsets.top : 0;
            this.viewportOffsetLeft = hasOffsets ? viewportOffsets.left : 0;
        },
        _findParticles: function() {
            var self = this, scrollLeft = this._getScrollLeft(), scrollTop = this._getScrollTop();
            if (this.particles !== undefined) {
                for (var i = this.particles.length - 1; i >= 0; i--) {
                    this.particles[i].$element.data("stellar-elementIsActive", undefined);
                }
            }
            this.particles = [];
            if (!this.options.parallaxElements) return;
            this.$element.find("[data-stellar-ratio]").each(function(i) {
                var $this = $(this), horizontalOffset, verticalOffset, positionLeft, positionTop, marginLeft, marginTop, $offsetParent, offsetLeft, offsetTop, parentOffsetLeft = 0, parentOffsetTop = 0, tempParentOffsetLeft = 0, tempParentOffsetTop = 0;
                if (!$this.data("stellar-elementIsActive")) {
                    $this.data("stellar-elementIsActive", this);
                } else if ($this.data("stellar-elementIsActive") !== this) {
                    return;
                }
                self.options.showElement($this);
                if (!$this.data("stellar-startingLeft")) {
                    $this.data("stellar-startingLeft", $this.css("left"));
                    $this.data("stellar-startingTop", $this.css("top"));
                } else {
                    $this.css("left", $this.data("stellar-startingLeft"));
                    $this.css("top", $this.data("stellar-startingTop"));
                }
                positionLeft = $this.position().left;
                positionTop = $this.position().top;
                marginLeft = $this.css("margin-left") === "auto" ? 0 : parseInt($this.css("margin-left"), 10);
                marginTop = $this.css("margin-top") === "auto" ? 0 : parseInt($this.css("margin-top"), 10);
                offsetLeft = $this.offset().left - marginLeft;
                offsetTop = $this.offset().top - marginTop;
                $this.parents().each(function() {
                    var $this = $(this);
                    if ($this.data("stellar-offset-parent") === true) {
                        parentOffsetLeft = tempParentOffsetLeft;
                        parentOffsetTop = tempParentOffsetTop;
                        $offsetParent = $this;
                        return false;
                    } else {
                        tempParentOffsetLeft += $this.position().left;
                        tempParentOffsetTop += $this.position().top;
                    }
                });
                horizontalOffset = $this.data("stellar-horizontal-offset") !== undefined ? $this.data("stellar-horizontal-offset") : $offsetParent !== undefined && $offsetParent.data("stellar-horizontal-offset") !== undefined ? $offsetParent.data("stellar-horizontal-offset") : self.horizontalOffset;
                verticalOffset = $this.data("stellar-vertical-offset") !== undefined ? $this.data("stellar-vertical-offset") : $offsetParent !== undefined && $offsetParent.data("stellar-vertical-offset") !== undefined ? $offsetParent.data("stellar-vertical-offset") : self.verticalOffset;
                self.particles.push({
                    $element: $this,
                    $offsetParent: $offsetParent,
                    isFixed: $this.css("position") === "fixed",
                    horizontalOffset: horizontalOffset,
                    verticalOffset: verticalOffset,
                    startingPositionLeft: positionLeft,
                    startingPositionTop: positionTop,
                    startingOffsetLeft: offsetLeft,
                    startingOffsetTop: offsetTop,
                    parentOffsetLeft: parentOffsetLeft,
                    parentOffsetTop: parentOffsetTop,
                    stellarRatio: $this.data("stellar-ratio") !== undefined ? $this.data("stellar-ratio") : 1,
                    width: $this.outerWidth(true),
                    height: $this.outerHeight(true),
                    isHidden: false
                });
            });
        },
        _findBackgrounds: function() {
            var self = this, scrollLeft = this._getScrollLeft(), scrollTop = this._getScrollTop(), $backgroundElements;
            this.backgrounds = [];
            if (!this.options.parallaxBackgrounds) return;
            $backgroundElements = this.$element.find("[data-stellar-background-ratio]");
            if (this.$element.data("stellar-background-ratio")) {
                $backgroundElements = $backgroundElements.add(this.$element);
            }
            $backgroundElements.each(function() {
                var $this = $(this), backgroundPosition = getBackgroundPosition($this), horizontalOffset, verticalOffset, positionLeft, positionTop, marginLeft, marginTop, offsetLeft, offsetTop, $offsetParent, parentOffsetLeft = 0, parentOffsetTop = 0, tempParentOffsetLeft = 0, tempParentOffsetTop = 0;
                if (!$this.data("stellar-backgroundIsActive")) {
                    $this.data("stellar-backgroundIsActive", this);
                } else if ($this.data("stellar-backgroundIsActive") !== this) {
                    return;
                }
                if (!$this.data("stellar-backgroundStartingLeft")) {
                    $this.data("stellar-backgroundStartingLeft", backgroundPosition[0]);
                    $this.data("stellar-backgroundStartingTop", backgroundPosition[1]);
                } else {
                    setBackgroundPosition($this, $this.data("stellar-backgroundStartingLeft"), $this.data("stellar-backgroundStartingTop"));
                }
                marginLeft = $this.css("margin-left") === "auto" ? 0 : parseInt($this.css("margin-left"), 10);
                marginTop = $this.css("margin-top") === "auto" ? 0 : parseInt($this.css("margin-top"), 10);
                offsetLeft = $this.offset().left - marginLeft - scrollLeft;
                offsetTop = $this.offset().top - marginTop - scrollTop;
                $this.parents().each(function() {
                    var $this = $(this);
                    if ($this.data("stellar-offset-parent") === true) {
                        parentOffsetLeft = tempParentOffsetLeft;
                        parentOffsetTop = tempParentOffsetTop;
                        $offsetParent = $this;
                        return false;
                    } else {
                        tempParentOffsetLeft += $this.position().left;
                        tempParentOffsetTop += $this.position().top;
                    }
                });
                horizontalOffset = $this.data("stellar-horizontal-offset") !== undefined ? $this.data("stellar-horizontal-offset") : $offsetParent !== undefined && $offsetParent.data("stellar-horizontal-offset") !== undefined ? $offsetParent.data("stellar-horizontal-offset") : self.horizontalOffset;
                verticalOffset = $this.data("stellar-vertical-offset") !== undefined ? $this.data("stellar-vertical-offset") : $offsetParent !== undefined && $offsetParent.data("stellar-vertical-offset") !== undefined ? $offsetParent.data("stellar-vertical-offset") : self.verticalOffset;
                self.backgrounds.push({
                    $element: $this,
                    $offsetParent: $offsetParent,
                    isFixed: $this.css("background-attachment") === "fixed",
                    horizontalOffset: horizontalOffset,
                    verticalOffset: verticalOffset,
                    startingValueLeft: backgroundPosition[0],
                    startingValueTop: backgroundPosition[1],
                    startingBackgroundPositionLeft: isNaN(parseInt(backgroundPosition[0], 10)) ? 0 : parseInt(backgroundPosition[0], 10),
                    startingBackgroundPositionTop: isNaN(parseInt(backgroundPosition[1], 10)) ? 0 : parseInt(backgroundPosition[1], 10),
                    startingPositionLeft: $this.position().left,
                    startingPositionTop: $this.position().top,
                    startingOffsetLeft: offsetLeft,
                    startingOffsetTop: offsetTop,
                    parentOffsetLeft: parentOffsetLeft,
                    parentOffsetTop: parentOffsetTop,
                    stellarRatio: $this.data("stellar-background-ratio") === undefined ? 1 : $this.data("stellar-background-ratio")
                });
            });
        },
        _reset: function() {
            var particle, startingPositionLeft, startingPositionTop, background, i;
            for (i = this.particles.length - 1; i >= 0; i--) {
                particle = this.particles[i];
                startingPositionLeft = particle.$element.data("stellar-startingLeft");
                startingPositionTop = particle.$element.data("stellar-startingTop");
                this._setPosition(particle.$element, startingPositionLeft, startingPositionLeft, startingPositionTop, startingPositionTop);
                this.options.showElement(particle.$element);
                particle.$element.data("stellar-startingLeft", null).data("stellar-elementIsActive", null).data("stellar-backgroundIsActive", null);
            }
            for (i = this.backgrounds.length - 1; i >= 0; i--) {
                background = this.backgrounds[i];
                background.$element.data("stellar-backgroundStartingLeft", null).data("stellar-backgroundStartingTop", null);
                setBackgroundPosition(background.$element, background.startingValueLeft, background.startingValueTop);
            }
        },
        destroy: function() {
            this._reset();
            this.$scrollElement.unbind("resize." + this.name).unbind("scroll." + this.name);
            this._animationLoop = $.noop;
            $(window).unbind("load." + this.name).unbind("resize." + this.name);
        },
        _setOffsets: function() {
            var self = this, $window = $(window);
            $window.unbind("resize.horizontal-" + this.name).unbind("resize.vertical-" + this.name);
            if (typeof this.options.horizontalOffset === "function") {
                this.horizontalOffset = this.options.horizontalOffset();
                $window.bind("resize.horizontal-" + this.name, function() {
                    self.horizontalOffset = self.options.horizontalOffset();
                });
            } else {
                this.horizontalOffset = this.options.horizontalOffset;
            }
            if (typeof this.options.verticalOffset === "function") {
                this.verticalOffset = this.options.verticalOffset();
                $window.bind("resize.vertical-" + this.name, function() {
                    self.verticalOffset = self.options.verticalOffset();
                });
            } else {
                this.verticalOffset = this.options.verticalOffset;
            }
        },
        _repositionElements: function() {
            var scrollLeft = this._getScrollLeft(), scrollTop = this._getScrollTop(), horizontalOffset, verticalOffset, particle, fixedRatioOffset, background, bgLeft, bgTop, isVisibleVertical = true, isVisibleHorizontal = true, newPositionLeft, newPositionTop, newOffsetLeft, newOffsetTop, i;
            if (this.currentScrollLeft === scrollLeft && this.currentScrollTop === scrollTop && this.currentWidth === this.viewportWidth && this.currentHeight === this.viewportHeight) {
                return;
            } else {
                this.currentScrollLeft = scrollLeft;
                this.currentScrollTop = scrollTop;
                this.currentWidth = this.viewportWidth;
                this.currentHeight = this.viewportHeight;
            }
            for (i = this.particles.length - 1; i >= 0; i--) {
                particle = this.particles[i];
                fixedRatioOffset = particle.isFixed ? 1 : 0;
                if (this.options.horizontalScrolling) {
                    newPositionLeft = (scrollLeft + particle.horizontalOffset + this.viewportOffsetLeft + particle.startingPositionLeft - particle.startingOffsetLeft + particle.parentOffsetLeft) * -(particle.stellarRatio + fixedRatioOffset - 1) + particle.startingPositionLeft;
                    newOffsetLeft = newPositionLeft - particle.startingPositionLeft + particle.startingOffsetLeft;
                } else {
                    newPositionLeft = particle.startingPositionLeft;
                    newOffsetLeft = particle.startingOffsetLeft;
                }
                if (this.options.verticalScrolling) {
                    newPositionTop = (scrollTop + particle.verticalOffset + this.viewportOffsetTop + particle.startingPositionTop - particle.startingOffsetTop + particle.parentOffsetTop) * -(particle.stellarRatio + fixedRatioOffset - 1) + particle.startingPositionTop;
                    newOffsetTop = newPositionTop - particle.startingPositionTop + particle.startingOffsetTop;
                } else {
                    newPositionTop = particle.startingPositionTop;
                    newOffsetTop = particle.startingOffsetTop;
                }
                if (this.options.hideDistantElements) {
                    isVisibleHorizontal = !this.options.horizontalScrolling || newOffsetLeft + particle.width > (particle.isFixed ? 0 : scrollLeft) && newOffsetLeft < (particle.isFixed ? 0 : scrollLeft) + this.viewportWidth + this.viewportOffsetLeft;
                    isVisibleVertical = !this.options.verticalScrolling || newOffsetTop + particle.height > (particle.isFixed ? 0 : scrollTop) && newOffsetTop < (particle.isFixed ? 0 : scrollTop) + this.viewportHeight + this.viewportOffsetTop;
                }
                if (isVisibleHorizontal && isVisibleVertical) {
                    if (particle.isHidden) {
                        this.options.showElement(particle.$element);
                        particle.isHidden = false;
                    }
                    this._setPosition(particle.$element, newPositionLeft, particle.startingPositionLeft, newPositionTop, particle.startingPositionTop);
                } else {
                    if (!particle.isHidden) {
                        this.options.hideElement(particle.$element);
                        particle.isHidden = true;
                    }
                }
            }
            for (i = this.backgrounds.length - 1; i >= 0; i--) {
                background = this.backgrounds[i];
                fixedRatioOffset = background.isFixed ? 0 : 1;
                bgLeft = this.options.horizontalScrolling ? (scrollLeft + background.horizontalOffset - this.viewportOffsetLeft - background.startingOffsetLeft + background.parentOffsetLeft - background.startingBackgroundPositionLeft) * (fixedRatioOffset - background.stellarRatio) + "px" : background.startingValueLeft;
                bgTop = this.options.verticalScrolling ? (scrollTop + background.verticalOffset - this.viewportOffsetTop - background.startingOffsetTop + background.parentOffsetTop - background.startingBackgroundPositionTop) * (fixedRatioOffset - background.stellarRatio) + "px" : background.startingValueTop;
                setBackgroundPosition(background.$element, bgLeft, bgTop);
            }
        },
        _handleScrollEvent: function() {
            var self = this, ticking = false;
            var update = function() {
                self._repositionElements();
                ticking = false;
            };
            var requestTick = function() {
                if (!ticking) {
                    requestAnimFrame(update);
                    ticking = true;
                }
            };
            this.$scrollElement.bind("scroll." + this.name, requestTick);
            requestTick();
        },
        _startAnimationLoop: function() {
            var self = this;
            this._animationLoop = function() {
                requestAnimFrame(self._animationLoop);
                self._repositionElements();
            };
            this._animationLoop();
        }
    };
    $.fn[pluginName] = function(options) {
        var args = arguments;
        if (options === undefined || typeof options === "object") {
            return this.each(function() {
                if (!$.data(this, "plugin_" + pluginName)) {
                    $.data(this, "plugin_" + pluginName, new Plugin(this, options));
                }
            });
        } else if (typeof options === "string" && options[0] !== "_" && options !== "init") {
            return this.each(function() {
                var instance = $.data(this, "plugin_" + pluginName);
                if (instance instanceof Plugin && typeof instance[options] === "function") {
                    instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }
                if (options === "destroy") {
                    $.data(this, "plugin_" + pluginName, null);
                }
            });
        }
    };
    $[pluginName] = function(options) {
        var $window = $(window);
        return $window.stellar.apply($window, Array.prototype.slice.call(arguments, 0));
    };
    $[pluginName].scrollProperty = scrollProperty;
    $[pluginName].positionProperty = positionProperty;
    window.Stellar = Plugin;
})(jQuery, this, document);

(function(f, p) {
    function c(b, d) {
        var c;
        return (c = f.data(b, a)) ? c : f.data(b, a, new e(b, d));
    }
    function e(a, c) {
        function e(a, b) {
            f(document).on("touchstart", A);
            g.hasFocus = !0;
            q = "sxy-focus";
            a && a(b);
            q = "sxy-hover";
        }
        function k() {
            f(document).off("touchstart", A);
            g.hasFocus = !1;
            q = "sxy-blur";
            g.el.triggerHandler(q);
            q = "sxy-hover";
        }
        function l(a) {
            v = a;
            u.x = a.pageX;
            u.y = a.pageY;
            g.pt = [ u ];
            g.trigger(q);
        }
        function n(a) {
            v = a;
            a = a.originalEvent.targetTouches;
            for (var b = g.pt = [], d = 0, c = a.length; d < c; ++d) {
                b.push({
                    x: a[d].pageX,
                    y: a[d].pageY,
                    type: 1,
                    down: !0
                });
            }
            g.trigger(q);
        }
        function m(a, b, c, e) {
            D.push(a = {
                e: a,
                hnd: c,
                l: 0,
                el: e || g.el
            });
            c = 0;
            for (e = b.length; c < e; ++c) {
                p[d[b[c]]].push(a);
            }
        }
        var g = this, q = "sxy-hover", u = {
            x: 0,
            y: 0,
            down: !1,
            type: 0
        }, D = [], p = {}, v;
        this.options = c = f.extend({}, b, f.isPlainObject(c) ? c : {});
        this.el = f(a);
        this.pt = [];
        this.g = {};
        this.h = {};
        this.hasFocus = !1;
        for (var z = 0; z < d.length; ++z) {
            p[d[z]] = [];
        }
        h || (m("mouseenter", [ 0, 2, 4 ], function(a) {
            g.hasFocus || e(l, a);
            q = "sxy-hover";
            l(a);
        }), m("mouseleave", [ 1, 2, 5 ], function(a) {
            u.down ? q = "sxy-up" : q = "sxy-hover";
            u.down = !1;
            l(a);
            k(l, a);
        }), m("mousedown", [ 3, 4 ], function(a) {
            q = "sxy-down";
            u.down = !0;
            l(a);
            q = "sxy-move";
        }), m("mouseup", [ 0, 1, 2, 3, 4, 5 ], function(a) {
            q = "sxy-up";
            u.down = !1;
            l(a);
            q = "sxy-hover";
        }), m("mousemove", [ 2, 4 ], l));
        m("touchstart", [ 0, 1, 2, 3, 4, 5 ], function(a) {
            q = "sxy-down";
            g.hasFocus || e(n, a);
            n(a);
            q = "sxy-move";
        });
        m("touchend", [ 0, 1, 2, 3, 4, 5 ], function(a) {
            q = "sxy-up";
            v = a;
            var b = a.originalEvent.targetTouches;
            a = a.originalEvent.changedTouches;
            for (var d = g.pt = [], c = 0, e = b.length; c < e; ++c) {
                d.push({
                    x: b[c].pageX,
                    y: b[c].pageY,
                    type: 1,
                    down: !0
                });
            }
            c = 0;
            for (e = a.length; c < e; ++c) {
                d.push({
                    x: a[c].pageX,
                    y: a[c].pageY,
                    type: 1,
                    down: !1
                });
            }
            g.trigger(q);
            q = "sxy-hover";
        });
        m("touchmove", [ 0, 1, 2, 3, 4, 5 ], n);
        var A = function(a) {
            for (var b = !0, c = g.pt, d = 0, e = c.length; d < e; ++d) {
                if (!0 == c[d].down) {
                    b = !1;
                    break;
                }
            }
            b && k(n, a);
        }, E = f.Event;
        this.trigger = function(a, b) {
            this.options.preventDefault && v.preventDefault();
            b = b || {};
            b.pointers = g.pt;
            b.originalEvent = v;
            g.el.trigger(E(a, b));
        };
        this.eventEnabler = function(a, b) {
            for (var d, c = p[a], e = b ? 1 : -1, k = 0, h = c.length; k < h; ++k) {
                switch ((d = c[k]).l += e) {
                  case 0:
                    d.el.off(d.e, d.hnd);
                    break;

                  case 1:
                    d.el.on(d.e, d.hnd);
                }
            }
        };
        g.focus = e;
        g.blur = k;
    }
    for (var g = navigator.userAgent.toLowerCase(), h = -1 < g.indexOf("android") && -1 < g.indexOf("mobile"), a = "swinxytouch", b = {
        preventDefault: !0,
        stopPropagation: !1
    }, d = "sxy-focus sxy-blur sxy-hover sxy-down sxy-move sxy-up".split(" "), g = function(a) {
        return function() {
            c(this).eventEnabler(a, !0);
        };
    }, l = function(a) {
        return function() {
            c(this).eventEnabler(a, !1);
        };
    }, m = 0, n = d.length; m < n; ++m) {
        var k = d[m];
        f.event.special[k] = {
            setup: g(k),
            teardown: l(k)
        };
    }
    f.fn[a] = function(a) {
        return this.each(function() {
            var b = c(this, a);
            a && b[a] && b[a].apply(b, Array.prototype.slice.call(arguments, 1));
        });
    };
    f.fn[a].g = function(a, b, d) {
        f.event.special[a] = {
            setup: function() {
                var e = c(this), k;
                k = e.g[a] = new b(e, e.options[a] ? f.extend({}, d, e.options[a]) : d);
                f.each(k, function(a, b) {
                    if ("sxy-" == a.substr(0, 4)) {
                        e.el.on(a, k[a]);
                    }
                });
            },
            teardown: function() {
                var b = c(this), d = b.g[a];
                f.each(d, function(a, c) {
                    "sxy-" == a.substr(0, 4) && b.el.off(a, d[a]);
                });
                b.g[a] = null;
            }
        };
    };
    f.fn[a].d = function(a, b) {
        var d = a.x - b.x, c = a.y - b.y;
        return Math.sqrt(d * d + c * c);
    };
    f.fn[a].a = function(a, b) {
        var d;
        return 0 < (d = Math.atan2(a.y - b.y, a.x - b.x)) ? 180 / Math.PI * d : 180 / Math.PI * (2 * Math.PI + d);
    };
    f.fn[a].h = function(a, b) {
        e.prototype[a] = function() {
            this.h[a] = new b(this);
        };
    };
    f.fn[a].m = function(a, b) {
        return {
            x: (a.x + b.x) / 2,
            y: (a.y + b.y) / 2
        };
    };
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-doubletap", function(c, e) {
        var g = Math.abs, h, a;
        this["sxy-tap"] = function(b) {
            b = b.position;
            null != h && new Date().getTime() - h < e.maxDelay && g(a.x - b.x) < e.maxMove && g(a.y - b.y) < e.maxMove ? (c.trigger("sxy-doubletap", {
                position: a
            }), h = null) : (h = new Date().getTime(), a = {
                x: b.x,
                y: b.y
            });
        };
    }, {
        maxDelay: 300,
        maxMove: 4
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-drag", function(c) {
        function e(a, b) {
            var d = a.pointers;
            h.state = b;
            0 < d.length && (h.position.x = d[0].x, h.position.y = d[0].y);
            c.trigger("sxy-drag", h);
        }
        var g, h = {
            position: {}
        };
        this["sxy-up"] = function(a) {
            g && e(a, 3);
            g = !1;
        };
        this["sxy-move"] = function(a) {
            1 == a.pointers.length && (g ? e(a, 2) : (g = !0, e(a, 1)));
        };
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-longpress", function(c, e) {
        var g, h = {}, a = function() {
            var a = c.pt, d = Math.abs;
            g = null;
            d(h.x - a[0].x) < e.maxMove && d(h.y - a[0].y) < e.maxMove && c.trigger("sxy-longpress", {
                position: h
            });
        };
        this["sxy-down"] = function(b) {
            b = b.pointers;
            h = {
                x: b[0].x,
                y: b[0].y
            };
            g && clearTimeout(g);
            g = setTimeout(a, e.minDelay);
        };
        this["sxy-up"] = function(a) {
            clearTimeout(g);
        };
    }, {
        minDelay: 1e3,
        maxMove: 5
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-rotate", function(c, e) {
        function g(b, e) {
            var k, h;
            l.state = e;
            l.rotation += 180 > Math.abs(k = (h = a(b.pointers[0], b.pointers[1])) - d) ? k : 0;
            d = h;
            c.trigger("sxy-rotate", l);
        }
        var h, a = f.fn.swinxytouch.a, b, d, l = {};
        this["sxy-down"] = function(c) {
            2 == c.pointers.length && (h = !1, b = d = a(c.pointers[0], c.pointers[1]));
        };
        this["sxy-up"] = function(a) {
            h && (h = !1, g(a, 3));
        };
        this["sxy-move"] = function(d) {
            var c = d.pointers;
            2 == c.length && (h ? g(d, 2) : Math.abs(b - a(c[0], c[1])) > e.minRotate && (h = !0, 
            l.rotation = 0, g(d, 1)));
        };
    }, {
        minRotate: 3
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-scale", function(c, e) {
        function g(b, e) {
            var k = b.pointers, g = h(k[0], k[1]);
            l.state = e;
            l.scale = g / d;
            l.distance = g - d;
            l.position = a(k[0], k[1]);
            c.trigger("sxy-scale", l);
        }
        var h = f.fn.swinxytouch.d, a = f.fn.swinxytouch.m, b, d, l = {};
        this["sxy-down"] = function(a) {
            a = a.pointers;
            2 == a.length && (b = !1, d = h({
                x: a[0].x,
                y: a[0].y
            }, {
                x: a[1].x,
                y: a[1].y
            }));
        };
        this["sxy-up"] = function(a) {
            b && g(a, 3);
        };
        this["sxy-move"] = function(a) {
            var c = a.pointers;
            2 == c.length && (b ? g(a, 2) : Math.abs(1 - h(c[0], c[1]) / d) > e.minScale && (b = !0, 
            g(a, 1)));
        };
    }, {
        minScale: .2
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-swipe", function(c, e) {
        var g = f.fn.swinxytouch.d, h = f.fn.swinxytouch.a, a = {}, b, d;
        this["sxy-down"] = function(a) {
            a = a.pointers;
            b = new Date().getTime();
            d = {
                x: a[0].x,
                y: a[0].y
            };
        };
        this["sxy-up"] = function(f) {
            f = f.pointers;
            new Date().getTime() - b < e.maxTime && g(d, f[0]) > e.minMove && (a.direction = e.map[Math.round(h(d, f[0]) / (360 / e.map.length)) % e.map.length], 
            a.distance = Math.abs(g(d, f[0])), c.trigger("sxy-swipe", a));
        };
    }, {
        maxTime: 300,
        minMove: 10,
        map: [ "left", "up", "right", "down" ]
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.g("sxy-tap", function(c, e) {
        var f = Math.abs, h, a;
        this["sxy-down"] = function(b) {
            b = b.pointers;
            1 == b.length && (h = new Date().getTime(), a = {
                x: b[0].x,
                y: b[0].y
            });
        };
        this["sxy-up"] = function(b) {
            b = b.pointers;
            1 == b.length && new Date().getTime() - h < e.maxDelay && f(a.x - b[0].x) < e.maxMove && f(a.y - b[0].y) < e.maxMove && c.trigger("sxy-tap", {
                position: a
            });
        };
    }, {
        maxDelay: 150,
        maxMove: 2
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.h("bound", function(c) {
        var e = c.el.offset(), g = e.left, h = e.top, a = g + c.el.width(), b = h + c.el.height();
        c.el.on("sxy-hover sxy-down sxy-up sxy-move sxy-focus", function(d) {
            var e = d.pointers[0];
            e.y < h || e.x > a || e.y > b || e.x < g ? c.hasFocus && c.blur() : c.hasFocus || (c.focus(), 
            c.el.trigger(f.Event("sxy-focus", {
                pointers: d.pointers,
                originalEvent: d.originalEvent
            })));
        });
    });
})(jQuery);

(function(f, p) {
    f.fn.swinxytouch.h("smartclick", function(c) {
        var e = this;
        e.allow = !1;
        e._hndClick = function(c) {
            e.allow || c.preventDefault();
            e.allow = !1;
        };
        e._hndTap = function(c) {
            e.allow = !0;
            f(c.originalEvent.target).trigger("click");
        };
        c.el.on("click", e._hndClick);
        c.el.on("sxy-tap", e._hndTap);
    });
})(jQuery);

(function(f, p) {
    function c(c, a) {
        this.e = c.get(0);
        this.j = c.first();
        a != p && f.extend(this, a);
    }
    function e(c, a) {
        var b = this;
        b.element = f(c);
        b.options = f.extend({}, g, a);
        b.driver = new f.fn.swinxyzoom.modes[b.options.mode](this);
        b.initialised = !1;
        b.enabled = !1;
        b.waiting = null;
        b.element.css({
            cursor: "default"
        });
        b.dmp = {
            cX: 0,
            tX: 0,
            cY: 0,
            tY: 0,
            timer: !1
        };
        b.last = !1;
        b.hasFocus = !1;
        b._animate = function() {
            var a = b.dmp, c = b.si.e.style, d = b.options.damping, e = a.tX - a.cX, h = a.tY - a.cY;
            c.left = (a.cX += e / d) + "px";
            c.top = (a.cY += h / d) + "px";
            0 == ~~e && 0 == ~~h && (clearTimeout(a.timer), a.timer = !1);
        };
        b._moveSlider = function(a) {
            a = a.pointers[0].y;
            var c = b.ct.sl.j.offset(), d = b.maxZoom / b.ct.sl.j.height();
            a = b.ct.sl.j.height() - (a - c.top);
            b.zoom(a * d, b.cursor.lastX, b.cursor.lastY);
        };
        b._focus = function() {
            var a = b.dp.j.offset();
            b.dp.ol = a.left;
            b.dp.ot = a.top;
            b.hasFocus = !0;
            b.options.controls && (b.ct.j.show(), b.ct.ol.j.stop().animate({
                opacity: .5
            }, {
                queue: !1
            }), b.ct.j.show());
            !1 === b.last || b.last.w == b.rt.j.width() && b.last.h == b.rt.j.height() || b.rebuild(function() {
                b.zoom(b.maxZoom, b.cursor.lastX, b.cursor.lastY);
                b.driver.load && b.driver.load(b.cursor.lastX, b.cursor.lastY);
                b.zoom(b.maxZoom, b.cursor.lastX, b.cursor.lastY);
            });
            b.last = {
                w: b.rt.j.width(),
                h: b.rt.j.height()
            };
        };
        b._blur = function(a) {
            b.hasFocus = !1;
            b.options.controls && (b.ct.j.hide(), b.ct.ol.j.stop().animate({
                opacity: 0
            }, {
                queue: !1,
                complete: function() {}
            }));
        };
        b._mousewheel = function(a, c, d, e) {
            a.preventDefault();
            b.zoom(b.level + Math.round(b.maxZoom / b.options.steps * e), a.pageX, a.pageY);
        };
        b._stepIn = function(a) {
            a.preventDefault();
            b.zoom(b.level + Math.round(b.maxZoom / b.options.steps * 1), b.cursor.lastX, b.cursor.lastY);
        };
        b._stepOut = function(a) {
            a.preventDefault();
            b.zoom(b.level + Math.round(b.maxZoom / b.options.steps * -1), b.cursor.lastX, b.cursor.lastY);
        };
        var d;
        b._scale = [];
        b._scale[1] = function(a) {
            d = b.level;
            f("#info").append("start[" + d + "] ");
        };
        b._scale[2] = function(a) {
            f("#info").append("s ");
            f("#info").append("s[" + Math.abs(d * a.scale) + "," + a.position.x + "] ");
            b.zoom(d * a.scale, a.position.x, a.position.y);
        };
        b._scale[3] = function(a) {};
        var e = b.element.children().first().attr("src"), m = b.element.attr("href"), n = new Image();
        n.onload = function() {
            b.load(e, m);
        };
        n.src = e;
    }
    var g = {
        damping: 8,
        steps: 15,
        mode: "dock",
        zoom: 15,
        controls: !0,
        size: "actual"
    };
    e.prototype.load = function(c, a, b) {
        var d = this;
        c || (c = d.dp.tn.src);
        a || (a = d.si.src);
        var e = function() {
            b && d._focus();
            if (d.dp && d.dp.tn) {
                d.dp.tn.src = c;
            } else {
                return;
            }
            d.si.src = a;
            d.dp.tn.j.attr("src") != d.dp.tn.src && (d.dp.tn.j.one("load", function() {
                "actual" == d.options.size && d.rt.j.css({
                    width: d.dp.tn.j.width(),
                    height: d.dp.tn.j.height()
                });
                d.dp.tn.j.stop().animate({
                    opacity: 1
                }, {
                    queue: !1,
                    complete: function() {
                        d.rt.bg.j.attr("src", d.dp.tn.src);
                        d.dp.tn.j.css({
                            opacity: 0
                        });
                    }
                });
            }), d.dp.tn.j.attr("src", d.dp.tn.src));
            var e = function(a, b) {
                var c;
                d.si.j.one("load", function() {
                    d.dp.j.off("sxy-move sxy-hover", c);
                    d.waiting = null;
                    d.rebuild(function() {
                        d.zoom(d.maxZoom / d.options.steps * d.options.zoom, d.cursor.lastX, d.cursor.lastY);
                        d.driver.load && d.driver.load(d.cursor.lastX, d.cursor.lastY);
                        d.zoom(d.maxZoom / d.options.steps * d.options.zoom, d.cursor.lastX, d.cursor.lastY);
                        d.rt.j.toggleClass("sxy-zoom-loading");
                    });
                });
                d.cursor = {
                    lastX: a,
                    lastY: b
                };
                d.dp.j.on("sxy-move sxy-hover", c = function(a) {
                    a = a.pointers[0];
                    d.cursor = {
                        lastX: a.x,
                        lastY: a.y
                    };
                });
                d.si.j.attr("src", d.si.src);
            };
            if (b) {
                d.waiting = null, d.rt.j.toggleClass("sxy-zoom-loading"), e(0, 0);
            } else {
                if (!d.waiting) {
                    d.rt.j.one("sxy-focus", d.waiting = function(a) {
                        d.rt.j.toggleClass("sxy-zoom-loading");
                        e(a.pointers[0].x, a.pointers[0].y);
                    });
                }
            }
        };
        !1 == d.initialised ? d.tearUp(e) : e();
    };
    e.prototype.getNaturalSize = function(c, a) {
        var b = new Image();
        b.onload = function() {
            a({
                w: b.width,
                h: b.height
            });
        };
        b.src = c;
    };
    e.prototype.rebuild = function(c) {
        var a = this, b = a.dp, d = a.vp, e = a.si, g = a.vf;
        f.extend(b, {
            w: "actual" == a.options.size ? b.tn.j.width() : a.rt.j.width(),
            h: "actual" == a.options.size ? b.tn.j.height() : a.rt.j.height(),
            ol: b.j.offset().left,
            ot: b.j.offset().top,
            hyp: Math.round(Math.sqrt(Math.pow(b.tn.j.width(), 2) + Math.pow(b.tn.j.height(), 2)))
        });
        switch (a.options.size) {
          case "actual":
            a.rt.j.css({
                width: b.w,
                height: b.h
            });
            break;

          case "src":
            a.rt.j.css({
                width: b.w,
                height: b.h
            });
        }
        f.extend(d, {
            w: b.w,
            h: b.h
        });
        a.vp.j.css({
            width: b.w,
            height: b.h
        });
        a.getNaturalSize(a.si.src, function(d) {
            f.extend(e, {
                w: 0,
                h: 0,
                l: 0,
                t: 0,
                mL: 0,
                mT: 0,
                oHyp: Math.round(Math.sqrt(Math.pow(d.w, 2) + Math.pow(d.h, 2))),
                oH: d.h,
                oW: d.w
            });
            f.extend(g, {
                w: 0,
                h: 0,
                l: 0,
                t: 0
            });
            a.ct.sl.j.css({
                height: a.ct.sl.h = a.ct.j.height() - (a.ct.zin.j.outerHeight() + a.ct.zout.j.outerHeight())
            });
            a.ct.sl.h -= 16;
            clearTimeout(a.dmp.timer);
            a.dmp = {
                cX: 0,
                tX: 0,
                cY: 0,
                tY: 0,
                timer: !1
            };
            a.scale = Math.atan(a.si.oH / a.si.oW);
            a.angle = 0;
            a.maxZoom = e.oHyp - b.hyp;
            a.level = 0;
            c();
        });
    };
    e.prototype.tearUp = function(e) {
        var a = this;
        a.initialised = !0;
        a.el = new c(a.element);
        a.el.tn = new c(a.element.children());
        a.getNaturalSize(a.el.tn.j.attr("src"), function(b) {
            var d, g;
            switch (a.options.size) {
              case "actual":
                d = b.w + "px";
                g = b.h + "px";
                break;

              case "src":
                d = a.el.tn.j.attr("width") + "px";
                g = "auto";
                break;

              default:
                d = a.options.size, g = "auto";
            }
            var m = {
                w: d,
                h: g,
                srcthumb: a.el.tn.j.attr("src"),
                mode: a.options.mode,
                auto: "auto" == g ? '<div style="padding-top: ' + 100 / b.w * b.h + '%;" />' : ""
            };
            a.el.j.wrap('<div class="sxy-zoom-container sxy-zoom-mode-{mode}" style="width: {w}; height: {h}; position: relative;" ></div>'.replace(/\{(\w+)\}/g, function(a, b) {
                return m[b] || a;
            }));
            a.element.hide();
            a.rt = new c(a.el.j.parent());
            a.rt.j.append('<img class="sxy-zoom-bg" src="{srcthumb}" />{auto}<div class="sxy-controls"><div class="overlay"></div><a class="in" href="#"></a><div class="sxy-slider"><div class="sxy-handle" style="top: 0px;"></div></div><a class="out" href="#"></a></div><div class="sxy-zoom-dragpad"><div class="sxy-overlay"></div><div class="sxy-zoom-viewport"><img galleryimg="no" /></div><img class="inner-thumb" src="{srcthumb}" /><div class="sxy-zoom-viewfinder"></div></div><div class="sxy-loading"><span></span></div>'.replace(/\{(\w+)\}/g, function(a, b) {
                return m[b] || a;
            }));
            a.rt.bg = new c(a.rt.j.find(".sxy-zoom-bg"));
            a.rt.j.on("dragstart", function(a) {
                return !1;
            });
            a.ct = new c(a.rt.j.find(".sxy-controls").hide());
            a.ct.ol = new c(a.ct.j.find(".overlay"));
            a.ct.zin = new c(a.ct.j.find(".in"));
            a.ct.zout = new c(a.ct.j.find(".out"));
            a.ct.sl = new c(a.ct.j.find(".sxy-slider").first(), {
                h: 0
            });
            a.ct.hnd = new c(a.ct.j.find(".sxy-handle"));
            a.dp = new c(a.rt.j.find(".sxy-zoom-dragpad").first(), {
                w: 0,
                h: 0,
                ol: 0,
                ot: 0,
                hyp: 0
            });
            a.dp.ovl = new c(a.dp.j.find(".sxy-overlay"));
            a.dp.tn = new c(a.dp.j.find(".inner-thumb").css({
                opacity: 0
            }), {
                src: ""
            });
            a.vp = new c(a.dp.j.find(".sxy-zoom-viewport").css({
                opacity: 0
            }), {
                w: 0,
                h: 0
            });
            a.si = new c(a.vp.j.find("img"), {
                w: 0,
                h: 0,
                l: 0,
                t: 0,
                mL: 0,
                mT: 0,
                oHyp: 0,
                oH: 0,
                oW: 0,
                src: ""
            });
            a.vf = new c(a.dp.j.find(".sxy-zoom-viewfinder").css({
                display: "none"
            }), {
                w: 0,
                h: 0,
                l: 0,
                t: 0,
                osl: 0,
                ost: 0
            });
            a.rt.j.on("sxy-focus", a._focus);
            a.rt.j.on("sxy-blur", a._blur);
            if (f.event.special.mousewheel) {
                a.rt.j.on("mousewheel", a._mousewheel);
            }
            a.dp.j.on("sxy-scale", function(b) {
                a._scale[b.state](b);
            });
            a.ct.zin.j.on("click", a._stepIn);
            a.ct.zout.j.on("click", a._stepOut);
            a.ct.sl.j.on("sxy-down sxy-move", a._moveSlider);
            e();
        });
    };
    e.prototype.move = function(c, a, b) {
        var d = c / this.scale * -1, e = a / this.scale * -1;
        this.cursor.lastX = d + this.vf.w / 2 + this.dp.ol;
        this.cursor.lastY = e + this.vf.h / 2 + this.dp.ot;
        0 > d && (d = c = 0);
        0 > e && (e = a = 0);
        d + this.vf.w > this.dp.w && (d = this.dp.w - this.vf.w, c = this.si.mL);
        e + this.vf.h > this.dp.h && (e = this.dp.h - this.vf.h, a = this.si.mT);
        this.vf.l = ~~d;
        this.vf.t = ~~e;
        this.dmp.tX = c;
        this.dmp.tY = a;
        b && !1 != this.options.damping ? this.dmp.timer || (this.dmp.timer = setInterval(this._animate, 16)) : (clearTimeout(this.dmp.timer), 
        this.dmp.timer = !1, b = this.si.e.style, b.left = (this.dmp.tX = this.dmp.cX = c) + "px", 
        b.top = (this.dmp.tY = this.dmp.cY = a) + "px");
    };
    e.prototype.center = function(c, a, b) {
        this.move(-1 * (c - this.vf.w / 2) * this.scale, -1 * (a - this.vf.h / 2) * this.scale, b);
    };
    e.prototype.zoom = function(c, a, b) {
        this.level = c;
        0 > this.level && (this.level = 0);
        this.level > this.maxZoom && (this.level = this.maxZoom);
        c = (this.si.oHyp - this.level) / this.si.oHyp * 100;
        this.ct.hnd.j.css({
            top: this.ct.sl.h - this.ct.sl.h / 100 * (this.level / this.maxZoom) * 100
        });
        this.vf.w = this.vp.w / 100 * c;
        this.vf.h = this.vp.h / 100 * c;
        this.vf.osl = parseInt(this.vf.j.css("border-left-width"), 10);
        this.vf.ost = parseInt(this.vf.j.css("border-top-width"), 10);
        this.scale = this.si.oW / this.vp.w / (this.si.oW / 100 * c / this.vp.w);
        this.si.w = this.si.oW / (this.si.oW / 100 * c / this.dp.w);
        this.si.h = this.si.oH / (this.si.oH / 100 * c / this.dp.h);
        this.vf.j.css({
            width: this.vf.w,
            height: this.vf.h
        });
        this.si.j.css({
            width: this.si.w,
            height: this.si.h
        });
        this.si.mL = 0 - (this.si.w - this.vp.w);
        this.si.mT = 0 - (this.si.h - this.vp.h);
        this.driver.zoom && this.driver.zoom(a, b);
    };
    f.fn.swinxyzoom = function(c) {
        var a = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var b;
            if (b = f.data(this, "swinxyzoom")) {
                if (b[c]) {
                    return b[c].apply(b, a);
                }
                f.error("Method " + c + " does not exist on jQuery.swinxyzoom");
            } else {
                f.data(this, "swinxyzoom", new e(this, c));
            }
        });
    };
    f.fn.swinxyzoom.modes = {};
})(jQuery);

(function(f, p) {
    function c(a) {
        var b = 0, c = 0, e;
        for (e in a) {
            ++b;
            for (var f = a[e], g = f.variations, h = 0, r = g.length; h < r; ++h) {
                if (document.createElement("div").style[g[h]] !== p) {
                    ++c;
                    f.supported = g[h];
                    break;
                }
            }
        }
        return b == c;
    }
    var e = {
        position: "right"
    }, g = !1, h = {
        backgroundSize: {
            supported: !1,
            variations: [ "backgroundSize", "WebkitBackgroundSize", "MozBackgroundSize", "OBackgroundSize", "msBackgroundSize" ]
        }
    };
    f.fn.swinxyzoom.modes.dock = function(a) {
        function b() {
            k && (k = !1, a.vf.j.hide(), a.dp.ovl.j.stop().animate({
                opacity: 0
            }, {
                queue: !1
            }), a.vp.j.stop().animate({
                opacity: 0,
                left: a.dp.w / 2,
                top: a.dp.h / 2,
                width: 0,
                height: 0
            }, {
                queue: !1
            }));
        }
        function d(b, c) {
            a.waiting || (k = !0, a.si.j.show(), a.vp.j.show(), a.vf.j.show(), a.dp.ovl.j.stop().animate({
                opacity: .5
            }, {
                queue: !1
            }), a.vp.j.stop().animate({
                opacity: 1,
                left: s,
                top: t,
                width: a.vp.w,
                height: a.vp.h
            }, {
                queue: !1
            }), r.move(b, c, !0));
        }
        function l() {
            a.rt.j.on("sxy-focus", function(a) {
                a = a.pointers[0];
                d(a.x, a.y);
            });
            a.rt.j.on("sxy-blur", function(a) {
                b();
            });
            a.dp.j.on("sxy-hover sxy-move sxy-down", B);
            if (!1 == w) {
                var c = f('<img src="" style="display: block; position: absolute;" />');
                a.vf.j.append(c);
                a.vf.img = {
                    j: c,
                    e: c.get(0)
                };
            }
            r.initialised = !0;
        }
        function m() {
            if (r.initialised) {
                var b = a.vf, c = a.vf.e.style;
                b.l != x || b.t != q ? (c.left = (x = b.l) + "px", c.top = (q = b.t) + "px", !1 == w ? (c = a.vf.img.e.style, 
                c.left = "-" + (b.l + b.osl) + "px", c.top = "-" + (b.t + b.ost) + "px") : c.backgroundPosition = "-" + (b.l + b.osl) + "px -" + (b.t + b.ost) + "px", 
                y = setTimeout(m, 8)) : y = !1;
            }
        }
        function n(c, e, f) {
            var g = a.dp.j.offset(), h = g.left, g = g.top, t = h + a.dp.j.width(), n = g + a.dp.j.height();
            e < g || c > t || e > n || c < h ? b() : (k || d(c, e), a.center(c - a.dp.ol, e - a.dp.ot, f), 
            y || m());
        }
        this.initialised = !1;
        g || (g = !0, h._all = c(h));
        var k = !1, r = this, s = 0, t = 0, w = h.backgroundSize.supported, B = function(a) {
            1 == a.pointers.length && (a = a.pointers[0], n(a.x, a.y, !0));
        }, C = f.extend({}, e, a.options.dock != p ? a.options.dock : {}), y = !1, x, q;
        r.tearUp = l;
        r.load = function(b, c) {
            switch (C.position) {
              case "top":
                s = 0;
                t = -1 * (a.dp.h + 10);
                break;

              case "right":
                s = a.dp.w + 10;
                t = 0;
                break;

              case "bottom":
                s = 0;
                t = a.dp.h + 10;
                break;

              case "left":
                s = -1 * (a.dp.w + 10), t = 0;
            }
            a.vp.j.css({
                width: 0,
                height: 0,
                left: a.dp.w / 2,
                top: a.dp.h / 2
            });
            a.dp.ovl.j.css({
                opacity: 0
            });
            a.vf.j.css({
                position: "relative",
                overflow: "hidden"
            });
            x = q = 0;
            r.initialised || l();
            !1 == w ? (a.vf.img.j.attr("src", a.dp.tn.src), a.vf.img.j.css({
                width: a.dp.w,
                height: a.dp.h
            })) : (a.vf.j.css("background-image", "url(" + a.dp.tn.src + ")"), a.vf.j.css(w, a.dp.w + "px " + a.dp.h + "px"));
            a.hasFocus && d(b, c);
        };
        r.focus = d;
        r.blur = b;
        r.move = n;
        r.zoom = function(a, b) {
            n(a, b, !1);
        };
    };
})(jQuery);

(function(f, p) {
    f.fn.swinxyzoom.modes.window = function(c) {
        function e(b, d) {
            c.waiting || (c.si.j.show(), c.vp.j.show(), c.vf.j.show(), c.vp.j.stop().animate({
                opacity: 1
            }, {
                queue: !1
            }), a(b, d, !0));
        }
        function g() {
            c.vf.j.hide();
            c.vp.j.stop().animate({
                opacity: 0
            }, {
                queue: !1
            });
        }
        function f() {
            var a = c.vf, b = c.vf.e.style;
            a.l != l || a.t != m ? (b.left = (l = a.l) + "px", b.top = (m = a.t) + "px", d = setTimeout(f, 8)) : d = !1;
        }
        function a(a, b, e) {
            c.center(a - c.dp.ol, b - c.dp.ot, e);
            d || f();
        }
        var b = this, d = this.initialised = !1, l, m;
        b.tearUp = function(b, d) {
            c.rt.j.on("sxy-focus", function(a) {
                e(a.pointers[0].x, a.pointers[0].y);
            });
            c.rt.j.on("sxy-blur", function() {
                g();
            });
            c.dp.j.on("sxy-hover sxy-move sxy-down", function(b) {
                1 == b.pointers.length && (b = b.pointers[0], a(b.x, b.y, !0));
            });
        };
        b.load = function(a, d) {
            c.vp.j.css({
                opacity: 0,
                width: c.dp.w,
                height: c.dp.h,
                left: 0,
                top: 0
            });
            l = m = 0;
            b.initialised || b.tearUp();
            c.hasFocus && b.focus(a, d);
        };
        b.focus = e;
        b.blur = g;
        b.move = a;
        b.zoom = function(b, c) {
            a(b, c, !1);
        };
    };
})(jQuery);

(function(f, p) {
    var c = {
        width: 200,
        height: 200
    };
    f.fn.swinxyzoom.modes.lens = function(e) {
        function g(a, b) {
            e.waiting || (l = !0, e.dp.j.on("sxy-hover sxy-move sxy-down", m), e.vp.j.show(), 
            e.vp.j.stop().animate({
                opacity: 1,
                width: e.vp.w,
                height: e.vp.h
            }, {
                queue: !1
            }), d.move(a, b, !0));
        }
        function h() {
            l && (l = !1, e.dp.j.off("sxy-hover sxy-move sxy-down", m), e.vp.j.stop().animate({
                opacity: 0
            }, {
                queue: !1,
                complete: function() {
                    e.vp.j.hide();
                }
            }));
        }
        function a() {
            var b = e.vf, c = e.vp, d = e.vp.e.style;
            b.l != r || b.t != s ? (d.left = e.cursor.lastX - e.dp.ol - c.w / 2 + "px", d.top = e.cursor.lastY - e.dp.ot - c.h / 2 + "px", 
            k = setTimeout(a, 8)) : k = !1;
        }
        function b(b, c, d) {
            e.center(b - e.dp.ol, c - e.dp.ot, d);
            k || a();
        }
        this.initialised = !1;
        var d = this, l = !0, m = function(a) {
            1 == a.pointers.length && (a = a.pointers[0], b(a.x, a.y, !0));
        }, n = f.extend({}, c, e.options.lens != p ? e.options.lens : {}), k = !1, r, s;
        d.tearUp = function(a, b) {
            e.dp.j.swinxytouch("bound");
            e.dp.j.on("sxy-focus", function(a) {
                g(a.pointers[0].x, a.pointers[0].y);
            });
            e.dp.j.on("sxy-blur", function() {
                h();
            });
        };
        d.load = function(a, b) {
            e.vp.j.css({
                opacity: 0,
                width: n.width,
                height: n.height,
                left: 0,
                top: 0
            });
            e.vp.w = n.width;
            e.vp.h = n.height;
            e.vp.j.show();
            e.si.j.show();
            e.vf.j.hide();
            r = s = 0;
            d.initialised || d.tearUp();
            e.hasFocus && g(a, b);
        };
        d.focus = g;
        d.blur = h;
        d.move = b;
        d.zoom = function(a, c) {
            b(a, c, !1);
        };
    };
})(jQuery);

(function(f, p) {
    f.fn.swinxyzoom.modes.slippy = function(c) {
        var e, f, h, a;
        function b() {
            c.dp.j.on("sxy-focus", function(a) {
                d(a.pointers[0].x, a.pointers[0].y);
            });
            c.dp.j.on("sxy-blur", function(a) {
                l();
            });
            c.dp.j.on("sxy-down", function(b) {
                c.dp.j.toggleClass("down");
                b = b.pointers[0];
                e = c.dmp.tX;
                f = c.dmp.tY;
                h = b.x - c.dp.ol;
                a = b.y - c.dp.ot;
            });
            c.dp.j.on("sxy-up", function(a) {
                c.dp.j.toggleClass("down");
            });
            c.dp.j.on("sxy-move", function(b) {
                b = b.pointers[0];
                c.move(e + (b.x - c.dp.ol - h), f + (b.y - c.dp.ot - a), !0);
                k || m();
            });
        }
        function d(a, b) {
            c.waiting || (c.si.j.show(), c.vp.j.show(), c.vf.j.show(), c.vp.j.stop().animate({
                opacity: 1
            }, {
                queue: !1
            }));
        }
        function l(a, b) {
            c.vf.j.hide();
            c.vp.j.animate({
                opacity: 0
            }, {
                queue: !1
            });
        }
        function m() {
            var a = c.vf, b = c.vf.e.style;
            a.l != p || a.t != s ? (b.left = (p = a.l) + "px", b.top = (s = a.t) + "px", k = setTimeout(m, 8)) : k = !1;
        }
        this.initialised = !1;
        var n = this;
        a = h = f = e = void 0;
        var k = !1, p, s;
        n.tearUp = b;
        n.load = function(k, l) {
            c.vp.j.css({
                opacity: 0,
                width: c.dp.w,
                height: c.dp.h,
                left: 0,
                top: 0
            });
            f = e = 0;
            h = k;
            a = l;
            c.center(c.dp.w / 2, c.dp.h / 2, !1);
            p = s = 0;
            n.initialised || b();
            c.hasFocus && d(k, l);
        };
        n.focus = d;
        n.blur = l;
        n.zoom = function(a, b) {
            c.center(c.cursor.lastX - c.dp.ol, c.cursor.lastY - c.dp.ot, !1);
            c.vf.j.css({
                left: c.vf.l,
                top: c.vf.t
            });
        };
    };
})(jQuery);

(function($) {
    $.fn.unveil = function(threshold, callback) {
        var $w = $(window), th = threshold || 0, retina = window.devicePixelRatio > 1, attrib = retina ? "data-src-retina" : "data-src", images = this, loaded;
        this.one("unveil", function() {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-src");
            if (source) {
                this.setAttribute("src", source);
                if (typeof callback === "function") callback.call(this);
            }
        });
        function unveil() {
            var inview = images.filter(function() {
                var $e = $(this);
                if ($e.is(":hidden")) return;
                var wt = $w.scrollTop(), wb = wt + $w.height(), et = $e.offset().top, eb = et + $e.height();
                return eb >= wt - th && et <= wb + th;
            });
            loaded = inview.trigger("unveil");
            images = images.not(loaded);
        }
        $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);
        unveil();
        return this;
    };
})(window.jQuery || window.Zepto);

(function(global) {
    var k, _handlers = {}, _mods = {
        16: false,
        18: false,
        17: false,
        91: false
    }, _scope = "all", _MODIFIERS = {
        "⇧": 16,
        shift: 16,
        "⌥": 18,
        alt: 18,
        option: 18,
        "⌃": 17,
        ctrl: 17,
        control: 17,
        "⌘": 91,
        command: 91
    }, _MAP = {
        backspace: 8,
        tab: 9,
        clear: 12,
        enter: 13,
        "return": 13,
        esc: 27,
        escape: 27,
        space: 32,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        del: 46,
        "delete": 46,
        home: 36,
        end: 35,
        pageup: 33,
        pagedown: 34,
        ",": 188,
        ".": 190,
        "/": 191,
        "`": 192,
        "-": 189,
        "=": 187,
        ";": 186,
        "'": 222,
        "[": 219,
        "]": 221,
        "\\": 220
    }, code = function(x) {
        return _MAP[x] || x.toUpperCase().charCodeAt(0);
    }, _downKeys = [];
    for (k = 1; k < 20; k++) _MAP["f" + k] = 111 + k;
    function index(array, item) {
        var i = array.length;
        while (i--) if (array[i] === item) return i;
        return -1;
    }
    function compareArray(a1, a2) {
        if (a1.length != a2.length) return false;
        for (var i = 0; i < a1.length; i++) {
            if (a1[i] !== a2[i]) return false;
        }
        return true;
    }
    var modifierMap = {
        16: "shiftKey",
        18: "altKey",
        17: "ctrlKey",
        91: "metaKey"
    };
    function updateModifierKey(event) {
        for (k in _mods) _mods[k] = event[modifierMap[k]];
    }
    function dispatch(event) {
        var key, handler, k, i, modifiersMatch, scope;
        key = event.keyCode;
        if (index(_downKeys, key) == -1) {
            _downKeys.push(key);
        }
        if (key == 93 || key == 224) key = 91;
        if (key in _mods) {
            _mods[key] = true;
            for (k in _MODIFIERS) if (_MODIFIERS[k] == key) assignKey[k] = true;
            return;
        }
        updateModifierKey(event);
        if (!assignKey.filter.call(this, event)) return;
        if (!(key in _handlers)) return;
        scope = getScope();
        for (i = 0; i < _handlers[key].length; i++) {
            handler = _handlers[key][i];
            if (handler.scope == scope || handler.scope == "all") {
                modifiersMatch = handler.mods.length > 0;
                for (k in _mods) if (!_mods[k] && index(handler.mods, +k) > -1 || _mods[k] && index(handler.mods, +k) == -1) modifiersMatch = false;
                if (handler.mods.length == 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || modifiersMatch) {
                    if (handler.method(event, handler) === false) {
                        if (event.preventDefault) event.preventDefault(); else event.returnValue = false;
                        if (event.stopPropagation) event.stopPropagation();
                        if (event.cancelBubble) event.cancelBubble = true;
                    }
                }
            }
        }
    }
    function clearModifier(event) {
        var key = event.keyCode, k, i = index(_downKeys, key);
        if (i >= 0) {
            _downKeys.splice(i, 1);
        }
        if (key == 93 || key == 224) key = 91;
        if (key in _mods) {
            _mods[key] = false;
            for (k in _MODIFIERS) if (_MODIFIERS[k] == key) assignKey[k] = false;
        }
    }
    function resetModifiers() {
        for (k in _mods) _mods[k] = false;
        for (k in _MODIFIERS) assignKey[k] = false;
    }
    function assignKey(key, scope, method) {
        var keys, mods;
        keys = getKeys(key);
        if (method === undefined) {
            method = scope;
            scope = "all";
        }
        for (var i = 0; i < keys.length; i++) {
            mods = [];
            key = keys[i].split("+");
            if (key.length > 1) {
                mods = getMods(key);
                key = [ key[key.length - 1] ];
            }
            key = key[0];
            key = code(key);
            if (!(key in _handlers)) _handlers[key] = [];
            _handlers[key].push({
                shortcut: keys[i],
                scope: scope,
                method: method,
                key: keys[i],
                mods: mods
            });
        }
    }
    function unbindKey(key, scope) {
        var multipleKeys, keys, mods = [], i, j, obj;
        multipleKeys = getKeys(key);
        for (j = 0; j < multipleKeys.length; j++) {
            keys = multipleKeys[j].split("+");
            if (keys.length > 1) {
                mods = getMods(keys);
            }
            key = keys[keys.length - 1];
            key = code(key);
            if (scope === undefined) {
                scope = getScope();
            }
            if (!_handlers[key]) {
                return;
            }
            for (i = 0; i < _handlers[key].length; i++) {
                obj = _handlers[key][i];
                if (obj.scope === scope && compareArray(obj.mods, mods)) {
                    _handlers[key][i] = {};
                }
            }
        }
    }
    function isPressed(keyCode) {
        if (typeof keyCode == "string") {
            keyCode = code(keyCode);
        }
        return index(_downKeys, keyCode) != -1;
    }
    function getPressedKeyCodes() {
        return _downKeys.slice(0);
    }
    function filter(event) {
        var tagName = (event.target || event.srcElement).tagName;
        return !(tagName == "INPUT" || tagName == "SELECT" || tagName == "TEXTAREA");
    }
    for (k in _MODIFIERS) assignKey[k] = false;
    function setScope(scope) {
        _scope = scope || "all";
    }
    function getScope() {
        return _scope || "all";
    }
    function deleteScope(scope) {
        var key, handlers, i;
        for (key in _handlers) {
            handlers = _handlers[key];
            for (i = 0; i < handlers.length; ) {
                if (handlers[i].scope === scope) handlers.splice(i, 1); else i++;
            }
        }
    }
    function getKeys(key) {
        var keys;
        key = key.replace(/\s/g, "");
        keys = key.split(",");
        if (keys[keys.length - 1] == "") {
            keys[keys.length - 2] += ",";
        }
        return keys;
    }
    function getMods(key) {
        var mods = key.slice(0, key.length - 1);
        for (var mi = 0; mi < mods.length; mi++) mods[mi] = _MODIFIERS[mods[mi]];
        return mods;
    }
    function addEvent(object, event, method) {
        if (object.addEventListener) object.addEventListener(event, method, false); else if (object.attachEvent) object.attachEvent("on" + event, function() {
            method(window.event);
        });
    }
    addEvent(document, "keydown", function(event) {
        dispatch(event);
    });
    addEvent(document, "keyup", clearModifier);
    addEvent(window, "focus", resetModifiers);
    var previousKey = global.key;
    function noConflict() {
        var k = global.key;
        global.key = previousKey;
        return k;
    }
    global.key = assignKey;
    global.key.setScope = setScope;
    global.key.getScope = getScope;
    global.key.deleteScope = deleteScope;
    global.key.filter = filter;
    global.key.isPressed = isPressed;
    global.key.getPressedKeyCodes = getPressedKeyCodes;
    global.key.noConflict = noConflict;
    global.key.unbind = unbindKey;
    if (typeof module !== "undefined") module.exports = assignKey;
})(this);

this.MutationObserver = this.MutationObserver || this.WebKitMutationObserver || function(v) {
    function m(a) {
        this.g = [];
        this.k = a;
    }
    function F(a) {
        (function c() {
            var d = a.takeRecords();
            d.length && a.k(d, a);
            a.f = setTimeout(c, m._period);
        })();
    }
    function r(a) {
        var b = {
            type: null,
            target: null,
            addedNodes: [],
            removedNodes: [],
            previousSibling: null,
            nextSibling: null,
            attributeName: null,
            attributeNamespace: null,
            oldValue: null
        }, c;
        for (c in a) b[c] !== v && a[c] !== v && (b[c] = a[c]);
        return b;
    }
    function G(a, b) {
        var c = A(a, b);
        return function(d) {
            var g = d.length;
            b.a && c.a && z(d, a, c.a, b.d);
            (b.c || b.e) && H(d, a, c, b);
            d.length !== g && (c = A(a, b));
        };
    }
    function z(a, b, c, d) {
        for (var g = {}, u = b.attributes, w, h, p = u.length; p--; ) w = u[p], h = w.name, 
        d && d[h] === v || (w.value !== c[h] && a.push(r({
            type: "attributes",
            target: b,
            attributeName: h,
            oldValue: c[h],
            attributeNamespace: w.namespaceURI
        })), g[h] = !0);
        for (h in c) g[h] || a.push(r({
            target: b,
            type: "attributes",
            attributeName: h,
            oldValue: c[h]
        }));
    }
    function H(a, b, c, d) {
        function g(b, c, g, n, x) {
            var m = b.length - 1;
            x = -~((m - x) / 2);
            for (var f, k, e; e = b.pop(); ) f = g[e.h], k = n[e.i], d.c && x && Math.abs(e.h - e.i) >= m && (a.push(r({
                type: "childList",
                target: c,
                addedNodes: [ f ],
                removedNodes: [ f ],
                nextSibling: f.nextSibling,
                previousSibling: f.previousSibling
            })), x--), d.a && k.a && z(a, f, k.a, d.d), d.b && 3 === f.nodeType && f.nodeValue !== k.b && a.push(r({
                type: "characterData",
                target: f,
                oldValue: k.b
            })), d.e && u(f, k);
        }
        function u(b, c) {
            for (var p = b.childNodes, n = c.c, m = p.length, v = n ? n.length : 0, f, k, e, l, s, y = 0, t = 0, q = 0; t < m || q < v; ) l = p[t], 
            s = (e = n[q]) && e.j, l === s ? (d.a && e.a && z(a, l, e.a, d.d), d.b && 3 === l.nodeType && l.nodeValue !== e.b && a.push(r({
                type: "characterData",
                target: l,
                oldValue: e.b
            })), k && g(k, b, p, n, y), d.e && (l.childNodes.length || e.c && e.c.length) && u(l, e), 
            t++, q++) : (f || (f = {}, k = []), l && (f[e = B(l)] || (f[e] = !0, -1 === (e = C(n, l, q, "j")) ? d.c && (a.push(r({
                type: "childList",
                target: b,
                addedNodes: [ l ],
                nextSibling: l.nextSibling,
                previousSibling: l.previousSibling
            })), y++) : k.push({
                h: t,
                i: e
            })), t++), s && s !== p[t] && (f[e = B(s)] || (f[e] = !0, -1 === (e = C(p, s, t)) ? d.c && (a.push(r({
                type: "childList",
                target: c.j,
                removedNodes: [ s ],
                nextSibling: n[q + 1],
                previousSibling: n[q - 1]
            })), y--) : k.push({
                h: e,
                i: q
            })), q++));
            k && g(k, b, p, n, y);
        }
        u(b, c);
    }
    function A(a, b) {
        var c = !0;
        return function g(a) {
            var m = 3 === a.nodeType, h = {
                j: a
            };
            m || 8 === a.nodeType ? m && b.b && (h.b = a.nodeValue) : (b.a && c && (h.a = D(a.attributes, function(a, c) {
                if (!b.d || b.d[c.name]) a[c.name] = c.value;
                return a;
            })), c && (b.c || b.b || b.a && b.e) && (h.c = I(a.childNodes, g)), c = b.e);
            return h;
        }(a);
    }
    function B(a) {
        try {
            return a.id || (a.mo_id = a.mo_id || E++);
        } catch (b) {
            try {
                return a.nodeValue;
            } catch (c) {
                return E++;
            }
        }
    }
    function I(a, b) {
        for (var c = [], d = 0; d < a.length; d++) c[d] = b(a[d], d, a);
        return c;
    }
    function D(a, b) {
        for (var c = {}, d = 0; d < a.length; d++) c = b(c, a[d], d, a);
        return c;
    }
    function C(a, b, c, d) {
        for (;c < a.length; c++) if ((d ? a[c][d] : a[c]) === b) return c;
        return -1;
    }
    m._period = 30;
    m.prototype = {
        observe: function(a, b) {
            for (var c = {
                a: !!(b.attributes || b.attributeFilter || b.attributeOldValue),
                c: !!b.childList,
                e: !!b.subtree,
                b: !(!b.characterData && !b.characterDataOldValue)
            }, d = this.g, g = 0; g < d.length; g++) d[g].m === a && d.splice(g, 1);
            b.attributeFilter && (c.d = D(b.attributeFilter, function(a, b) {
                a[b] = !0;
                return a;
            }));
            d.push({
                m: a,
                l: G(a, c)
            });
            this.f || F(this);
        },
        takeRecords: function() {
            for (var a = [], b = this.g, c = 0; c < b.length; c++) b[c].l(a);
            return a;
        },
        disconnect: function() {
            this.g = [];
            clearTimeout(this.f);
            this.f = null;
        }
    };
    var E = 1;
    return m;
}(void 0);

(function(global) {
    "use strict";
    var test = document.createElement("input");
    var nativeSupport = test.placeholder !== void 0;
    global.Placeholders = {
        nativeSupport: nativeSupport,
        disable: nativeSupport ? noop : disablePlaceholders,
        enable: nativeSupport ? noop : enablePlaceholders
    };
    if (nativeSupport) {
        return;
    }
    var validTypes = [ "text", "search", "url", "tel", "email", "password", "number", "textarea" ];
    var badKeys = [ 27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46 ];
    var placeholderStyleColor = "#ccc";
    var placeholderClassName = "placeholdersjs";
    var classNameRegExp = new RegExp("(?:^|\\s)" + placeholderClassName + "(?!\\S)");
    var ATTR_CURRENT_VAL = "data-placeholder-value";
    var ATTR_ACTIVE = "data-placeholder-active";
    var ATTR_INPUT_TYPE = "data-placeholder-type";
    var ATTR_FORM_HANDLED = "data-placeholder-submit";
    var ATTR_EVENTS_BOUND = "data-placeholder-bound";
    var ATTR_OPTION_FOCUS = "data-placeholder-focus";
    var ATTR_OPTION_LIVE = "data-placeholder-live";
    var ATTR_MAXLENGTH = "data-placeholder-maxlength";
    var UPDATE_INTERVAL = 100;
    var head = document.getElementsByTagName("head")[0];
    var root = document.documentElement;
    var Placeholders = global.Placeholders;
    var keydownVal;
    var inputs = document.getElementsByTagName("input");
    var textareas = document.getElementsByTagName("textarea");
    var hideOnInput = root.getAttribute(ATTR_OPTION_FOCUS) === "false";
    var liveUpdates = root.getAttribute(ATTR_OPTION_LIVE) !== "false";
    var styleElem = document.createElement("style");
    styleElem.type = "text/css";
    var styleRules = document.createTextNode("." + placeholderClassName + " {" + "color:" + placeholderStyleColor + ";" + "}");
    if (styleElem.styleSheet) {
        styleElem.styleSheet.cssText = styleRules.nodeValue;
    } else {
        styleElem.appendChild(styleRules);
    }
    head.insertBefore(styleElem, head.firstChild);
    var placeholder;
    var elem;
    for (var i = 0, len = inputs.length + textareas.length; i < len; i++) {
        elem = i < inputs.length ? inputs[i] : textareas[i - inputs.length];
        placeholder = elem.attributes.placeholder;
        if (placeholder) {
            placeholder = placeholder.nodeValue;
            if (placeholder && inArray(validTypes, elem.type)) {
                newElement(elem);
            }
        }
    }
    var timer = setInterval(function() {
        for (var i = 0, len = inputs.length + textareas.length; i < len; i++) {
            elem = i < inputs.length ? inputs[i] : textareas[i - inputs.length];
            placeholder = elem.attributes.placeholder;
            if (placeholder) {
                placeholder = placeholder.nodeValue;
                if (placeholder && inArray(validTypes, elem.type)) {
                    if (!elem.getAttribute(ATTR_EVENTS_BOUND)) {
                        newElement(elem);
                    }
                    if (placeholder !== elem.getAttribute(ATTR_CURRENT_VAL) || elem.type === "password" && !elem.getAttribute(ATTR_INPUT_TYPE)) {
                        if (elem.type === "password" && !elem.getAttribute(ATTR_INPUT_TYPE) && changeType(elem, "text")) {
                            elem.setAttribute(ATTR_INPUT_TYPE, "password");
                        }
                        if (elem.value === elem.getAttribute(ATTR_CURRENT_VAL)) {
                            elem.value = placeholder;
                        }
                        elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
                    }
                }
            } else if (elem.getAttribute(ATTR_ACTIVE)) {
                hidePlaceholder(elem);
                elem.removeAttribute(ATTR_CURRENT_VAL);
            }
        }
        if (!liveUpdates) {
            clearInterval(timer);
        }
    }, UPDATE_INTERVAL);
    addEventListener(global, "beforeunload", function() {
        Placeholders.disable();
    });
    function noop() {}
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function inArray(arr, item) {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr[i] === item) {
                return true;
            }
        }
        return false;
    }
    function addEventListener(elem, event, fn) {
        if (elem.addEventListener) {
            return elem.addEventListener(event, fn, false);
        }
        if (elem.attachEvent) {
            return elem.attachEvent("on" + event, fn);
        }
    }
    function moveCaret(elem, index) {
        var range;
        if (elem.createTextRange) {
            range = elem.createTextRange();
            range.move("character", index);
            range.select();
        } else if (elem.selectionStart) {
            elem.focus();
            elem.setSelectionRange(index, index);
        }
    }
    function changeType(elem, type) {
        try {
            elem.type = type;
            return true;
        } catch (e) {
            return false;
        }
    }
    function handleElem(node, callback) {
        if (node && node.getAttribute(ATTR_CURRENT_VAL)) {
            callback(node);
        } else {
            var handleInputs = node ? node.getElementsByTagName("input") : inputs;
            var handleTextareas = node ? node.getElementsByTagName("textarea") : textareas;
            var handleInputsLength = handleInputs ? handleInputs.length : 0;
            var handleTextareasLength = handleTextareas ? handleTextareas.length : 0;
            var len = handleInputsLength + handleTextareasLength;
            var elem;
            for (var i = 0; i < len; i++) {
                elem = i < handleInputsLength ? handleInputs[i] : handleTextareas[i - handleInputsLength];
                callback(elem);
            }
        }
    }
    function disablePlaceholders(node) {
        handleElem(node, hidePlaceholder);
    }
    function enablePlaceholders(node) {
        handleElem(node, showPlaceholder);
    }
    function hidePlaceholder(elem, keydownValue) {
        var valueChanged = !!keydownValue && elem.value !== keydownValue;
        var isPlaceholderValue = elem.value === elem.getAttribute(ATTR_CURRENT_VAL);
        if ((valueChanged || isPlaceholderValue) && elem.getAttribute(ATTR_ACTIVE) === "true") {
            elem.removeAttribute(ATTR_ACTIVE);
            elem.value = elem.value.replace(elem.getAttribute(ATTR_CURRENT_VAL), "");
            elem.className = elem.className.replace(classNameRegExp, "");
            var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
            if (parseInt(maxLength, 10) >= 0) {
                elem.setAttribute("maxLength", maxLength);
                elem.removeAttribute(ATTR_MAXLENGTH);
            }
            var type = elem.getAttribute(ATTR_INPUT_TYPE);
            if (type) {
                elem.type = type;
            }
            return true;
        }
        return false;
    }
    function showPlaceholder(elem) {
        var val = elem.getAttribute(ATTR_CURRENT_VAL);
        if (elem.value === "" && val) {
            elem.setAttribute(ATTR_ACTIVE, "true");
            elem.value = val;
            elem.className += " " + placeholderClassName;
            var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
            if (!maxLength) {
                elem.setAttribute(ATTR_MAXLENGTH, elem.maxLength);
                elem.removeAttribute("maxLength");
            }
            var type = elem.getAttribute(ATTR_INPUT_TYPE);
            if (type) {
                elem.type = "text";
            } else if (elem.type === "password" && changeType(elem, "text")) {
                elem.setAttribute(ATTR_INPUT_TYPE, "password");
            }
            return true;
        }
        return false;
    }
    function makeFocusHandler(elem) {
        return function() {
            if (hideOnInput && elem.value === elem.getAttribute(ATTR_CURRENT_VAL) && elem.getAttribute(ATTR_ACTIVE) === "true") {
                moveCaret(elem, 0);
            } else {
                hidePlaceholder(elem);
            }
        };
    }
    function makeBlurHandler(elem) {
        return function() {
            showPlaceholder(elem);
        };
    }
    function makeSubmitHandler(form) {
        return function() {
            disablePlaceholders(form);
        };
    }
    function makeKeydownHandler(elem) {
        return function(e) {
            keydownVal = elem.value;
            if (elem.getAttribute(ATTR_ACTIVE) === "true" && keydownVal === elem.getAttribute(ATTR_CURRENT_VAL) && inArray(badKeys, e.keyCode)) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                return false;
            }
        };
    }
    function makeKeyupHandler(elem) {
        return function() {
            hidePlaceholder(elem, keydownVal);
            if (elem.value === "") {
                elem.blur();
                moveCaret(elem, 0);
            }
        };
    }
    function makeClickHandler(elem) {
        return function() {
            if (elem === safeActiveElement() && elem.value === elem.getAttribute(ATTR_CURRENT_VAL) && elem.getAttribute(ATTR_ACTIVE) === "true") {
                moveCaret(elem, 0);
            }
        };
    }
    function newElement(elem) {
        var form = elem.form;
        if (form && typeof form === "string") {
            form = document.getElementById(form);
            if (!form.getAttribute(ATTR_FORM_HANDLED)) {
                addEventListener(form, "submit", makeSubmitHandler(form));
                form.setAttribute(ATTR_FORM_HANDLED, "true");
            }
        }
        addEventListener(elem, "focus", makeFocusHandler(elem));
        addEventListener(elem, "blur", makeBlurHandler(elem));
        if (hideOnInput) {
            addEventListener(elem, "keydown", makeKeydownHandler(elem));
            addEventListener(elem, "keyup", makeKeyupHandler(elem));
            addEventListener(elem, "click", makeClickHandler(elem));
        }
        elem.setAttribute(ATTR_EVENTS_BOUND, "true");
        elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
        if (hideOnInput || elem !== safeActiveElement()) {
            showPlaceholder(elem);
        }
    }
})(this);

(function($, global) {
    "use strict";
    var originalValFn = $.fn.val;
    var originalPropFn = $.fn.prop;
    if (!global.Placeholders.nativeSupport) {
        $.fn.val = function(val) {
            var originalValue = originalValFn.apply(this, arguments);
            var placeholder = this.eq(0).data("placeholder-value");
            if (val === undefined && this.eq(0).data("placeholder-active") && originalValue === placeholder) {
                return "";
            }
            return originalValue;
        };
        $.fn.prop = function(name, val) {
            if (val === undefined && this.eq(0).data("placeholder-active") && name === "value") {
                return "";
            }
            return originalPropFn.apply(this, arguments);
        };
    }
})(jQuery, this);

(function() {
    var lastTime = 0;
    var vendors = [ "ms", "moz", "webkit", "o" ];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
        window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
    }
    if (!window.requestAnimationFrame) window.requestAnimationFrame = function(callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
    };
})();

(function() {
    function a(a, c, d, e) {
        return new b(a, c, d, e);
    }
    function b(a, b, d, e) {
        this.options = e || {}, this.options.adapters = this.options.adapters || {}, this.obj = a, 
        this.keypath = b, this.callback = d, this.objectPath = [], this.parse(), c(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback);
    }
    function c(a) {
        return "object" == typeof a && null !== a;
    }
    function d(a) {
        throw new Error("[sightglass] " + a);
    }
    a.adapters = {}, b.tokenize = function(a, b, c) {
        var d, e, f = [], g = {
            i: c,
            path: ""
        };
        for (d = 0; d < a.length; d++) e = a.charAt(d), ~b.indexOf(e) ? (f.push(g), g = {
            i: e,
            path: ""
        }) : g.path += e;
        return f.push(g), f;
    }, b.prototype.parse = function() {
        var c, e, f = this.interfaces();
        f.length || d("Must define at least one adapter interface."), ~f.indexOf(this.keypath[0]) ? (c = this.keypath[0], 
        e = this.keypath.substr(1)) : ("undefined" == typeof (c = this.options.root || a.root) && d("Must define a default root adapter."), 
        e = this.keypath), this.tokens = b.tokenize(e, f, c), this.key = this.tokens.pop();
    }, b.prototype.realize = function() {
        var a, b = this.obj, d = !1;
        return this.tokens.forEach(function(e, f) {
            c(b) ? ("undefined" != typeof this.objectPath[f] ? b !== (a = this.objectPath[f]) && (this.set(!1, e, a, this.update.bind(this)), 
            this.set(!0, e, b, this.update.bind(this)), this.objectPath[f] = b) : (this.set(!0, e, b, this.update.bind(this)), 
            this.objectPath[f] = b), b = this.get(e, b)) : (d === !1 && (d = f), (a = this.objectPath[f]) && this.set(!1, e, a, this.update.bind(this)));
        }, this), d !== !1 && this.objectPath.splice(d), b;
    }, b.prototype.update = function() {
        var a, b;
        (a = this.realize()) !== this.target && (c(this.target) && this.set(!1, this.key, this.target, this.callback), 
        c(a) && this.set(!0, this.key, a, this.callback), b = this.value(), this.target = a, 
        this.value() !== b && this.callback());
    }, b.prototype.value = function() {
        return c(this.target) ? this.get(this.key, this.target) : void 0;
    }, b.prototype.setValue = function(a) {
        c(this.target) && this.adapter(this.key).set(this.target, this.key.path, a);
    }, b.prototype.get = function(a, b) {
        return this.adapter(a).get(b, a.path);
    }, b.prototype.set = function(a, b, c, d) {
        var e = a ? "observe" : "unobserve";
        this.adapter(b)[e](c, b.path, d);
    }, b.prototype.interfaces = function() {
        var b = Object.keys(this.options.adapters);
        return Object.keys(a.adapters).forEach(function(a) {
            ~b.indexOf(a) || b.push(a);
        }), b;
    }, b.prototype.adapter = function(b) {
        return this.options.adapters[b.i] || a.adapters[b.i];
    }, b.prototype.unobserve = function() {
        var a;
        this.tokens.forEach(function(b, c) {
            (a = this.objectPath[c]) && this.set(!1, b, a, this.update.bind(this));
        }, this), c(this.target) && this.set(!1, this.key, this.target, this.callback);
    }, "undefined" != typeof module && module.exports ? module.exports = a : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = a;
    }) : this.sightglass = a;
}).call(this), function() {
    var a, b, c, d, e = function(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    }, f = [].slice, g = {}.hasOwnProperty, h = function(a, b) {
        function c() {
            this.constructor = a;
        }
        for (var d in b) g.call(b, d) && (a[d] = b[d]);
        return c.prototype = b.prototype, a.prototype = new c(), a.__super__ = b.prototype, 
        a;
    }, i = [].indexOf || function(a) {
        for (var b = 0, c = this.length; c > b; b++) if (b in this && this[b] === a) return b;
        return -1;
    };
    a = {
        options: [ "prefix", "templateDelimiters", "rootInterface", "preloadData", "handler" ],
        extensions: [ "binders", "formatters", "components", "adapters" ],
        "public": {
            binders: {},
            components: {},
            formatters: {},
            adapters: {},
            prefix: "rv",
            templateDelimiters: [ "{", "}" ],
            rootInterface: ".",
            preloadData: !0,
            handler: function(a, b, c) {
                return this.call(a, b, c.view.models);
            },
            configure: function(b) {
                var c, d, e, f;
                null == b && (b = {});
                for (e in b) if (f = b[e], "binders" === e || "components" === e || "formatters" === e || "adapters" === e) for (d in f) c = f[d], 
                a[e][d] = c; else a["public"][e] = f;
            },
            bind: function(b, c, d) {
                var e;
                return null == c && (c = {}), null == d && (d = {}), e = new a.View(b, c, d), e.bind(), 
                e;
            },
            init: function(b, c, d) {
                var e, f;
                return null == d && (d = {}), null == c && (c = document.createElement("div")), 
                b = a["public"].components[b], c.innerHTML = b.template.call(this, c), e = b.initialize.call(this, c, d), 
                f = new a.View(c, e), f.bind(), f;
            }
        }
    }, window.jQuery || window.$ ? (d = "on" in jQuery.prototype ? [ "on", "off" ] : [ "bind", "unbind" ], 
    b = d[0], c = d[1], a.Util = {
        bindEvent: function(a, c, d) {
            return jQuery(a)[b](c, d);
        },
        unbindEvent: function(a, b, d) {
            return jQuery(a)[c](b, d);
        },
        getInputValue: function(a) {
            var b;
            return b = jQuery(a), "checkbox" === b.attr("type") ? b.is(":checked") : b.val();
        }
    }) : a.Util = {
        bindEvent: function() {
            return "addEventListener" in window ? function(a, b, c) {
                return a.addEventListener(b, c, !1);
            } : function(a, b, c) {
                return a.attachEvent("on" + b, c);
            };
        }(),
        unbindEvent: function() {
            return "removeEventListener" in window ? function(a, b, c) {
                return a.removeEventListener(b, c, !1);
            } : function(a, b, c) {
                return a.detachEvent("on" + b, c);
            };
        }(),
        getInputValue: function(a) {
            var b, c, d, e;
            if ("checkbox" === a.type) return a.checked;
            if ("select-multiple" === a.type) {
                for (e = [], c = 0, d = a.length; d > c; c++) b = a[c], b.selected && e.push(b.value);
                return e;
            }
            return a.value;
        }
    }, a.TypeParser = function() {
        function a() {}
        return a.types = {
            primitive: 0,
            keypath: 1
        }, a.parse = function(a) {
            return /^'.*'$|^".*"$/.test(a) ? {
                type: this.types.primitive,
                value: a.slice(1, -1)
            } : "true" === a ? {
                type: this.types.primitive,
                value: !0
            } : "false" === a ? {
                type: this.types.primitive,
                value: !1
            } : "null" === a ? {
                type: this.types.primitive,
                value: null
            } : "undefined" === a ? {
                type: this.types.primitive,
                value: void 0
            } : isNaN(Number(a)) === !1 ? {
                type: this.types.primitive,
                value: Number(a)
            } : {
                type: this.types.keypath,
                value: a
            };
        }, a;
    }(), a.TextTemplateParser = function() {
        function a() {}
        return a.types = {
            text: 0,
            binding: 1
        }, a.parse = function(a, b) {
            var c, d, e, f, g, h, i;
            for (h = [], f = a.length, c = 0, d = 0; f > d; ) {
                if (c = a.indexOf(b[0], d), 0 > c) {
                    h.push({
                        type: this.types.text,
                        value: a.slice(d)
                    });
                    break;
                }
                if (c > 0 && c > d && h.push({
                    type: this.types.text,
                    value: a.slice(d, c)
                }), d = c + b[0].length, c = a.indexOf(b[1], d), 0 > c) {
                    g = a.slice(d - b[1].length), e = h[h.length - 1], (null != e ? e.type : void 0) === this.types.text ? e.value += g : h.push({
                        type: this.types.text,
                        value: g
                    });
                    break;
                }
                i = a.slice(d, c).trim(), h.push({
                    type: this.types.binding,
                    value: i
                }), d = c + b[1].length;
            }
            return h;
        }, a;
    }(), a.View = function() {
        function b(b, c, d) {
            var f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (this.els = b, this.models = c, null == d && (d = {}), this.update = e(this.update, this), 
            this.publish = e(this.publish, this), this.sync = e(this.sync, this), this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.select = e(this.select, this), this.traverse = e(this.traverse, this), 
            this.build = e(this.build, this), this.buildBinding = e(this.buildBinding, this), 
            this.bindingRegExp = e(this.bindingRegExp, this), this.options = e(this.options, this), 
            this.els.jquery || this.els instanceof Array || (this.els = [ this.els ]), n = a.extensions, 
            j = 0, l = n.length; l > j; j++) {
                if (g = n[j], this[g] = {}, d[g]) {
                    o = d[g];
                    for (f in o) h = o[f], this[g][f] = h;
                }
                p = a["public"][g];
                for (f in p) h = p[f], null == (i = this[g])[f] && (i[f] = h);
            }
            for (q = a.options, k = 0, m = q.length; m > k; k++) g = q[k], this[g] = null != (r = d[g]) ? r : a["public"][g];
            this.build();
        }
        return b.prototype.options = function() {
            var b, c, d, e, f;
            for (c = {}, f = a.extensions.concat(a.options), d = 0, e = f.length; e > d; d++) b = f[d], 
            c[b] = this[b];
            return c;
        }, b.prototype.bindingRegExp = function() {
            return new RegExp("^" + this.prefix + "-");
        }, b.prototype.buildBinding = function(b, c, d, e) {
            var f, g, h, i, j, k, l;
            return j = {}, l = function() {
                var a, b, c, d;
                for (c = e.split("|"), d = [], a = 0, b = c.length; b > a; a++) k = c[a], d.push(k.trim());
                return d;
            }(), f = function() {
                var a, b, c, d;
                for (c = l.shift().split("<"), d = [], a = 0, b = c.length; b > a; a++) g = c[a], 
                d.push(g.trim());
                return d;
            }(), i = f.shift(), j.formatters = l, (h = f.shift()) && (j.dependencies = h.split(/\s+/)), 
            this.bindings.push(new a[b](this, c, d, i, j));
        }, b.prototype.build = function() {
            var b, c, d, e, f;
            for (this.bindings = [], c = function(b) {
                return function(d) {
                    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
                    if (3 === d.nodeType) {
                        if (i = a.TextTemplateParser, (g = b.templateDelimiters) && (l = i.parse(d.data, g)).length && (1 !== l.length || l[0].type !== i.types.text)) {
                            for (m = 0, o = l.length; o > m; m++) k = l[m], j = document.createTextNode(k.value), 
                            d.parentNode.insertBefore(j, d), 1 === k.type && b.buildBinding("TextBinding", j, null, k.value);
                            d.parentNode.removeChild(d);
                        }
                    } else 1 === d.nodeType && (e = b.traverse(d));
                    if (!e) {
                        for (q = function() {
                            var a, b, c, e;
                            for (c = d.childNodes, e = [], a = 0, b = c.length; b > a; a++) h = c[a], e.push(h);
                            return e;
                        }(), r = [], n = 0, p = q.length; p > n; n++) f = q[n], r.push(c(f));
                        return r;
                    }
                };
            }(this), f = this.els, d = 0, e = f.length; e > d; d++) b = f[d], c(b);
            this.bindings.sort(function(a, b) {
                var c, d;
                return ((null != (c = b.binder) ? c.priority : void 0) || 0) - ((null != (d = a.binder) ? d.priority : void 0) || 0);
            });
        }, b.prototype.traverse = function(b) {
            var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
            for (f = this.bindingRegExp(), g = "SCRIPT" === b.nodeName || "STYLE" === b.nodeName, 
            p = b.attributes, l = 0, n = p.length; n > l; l++) if (c = p[l], f.test(c.name)) {
                if (j = c.name.replace(f, ""), !(e = this.binders[j])) {
                    q = this.binders;
                    for (h in q) k = q[h], "*" !== h && -1 !== h.indexOf("*") && (i = new RegExp("^" + h.replace(/\*/g, ".+") + "$"), 
                    i.test(j) && (e = k));
                }
                e || (e = this.binders["*"]), e.block && (g = !0, d = [ c ]);
            }
            for (r = d || b.attributes, m = 0, o = r.length; o > m; m++) c = r[m], f.test(c.name) && (j = c.name.replace(f, ""), 
            this.buildBinding("Binding", b, j, c.value));
            return g || (j = b.nodeName.toLowerCase(), this.components[j] && !b._bound && (this.bindings.push(new a.ComponentBinding(this, b, j)), 
            g = !0)), g;
        }, b.prototype.select = function(a) {
            var b, c, d, e, f;
            for (e = this.bindings, f = [], c = 0, d = e.length; d > c; c++) b = e[c], a(b) && f.push(b);
            return f;
        }, b.prototype.bind = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.bind());
            return e;
        }, b.prototype.unbind = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.unbind());
            return e;
        }, b.prototype.sync = function() {
            var a, b, c, d, e;
            for (d = this.bindings, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push("function" == typeof a.sync ? a.sync() : void 0);
            return e;
        }, b.prototype.publish = function() {
            var a, b, c, d, e;
            for (d = this.select(function(a) {
                var b;
                return null != (b = a.binder) ? b.publishes : void 0;
            }), e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.publish());
            return e;
        }, b.prototype.update = function(a) {
            var b, c, d, e, f, g, h;
            null == a && (a = {});
            for (c in a) d = a[c], this.models[c] = d;
            for (g = this.bindings, h = [], e = 0, f = g.length; f > e; e++) b = g[e], h.push("function" == typeof b.update ? b.update(a) : void 0);
            return h;
        }, b;
    }(), a.Binding = function() {
        function b(a, b, c, d, f) {
            this.view = a, this.el = b, this.type = c, this.keypath = d, this.options = null != f ? f : {}, 
            this.getValue = e(this.getValue, this), this.update = e(this.update, this), this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.publish = e(this.publish, this), this.sync = e(this.sync, this), 
            this.set = e(this.set, this), this.eventHandler = e(this.eventHandler, this), this.formattedValue = e(this.formattedValue, this), 
            this.parseTarget = e(this.parseTarget, this), this.observe = e(this.observe, this), 
            this.setBinder = e(this.setBinder, this), this.formatters = this.options.formatters || [], 
            this.dependencies = [], this.formatterObservers = {}, this.model = void 0, this.setBinder();
        }
        return b.prototype.setBinder = function() {
            var a, b, c, d;
            if (!(this.binder = this.view.binders[this.type])) {
                d = this.view.binders;
                for (a in d) c = d[a], "*" !== a && -1 !== a.indexOf("*") && (b = new RegExp("^" + a.replace(/\*/g, ".+") + "$"), 
                b.test(this.type) && (this.binder = c, this.args = new RegExp("^" + a.replace(/\*/g, "(.+)") + "$").exec(this.type), 
                this.args.shift()));
            }
            return this.binder || (this.binder = this.view.binders["*"]), this.binder instanceof Function ? this.binder = {
                routine: this.binder
            } : void 0;
        }, b.prototype.observe = function(b, c, d) {
            return a.sightglass(b, c, d, {
                root: this.view.rootInterface,
                adapters: this.view.adapters
            });
        }, b.prototype.parseTarget = function() {
            var b;
            return b = a.TypeParser.parse(this.keypath), 0 === b.type ? this.value = b.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync), 
            this.model = this.observer.target);
        }, b.prototype.formattedValue = function(b) {
            var c, d, e, g, h, i, j, k, l, m, n, o, p, q;
            for (q = this.formatters, g = m = 0, o = q.length; o > m; g = ++m) {
                for (h = q[g], e = h.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g), i = e.shift(), 
                h = this.view.formatters[i], e = function() {
                    var b, c, f;
                    for (f = [], b = 0, c = e.length; c > b; b++) d = e[b], f.push(a.TypeParser.parse(d));
                    return f;
                }(), k = [], c = n = 0, p = e.length; p > n; c = ++n) d = e[c], k.push(0 === d.type ? d.value : ((l = this.formatterObservers)[g] || (l[g] = {}), 
                (j = this.formatterObservers[g][c]) ? void 0 : (j = this.observe(this.view.models, d.value, this.sync), 
                this.formatterObservers[g][c] = j), j.value()));
                (null != h ? h.read : void 0) instanceof Function ? b = h.read.apply(h, [ b ].concat(f.call(k))) : h instanceof Function && (b = h.apply(null, [ b ].concat(f.call(k))));
            }
            return b;
        }, b.prototype.eventHandler = function(a) {
            var b, c;
            return c = (b = this).view.handler, function(d) {
                return c.call(a, this, d, b);
            };
        }, b.prototype.set = function(a) {
            var b;
            return a = this.formattedValue(a instanceof Function && !this.binder["function"] ? a.call(this.model) : a), 
            null != (b = this.binder.routine) ? b.call(this, this.el, a) : void 0;
        }, b.prototype.sync = function() {
            var a, b;
            return this.set(function() {
                var c, d, e, f, g, h, i;
                if (this.observer) {
                    if (this.model !== this.observer.target) {
                        for (g = this.dependencies, c = 0, e = g.length; e > c; c++) b = g[c], b.unobserve();
                        if (this.dependencies = [], null != (this.model = this.observer.target) && (null != (h = this.options.dependencies) ? h.length : void 0)) for (i = this.options.dependencies, 
                        d = 0, f = i.length; f > d; d++) a = i[d], b = this.observe(this.model, a, this.sync), 
                        this.dependencies.push(b);
                    }
                    return this.observer.value();
                }
                return this.value;
            }.call(this));
        }, b.prototype.publish = function() {
            var a, b, c, d, e, g, h, i, j;
            if (this.observer) {
                for (d = this.getValue(this.el), h = this.formatters.slice(0).reverse(), e = 0, 
                g = h.length; g > e; e++) b = h[e], a = b.split(/\s+/), c = a.shift(), (null != (i = this.view.formatters[c]) ? i.publish : void 0) && (d = (j = this.view.formatters[c]).publish.apply(j, [ d ].concat(f.call(a))));
                return this.observer.setValue(d);
            }
        }, b.prototype.bind = function() {
            var a, b, c, d, e, f, g;
            if (this.parseTarget(), null != (e = this.binder.bind) && e.call(this, this.el), 
            null != this.model && (null != (f = this.options.dependencies) ? f.length : void 0)) for (g = this.options.dependencies, 
            c = 0, d = g.length; d > c; c++) a = g[c], b = this.observe(this.model, a, this.sync), 
            this.dependencies.push(b);
            return this.view.preloadData ? this.sync() : void 0;
        }, b.prototype.unbind = function() {
            var a, b, c, d, e, f, g, h, i, j;
            for (null != (g = this.binder.unbind) && g.call(this, this.el), null != (h = this.observer) && h.unobserve(), 
            i = this.dependencies, e = 0, f = i.length; f > e; e++) d = i[e], d.unobserve();
            this.dependencies = [], j = this.formatterObservers;
            for (c in j) {
                b = j[c];
                for (a in b) d = b[a], d.unobserve();
            }
            return this.formatterObservers = {};
        }, b.prototype.update = function(a) {
            var b, c;
            return null == a && (a = {}), this.model = null != (b = this.observer) ? b.target : void 0, 
            null != (c = this.binder.update) ? c.call(this, a) : void 0;
        }, b.prototype.getValue = function(b) {
            return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, b) : a.Util.getInputValue(b);
        }, b;
    }(), a.ComponentBinding = function(b) {
        function c(a, b, c) {
            var d, f, g, h, j, k, l;
            for (this.view = a, this.el = b, this.type = c, this.unbind = e(this.unbind, this), 
            this.bind = e(this.bind, this), this.locals = e(this.locals, this), this.component = this.view.components[this.type], 
            this["static"] = {}, this.observers = {}, this.upstreamObservers = {}, f = a.bindingRegExp(), 
            k = this.el.attributes || [], h = 0, j = k.length; j > h; h++) d = k[h], f.test(d.name) || (g = this.camelCase(d.name), 
            i.call(null != (l = this.component["static"]) ? l : [], g) >= 0 ? this["static"][g] = d.value : this.observers[g] = d.value);
        }
        return h(c, b), c.prototype.sync = function() {}, c.prototype.update = function() {}, 
        c.prototype.publish = function() {}, c.prototype.locals = function() {
            var a, b, c, d, e, f;
            c = {}, e = this["static"];
            for (a in e) d = e[a], c[a] = d;
            f = this.observers;
            for (a in f) b = f[a], c[a] = b.value();
            return c;
        }, c.prototype.camelCase = function(a) {
            return a.replace(/-([a-z])/g, function(a) {
                return a[1].toUpperCase();
            });
        }, c.prototype.bind = function() {
            var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
            if (!this.bound) {
                o = this.observers;
                for (c in o) d = o[c], this.observers[c] = this.observe(this.view.models, d, function(a) {
                    return function(b) {
                        return function() {
                            return a.componentView.models[b] = a.observers[b].value();
                        };
                    };
                }(this).call(this, c));
                this.bound = !0;
            }
            if (null != this.componentView) return this.componentView.bind();
            for (this.el.innerHTML = this.component.template.call(this), h = this.component.initialize.call(this, this.el, this.locals()), 
            this.el._bound = !0, g = {}, p = a.extensions, k = 0, m = p.length; m > k; k++) {
                if (f = p[k], g[f] = {}, this.component[f]) {
                    q = this.component[f];
                    for (b in q) i = q[b], g[f][b] = i;
                }
                r = this.view[f];
                for (b in r) i = r[b], null == (j = g[f])[b] && (j[b] = i);
            }
            for (s = a.options, l = 0, n = s.length; n > l; l++) f = s[l], g[f] = null != (t = this.component[f]) ? t : this.view[f];
            this.componentView = new a.View(this.el, h, g), this.componentView.bind(), u = this.observers, 
            v = [];
            for (c in u) e = u[c], v.push(this.upstreamObservers[c] = this.observe(this.componentView.models, c, function(a) {
                return function(b, c) {
                    return function() {
                        return c.setValue(a.componentView.models[b]);
                    };
                };
            }(this).call(this, c, e)));
            return v;
        }, c.prototype.unbind = function() {
            var a, b, c, d, e;
            c = this.upstreamObservers;
            for (a in c) b = c[a], b.unobserve();
            d = this.observers;
            for (a in d) b = d[a], b.unobserve();
            return null != (e = this.componentView) ? e.unbind.call(this) : void 0;
        }, c;
    }(a.Binding), a.TextBinding = function(a) {
        function b(a, b, c, d, f) {
            this.view = a, this.el = b, this.type = c, this.keypath = d, this.options = null != f ? f : {}, 
            this.sync = e(this.sync, this), this.formatters = this.options.formatters || [], 
            this.dependencies = [], this.formatterObservers = {};
        }
        return h(b, a), b.prototype.binder = {
            routine: function(a, b) {
                return a.data = null != b ? b : "";
            }
        }, b.prototype.sync = function() {
            return b.__super__.sync.apply(this, arguments);
        }, b;
    }(a.Binding), a["public"].binders.text = function(a, b) {
        return null != a.textContent ? a.textContent = null != b ? b : "" : a.innerText = null != b ? b : "";
    }, a["public"].binders.html = function(a, b) {
        return a.innerHTML = null != b ? b : "";
    }, a["public"].binders.show = function(a, b) {
        return a.style.display = b ? "" : "none";
    }, a["public"].binders.hide = function(a, b) {
        return a.style.display = b ? "none" : "";
    }, a["public"].binders.enabled = function(a, b) {
        return a.disabled = !b;
    }, a["public"].binders.disabled = function(a, b) {
        return a.disabled = !!b;
    }, a["public"].binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish);
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish);
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) === (null != b ? b.toString() : void 0) : !!b;
        }
    }, a["public"].binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function(b) {
            return a.Util.bindEvent(b, "change", this.publish);
        },
        unbind: function(b) {
            return a.Util.unbindEvent(b, "change", this.publish);
        },
        routine: function(a, b) {
            var c;
            return a.checked = "radio" === a.type ? (null != (c = a.value) ? c.toString() : void 0) !== (null != b ? b.toString() : void 0) : !b;
        }
    }, a["public"].binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? (this.event = "SELECT" === b.tagName ? "change" : "input", 
            a.Util.bindEvent(b, this.event, this.publish)) : void 0;
        },
        unbind: function(b) {
            return "INPUT" !== b.tagName || "radio" !== b.type ? a.Util.unbindEvent(b, this.event, this.publish) : void 0;
        },
        routine: function(a, b) {
            var c, d, e, f, g, h, j;
            if ("INPUT" === a.tagName && "radio" === a.type) return a.setAttribute("value", b);
            if (null != window.jQuery) {
                if (a = jQuery(a), (null != b ? b.toString() : void 0) !== (null != (f = a.val()) ? f.toString() : void 0)) return a.val(null != b ? b : "");
            } else if ("select-multiple" === a.type) {
                if (null != b) {
                    for (j = [], d = 0, e = a.length; e > d; d++) c = a[d], j.push(c.selected = (g = c.value, 
                    i.call(b, g) >= 0));
                    return j;
                }
            } else if ((null != b ? b.toString() : void 0) !== (null != (h = a.value) ? h.toString() : void 0)) return a.value = null != b ? b : "";
        }
    }, a["public"].binders["if"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c;
            return null == this.marker ? (b = [ this.view.prefix, this.type ].join("-").replace("--", "-"), 
            c = a.getAttribute(b), this.marker = document.createComment(" rivets: " + this.type + " " + c + " "), 
            this.bound = !1, a.removeAttribute(b), a.parentNode.insertBefore(this.marker, a), 
            a.parentNode.removeChild(a)) : void 0;
        },
        unbind: function() {
            var a;
            return null != (a = this.nested) ? a.unbind() : void 0;
        },
        routine: function(b, c) {
            var d, e, f, g;
            if (!!c == !this.bound) {
                if (c) {
                    f = {}, g = this.view.models;
                    for (d in g) e = g[d], f[d] = e;
                    return (this.nested || (this.nested = new a.View(b, f, this.view.options()))).bind(), 
                    this.marker.parentNode.insertBefore(b, this.marker.nextSibling), this.bound = !0;
                }
                return b.parentNode.removeChild(b), this.nested.unbind(), this.bound = !1;
            }
        },
        update: function(a) {
            var b;
            return null != (b = this.nested) ? b.update(a) : void 0;
        }
    }, a["public"].binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function(b) {
            return a["public"].binders["if"].bind.call(this, b);
        },
        unbind: function() {
            return a["public"].binders["if"].unbind.call(this);
        },
        routine: function(b, c) {
            return a["public"].binders["if"].routine.call(this, b, !c);
        },
        update: function(b) {
            return a["public"].binders["if"].update.call(this, b);
        }
    }, a["public"].binders["on-*"] = {
        "function": !0,
        priority: 1e3,
        unbind: function(b) {
            return this.handler ? a.Util.unbindEvent(b, this.args[0], this.handler) : void 0;
        },
        routine: function(b, c) {
            return this.handler && a.Util.unbindEvent(b, this.args[0], this.handler), a.Util.bindEvent(b, this.args[0], this.handler = this.eventHandler(c));
        }
    }, a["public"].binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function(a) {
            var b, c, d, e, f;
            if (null == this.marker) b = [ this.view.prefix, this.type ].join("-").replace("--", "-"), 
            this.marker = document.createComment(" rivets: " + this.type + " "), this.iterated = [], 
            a.removeAttribute(b), a.parentNode.insertBefore(this.marker, a), a.parentNode.removeChild(a); else for (f = this.iterated, 
            d = 0, e = f.length; e > d; d++) c = f[d], c.bind();
        },
        unbind: function() {
            var a, b, c, d, e;
            if (null != this.iterated) {
                for (d = this.iterated, e = [], b = 0, c = d.length; c > b; b++) a = d[b], e.push(a.unbind());
                return e;
            }
        },
        routine: function(b, c) {
            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x;
            if (j = this.args[0], c = c || [], this.iterated.length > c.length) for (u = Array(this.iterated.length - c.length), 
            o = 0, r = u.length; r > o; o++) f = u[o], n = this.iterated.pop(), n.unbind(), 
            this.marker.parentNode.removeChild(n.els[0]);
            for (g = p = 0, s = c.length; s > p; g = ++p) if (i = c[g], e = {
                index: g
            }, e[j] = i, null == this.iterated[g]) {
                v = this.view.models;
                for (h in v) i = v[h], null == e[h] && (e[h] = i);
                l = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker, 
                k = this.view.options(), k.preloadData = !0, m = b.cloneNode(!0), n = new a.View(m, e, k), 
                n.bind(), this.iterated.push(n), this.marker.parentNode.insertBefore(m, l.nextSibling);
            } else this.iterated[g].models[j] !== i && this.iterated[g].update(e);
            if ("OPTION" === b.nodeName) {
                for (w = this.view.bindings, x = [], q = 0, t = w.length; t > q; q++) d = w[q], 
                x.push(d.el === this.marker.parentNode && "value" === d.type ? d.sync() : void 0);
                return x;
            }
        },
        update: function(a) {
            var b, c, d, e, f, g, h, i;
            b = {};
            for (c in a) d = a[c], c !== this.args[0] && (b[c] = d);
            for (h = this.iterated, i = [], f = 0, g = h.length; g > f; f++) e = h[f], i.push(e.update(b));
            return i;
        }
    }, a["public"].binders["class-*"] = function(a, b) {
        var c;
        return c = " " + a.className + " ", !b == (-1 !== c.indexOf(" " + this.args[0] + " ")) ? a.className = b ? "" + a.className + " " + this.args[0] : c.replace(" " + this.args[0] + " ", " ").trim() : void 0;
    }, a["public"].binders["*"] = function(a, b) {
        return null != b ? a.setAttribute(this.type, b) : a.removeAttribute(this.type);
    }, a["public"].adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function(a) {
            var b, c, d;
            return a.hasOwnProperty(this.id) || (b = this.counter++, Object.defineProperty(a, this.id, {
                value: b
            })), (c = this.weakmap)[d = a[this.id]] || (c[d] = {
                callbacks: {}
            });
        },
        cleanupWeakReference: function(a, b) {
            return Object.keys(a.callbacks).length || a.pointers && Object.keys(a.pointers).length ? void 0 : delete this.weakmap[b];
        },
        stubFunction: function(a, b) {
            var c, d, e;
            return d = a[b], c = this.weakReference(a), e = this.weakmap, a[b] = function() {
                var b, f, g, h, i, j, k, l, m, n;
                h = d.apply(a, arguments), k = c.pointers;
                for (g in k) for (f = k[g], n = null != (l = null != (m = e[g]) ? m.callbacks[f] : void 0) ? l : [], 
                i = 0, j = n.length; j > i; i++) (b = n[i])();
                return h;
            };
        },
        observeMutations: function(a, b, c) {
            var d, e, f, g, h, j;
            if (Array.isArray(a)) {
                if (f = this.weakReference(a), null == f.pointers) for (f.pointers = {}, e = [ "push", "pop", "shift", "unshift", "sort", "reverse", "splice" ], 
                h = 0, j = e.length; j > h; h++) d = e[h], this.stubFunction(a, d);
                if (null == (g = f.pointers)[b] && (g[b] = []), i.call(f.pointers[b], c) < 0) return f.pointers[b].push(c);
            }
        },
        unobserveMutations: function(a, b, c) {
            var d, e, f;
            return Array.isArray(a) && null != a[this.id] && (e = this.weakmap[a[this.id]]) && (f = e.pointers[b]) ? ((d = f.indexOf(c)) >= 0 && f.splice(d, 1), 
            f.length || delete e.pointers[b], this.cleanupWeakReference(e, a[this.id])) : void 0;
        },
        observe: function(a, b, c) {
            var d, e, f;
            return d = this.weakReference(a).callbacks, null == d[b] && (d[b] = [], e = Object.getOwnPropertyDescriptor(a, b), 
            (null != e ? e.get : void 0) || (null != e ? e.set : void 0) || (f = a[b], Object.defineProperty(a, b, {
                enumerable: !0,
                get: function() {
                    return f;
                },
                set: function(e) {
                    return function(g) {
                        var h, j, k, l;
                        if (g !== f && (e.unobserveMutations(f, a[e.id], b), f = g, h = e.weakmap[a[e.id]])) {
                            if (d = h.callbacks, d[b]) for (l = d[b].slice(), j = 0, k = l.length; k > j; j++) c = l[j], 
                            i.call(d[b], c) >= 0 && c();
                            return e.observeMutations(g, a[e.id], b);
                        }
                    };
                }(this)
            }))), i.call(d[b], c) < 0 && d[b].push(c), this.observeMutations(a[b], a[this.id], b);
        },
        unobserve: function(a, b, c) {
            var d, e, f;
            return (f = this.weakmap[a[this.id]]) && (d = f.callbacks[b]) ? ((e = d.indexOf(c)) >= 0 && (d.splice(e, 1), 
            d.length || delete f.callbacks[b]), this.unobserveMutations(a[b], a[this.id], b), 
            this.cleanupWeakReference(f, a[this.id])) : void 0;
        },
        get: function(a, b) {
            return a[b];
        },
        set: function(a, b, c) {
            return a[b] = c;
        }
    }, a.factory = function(b) {
        return a.sightglass = b, a["public"]._ = a, a["public"];
    }, "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = a.factory(require("sightglass")) : "function" == typeof define && define.amd ? define([ "sightglass" ], function(b) {
        return this.rivets = a.factory(b);
    }) : this.rivets = a.factory(sightglass);
}.call(this), function() {
    var a, b, c, d, e, f, g = function(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    };
    b = function() {
        function a() {
            this.update = g(this.update, this);
        }
        return a.prototype.update = function(a) {
            var b, c, e;
            for (c in a) e = a[c], "items" !== c && (this[c] = e);
            return this.items = function() {
                var c, e, f, g;
                for (f = a.items, g = [], c = 0, e = f.length; e > c; c++) b = f[c], g.push(new d(b));
                return g;
            }();
        }, a;
    }(), d = function() {
        function a(a) {
            this.propertyArray = g(this.propertyArray, this), this.update = g(this.update, this), 
            this.update(a);
        }
        return a.prototype.update = function(a) {
            var b, d;
            for (b in a) d = a[b], "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties);
        }, a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties, d = [];
            for (a in c) b = c[a], d.push({
                name: a,
                value: b
            });
            return d;
        }, a;
    }(), c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null
        },
        cart: new b()
    }, c.init = function(a, b) {
        return null == b && (b = {}), c.configure(b), c.Utils.log("Initialising CartJS."), 
        c.cart.update(a), c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'), 
        c.Data.init()), c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'), 
        $(document).on("cart.requestStarted", function() {
            return $("body").addClass(c.settings.requestBodyClass);
        }), $(document).on("cart.requestComplete", function() {
            return $("body").removeClass(c.settings.requestBodyClass);
        })), c.Rivets.init();
    }, c.configure = function(a) {
        return null == a && (a = {}), c.Utils.extend(c.settings, a);
    }, null == window.console && (window.console = {}, window.console.log = function() {}), 
    c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments);
        },
        error: function() {
            return c.Utils.console(console.error, arguments);
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b), 
            b.unshift("[CartJS]:"), a.apply(console, b)) : void 0;
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"), f = {};
            for (d in a) e = a[d], f["" + b + "[" + d + "]"] = null != c ? c : e;
            return f;
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"), e = {};
            for (d in a) g = a[d], f = d.replace("" + b + "[", "").replace("]", ""), e[f] = null != c ? c : g;
            return e;
        },
        extend: function(a, b) {
            var c, d;
            for (c in b) d = b[c], a[c] = d;
            return a;
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a) return a;
            c = new a.constructor();
            for (b in a) c[b] = clone(a[b]);
            return c;
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === {}.toString.call(a);
        },
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [ a ] : [];
        },
        formatMoney: function(a, b, d, e) {
            var f, g;
            return null == e && (e = ""), e || (e = c.settings.currency), null != window.Currency && e !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, e), 
            null != (null != (f = window.Currency) ? f.moneyFormats : void 0) && e in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[e][d])), 
            null != (null != (g = window.Shopify) ? g.formatMoney : void 0) ? Shopify.formatMoney(a, b) : a;
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? Shopify.Image.getSizedImageUrl(a, b) : a;
        }
    }, f = [], e = !1, c.Queue = {
        add: function(a, b, d) {
            var g;
            return null == d && (d = {}), g = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            }, d.updateCart && g.success.push(c.cart.update), f.push(g), e ? void 0 : (jQuery(document).trigger("cart.requestStarted", [ c.cart ]), 
            c.Queue.process());
        },
        process: function() {
            var a;
            return f.length ? (e = !0, a = f.shift(), a.complete = c.Queue.process, jQuery.ajax(a)) : (e = !1, 
            void jQuery(document).trigger("cart.requestComplete", [ c.cart ]));
        }
    }, c.Core = {
        getCart: function(a) {
            return null == a && (a = {}), a.type = "GET", a.updateCart = !0, c.Queue.add("/cart.js", {}, a);
        },
        addItem: function(a, b, d, e) {
            var f;
            return null == b && (b = 1), null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), 
            f.id = a, f.quantity = b, c.Queue.add("/cart/add.js", f, e), c.Core.getCart();
        },
        updateItem: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.line = a, 
            null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        removeItem: function(a, b) {
            return null == b && (b = {}), c.Core.updateItem(a, 0, {}, b);
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.id = a, 
            null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                updates: a
            }, b);
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}), d = {
                id: a,
                quantity: 0
            }, b.updateCart = !0, c.Queue.add("/cart/change.js", d, b);
        },
        clear: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/clear.js", {}, a);
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b;
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}), e = {}, e[a] = b, c.Core.setAttributes(e, d);
        },
        getAttributes: function() {
            return c.cart.attributes;
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b);
        },
        clearAttributes: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a);
        },
        getNote: function() {
            return c.cart.note;
        },
        setNote: function(a, b) {
            return null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                note: a
            }, b);
        }
    }, a = jQuery(document), c.Data = {
        init: function() {
            return c.Data.setEventListeners("on"), c.Data.render(null, c.cart);
        },
        destroy: function() {
            return c.Data.setEventListeners("off");
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add), a[b]("click", "[data-cart-remove]", c.Data.remove), 
            a[b]("click", "[data-cart-remove-id]", c.Data.removeById), a[b]("click", "[data-cart-update]", c.Data.update), 
            a[b]("click", "[data-cart-update-id]", c.Data.updateById), a[b]("click", "[data-cart-clear]", c.Data.clear), 
            a[b]("change", "[data-cart-toggle]", c.Data.toggle), a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute), 
            a[b]("submit", "[data-cart-submit]", c.Data.submit), a[b]("cart.requestComplete", c.Data.render);
        },
        add: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"));
        },
        remove: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.removeItem(b.attr("data-cart-remove"));
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.removeItemById(b.attr("data-cart-remove-id"));
        },
        update: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"));
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(), b = jQuery(this), c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"));
        },
        clear: function(a) {
            return a.preventDefault(), c.Core.clear();
        },
        toggle: function() {
            var a, b;
            return a = jQuery(this), b = a.attr("data-cart-toggle"), a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b);
        },
        toggleAttribute: function() {
            var a, b;
            return a = jQuery(this), b = a.attr("data-cart-toggle-attribute"), c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "");
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(), b = jQuery(this).serializeArray(), d = void 0, f = void 0, 
            e = {}, jQuery.each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : e[b.name] = b.value;
            }), c.Core.addItem(d, f, c.Utils.unwrapKeys(e));
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            }, jQuery("[data-cart-render]").each(function() {
                var a;
                return a = jQuery(this), a.html(d[a.attr("data-cart-render")]);
            });
        }
    }, "rivets" in window ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews(), null != c.IE8 ? c.IE8.init() : void 0;
        },
        destroy: function() {
            return c.Rivets.unbindViews(), null != c.IE8 ? c.IE8.destroy() : void 0;
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."), c.Rivets.unbindViews(), 
            c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels), null != window.Currency && (c.Rivets.model.Currency = window.Currency), 
            jQuery("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind(jQuery(this), c.Rivets.model), c.Rivets.boundViews.push(a);
            });
        },
        unbindViews: function() {
            var a, b, d, e;
            for (e = c.Rivets.boundViews, b = 0, d = e.length; d > b; b++) a = e[b], a.unbind();
            return c.Rivets.boundViews = [];
        }
    }, rivets.formatters.eq = function(a, b) {
        return a === b;
    }, rivets.formatters.lt = function(a, b) {
        return b > a;
    }, rivets.formatters.gt = function(a, b) {
        return a > b;
    }, rivets.formatters.not = function(a) {
        return !a;
    }, rivets.formatters.empty = function(a) {
        return !a.length;
    }, rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b);
    }, rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b);
    }, rivets.formatters.prepend = function(a, b) {
        return b + a;
    }, rivets.formatters.append = function(a, b) {
        return a + b;
    }, rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b);
    }, rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b);
    }, rivets.formatters.productImageSize = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b);
    }) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    }, c.factory = function(a) {
        return a.init = c.init, a.configure = c.configure, a.cart = c.cart, a.settings = c.settings, 
        a.getCart = c.Core.getCart, a.addItem = c.Core.addItem, a.updateItem = c.Core.updateItem, 
        a.updateItemById = c.Core.updateItemById, a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById, 
        a.removeItem = c.Core.removeItem, a.removeItemById = c.Core.removeItemById, a.clear = c.Core.clear, 
        a.getAttribute = c.Core.getAttribute, a.setAttribute = c.Core.setAttribute, a.getAttributes = c.Core.getAttributes, 
        a.setAttributes = c.Core.setAttributes, a.clearAttributes = c.Core.clearAttributes, 
        a.getNote = c.Core.getNote, a.setNote = c.Core.setNote, a.render = c.Data.render;
    }, "object" == typeof exports ? c.factory(exports) : "function" == typeof define && define.amd ? define([ "exports" ], function(a) {
        return c.factory(this.CartJS = a), a;
    }) : c.factory(this.CartJS = {});
}.call(this);

(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) {
        define([ "jquery" ], factory);
    } else if (typeof exports !== "undefined") {
        module.exports = factory(require("jquery"));
    } else {
        factory(jQuery);
    }
})(function($) {
    "use strict";
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings, responsiveSettings, breakpoint;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next">Next</button>',
                autoplay: false,
                autoplaySpeed: 3e3,
                centerMode: false,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(slider, i) {
                    return '<button type="button" data-role="none">' + (i + 1) + "</button>";
                },
                dots: false,
                dotsClass: "slick-dots",
                draggable: true,
                easing: "linear",
                edgeFriction: .35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnDotsHover: false,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: false,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.hidden = "hidden";
            _.paused = false;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = "visibilitychange";
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data("slick") || {};
            _.options = $.extend({}, _.defaults, dataSettings, settings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            responsiveSettings = _.options.responsive || null;
            if (responsiveSettings && responsiveSettings.length > -1) {
                _.respondTo = _.options.respondTo || "window";
                for (breakpoint in responsiveSettings) {
                    if (responsiveSettings.hasOwnProperty(breakpoint)) {
                        _.breakpoints.push(responsiveSettings[breakpoint].breakpoint);
                        _.breakpointSettings[responsiveSettings[breakpoint].breakpoint] = responsiveSettings[breakpoint].settings;
                    }
                }
                _.breakpoints.sort(function(a, b) {
                    if (_.options.mobileFirst === true) {
                        return a - b;
                    } else {
                        return b - a;
                    }
                });
            }
            if (typeof document.mozHidden !== "undefined") {
                _.hidden = "mozHidden";
                _.visibilityChange = "mozvisibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                _.hidden = "msHidden";
                _.visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                _.hidden = "webkitHidden";
                _.visibilityChange = "webkitvisibilitychange";
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.instanceUid = instanceUid++;
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.init();
            _.checkResponsive(true);
        }
        return Slick;
    }();
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === "boolean") {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }
        _.unload();
        if (typeof index === "number") {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr("data-slick-index", index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }
        } else {
            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = "translate(" + now + "px, 0px)";
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = "translate(0px," + now + "px)";
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });
            } else {
                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);
                if (_.options.vertical === false) {
                    animProps[_.animType] = "translate3d(" + targetLeft + "px, 0px, 0px)";
                } else {
                    animProps[_.animType] = "translate3d(0px," + targetLeft + "px, 0px)";
                }
                _.$slideTrack.css(animProps);
                if (callback) {
                    setTimeout(function() {
                        _.disableTransition();
                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.options.asNavFor !== null ? $(_.options.asNavFor).slick("getSlick") : null;
        if (asNavFor !== null) asNavFor.slideHandler(index, true);
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + " " + _.options.speed + "ms " + _.options.cssEase;
        } else {
            transition[_.transitionType] = "opacity " + _.options.speed + "ms " + _.options.cssEase;
        }
        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
        if (_.slideCount > _.options.slidesToShow && _.paused !== true) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this;
        if (_.options.infinite === false) {
            if (_.direction === 1) {
                if (_.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                }
                _.slideHandler(_.currentSlide + _.options.slidesToScroll);
            } else {
                if (_.currentSlide - 1 === 0) {
                    _.direction = 1;
                }
                _.slideHandler(_.currentSlide - _.options.slidesToScroll);
            }
        } else {
            _.slideHandler(_.currentSlide + _.options.slidesToScroll);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow = $(_.options.prevArrow);
            _.$nextArrow = $(_.options.nextArrow);
            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.appendTo(_.options.appendArrows);
            }
            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.appendTo(_.options.appendArrows);
            }
            if (_.options.infinite !== true) {
                _.$prevArrow.addClass("slick-disabled");
            }
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dotString;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            dotString = '<ul class="' + _.options.dotsClass + '">';
            for (i = 0; i <= _.getDotCount(); i += 1) {
                dotString += "<li>" + _.options.customPaging.call(this, _, i) + "</li>";
            }
            dotString += "</ul>";
            _.$dots = $(dotString).appendTo(_.options.appendDots);
            _.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(":not(.slick-cloned)").addClass("slick-slide");
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr("data-slick-index", index);
        });
        _.$slidesCache = _.$slides;
        _.$slider.addClass("slick-slider");
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css("opacity", 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }
        $("img[data-lazy]", _.$slider).not("[src]").addClass("slick-loading");
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        if (_.options.accessibility === true) {
            _.$list.prop("tabIndex", 0);
        }
        _.setSlideClasses(typeof this.currentSlide === "number" ? this.currentSlide : 0);
        if (_.options.draggable === true) {
            _.$list.addClass("draggable");
        }
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 1) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement("div");
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement("div");
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.html(newSlides);
            _.$slider.children().children().children().width(100 / _.options.slidesPerRow + "%").css({
                display: "inline-block"
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === "window") {
            respondToWidth = windowWidth;
        } else if (_.respondTo === "slider") {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === "min") {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }
        if (_.originalSettings.responsive && _.originalSettings.responsive.length > -1 && _.originalSettings.responsive !== null) {
            targetBreakpoint = null;
            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === "unslick") {
                            _.unslick();
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh();
                        }
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === "unslick") {
                        _.unslick();
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh();
                    }
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) _.currentSlide = _.options.initialSlide;
                    _.refresh();
                }
            }
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.target), indexOffset, slideOffset, unevenOffset;
        $target.is("a") && event.preventDefault();
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch (event.data.message) {
          case "previous":
            slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
            if (_.slideCount > _.options.slidesToShow) {
                _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
            }
            break;

          case "next":
            slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
            if (_.slideCount > _.options.slidesToShow) {
                _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
            }
            break;

          case "index":
            var index = event.data.index === 0 ? 0 : event.data.index || $(event.target).parent().index() * _.options.slidesToScroll;
            _.slideHandler(_.checkNavigable(index), false, dontAnimate);
            break;

          default:
            return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $("li", _.$dots).off("click.slick", _.changeSlide);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.options.autoplay === true) {
            $("li", _.$dots).off("mouseenter.slick", _.setPaused.bind(_, true)).off("mouseleave.slick", _.setPaused.bind(_, false));
        }
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off("click.slick", _.changeSlide);
            _.$nextArrow && _.$nextArrow.off("click.slick", _.changeSlide);
        }
        _.$list.off("touchstart.slick mousedown.slick", _.swipeHandler);
        _.$list.off("touchmove.slick mousemove.slick", _.swipeHandler);
        _.$list.off("touchend.slick mouseup.slick", _.swipeHandler);
        _.$list.off("touchcancel.slick mouseleave.slick", _.swipeHandler);
        _.$list.off("click.slick", _.clickHandler);
        if (_.options.autoplay === true) {
            $(document).off(_.visibilityChange, _.visibility);
        }
        _.$list.off("mouseenter.slick", _.setPaused.bind(_, true));
        _.$list.off("mouseleave.slick", _.setPaused.bind(_, false));
        if (_.options.accessibility === true) {
            _.$list.off("keydown.slick", _.keyHandler);
        }
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off("click.slick", _.selectHandler);
        }
        $(window).off("orientationchange.slick.slick-" + _.instanceUid, _.orientationChange);
        $(window).off("resize.slick.slick-" + _.instanceUid, _.resize);
        $("[draggable!=true]", _.$slideTrack).off("dragstart", _.preventDefault);
        $(window).off("load.slick.slick-" + _.instanceUid, _.setPosition);
        $(document).off("ready.slick.slick-" + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr("style");
            _.$slider.html(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function() {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $(".slick-cloned", _.$slider).remove();
        if (_.$dots) {
            _.$dots.remove();
        }
        if (_.$prevArrow && typeof _.options.prevArrow !== "object") {
            _.$prevArrow.remove();
        }
        if (_.$nextArrow && typeof _.options.nextArrow !== "object") {
            _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass("slick-slide slick-active slick-center slick-visible").attr("aria-hidden", "true").removeAttr("data-slick-index").css({
                position: "",
                left: "",
                top: "",
                zIndex: "",
                opacity: "",
                width: ""
            });
            _.$slider.html(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass("slick-slider");
        _.$slider.removeClass("slick-initialized");
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = "";
        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: 1e3
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: 1e3
            });
            if (callback) {
                setTimeout(function() {
                    _.disableTransition(slideIndex);
                    callback.call();
                }, _.options.speed);
            }
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            pagerQty = Math.ceil(_.slideCount / _.options.slidesToScroll);
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToShow;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight();
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                verticalOffset = verticalHeight * _.options.slidesToShow * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow);
            }
            targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.options.infinite === false) {
                    targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex + _.options.slidesToShow + 1);
                }
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) {
            max = _.slideCount - _.options.slidesToShow + 1;
            if (_.options.centerMode === true) max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find(".slick-slide").each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr("data-slick-index") - _.currentSlide) || 1;
            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: "index",
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function() {
        var _ = this;
        if (!$(_.$slider).hasClass("slick-initialized")) {
            $(_.$slider).addClass("slick-initialized");
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
        }
        _.$slider.trigger("init", [ _ ]);
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.on("click.slick", {
                message: "previous"
            }, _.changeSlide);
            _.$nextArrow.on("click.slick", {
                message: "next"
            }, _.changeSlide);
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $("li", _.$dots).on("click.slick", {
                message: "index"
            }, _.changeSlide);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.options.autoplay === true) {
            $("li", _.$dots).on("mouseenter.slick", _.setPaused.bind(_, true)).on("mouseleave.slick", _.setPaused.bind(_, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, _.swipeHandler);
        _.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, _.swipeHandler);
        _.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, _.swipeHandler);
        _.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, _.swipeHandler);
        _.$list.on("click.slick", _.clickHandler);
        if (_.options.autoplay === true) {
            $(document).on(_.visibilityChange, _.visibility.bind(_));
        }
        _.$list.on("mouseenter.slick", _.setPaused.bind(_, true));
        _.$list.on("mouseleave.slick", _.setPaused.bind(_, false));
        if (_.options.accessibility === true) {
            _.$list.on("keydown.slick", _.keyHandler);
        }
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        }
        $(window).on("orientationchange.slick.slick-" + _.instanceUid, _.orientationChange.bind(_));
        $(window).on("resize.slick.slick-" + _.instanceUid, _.resize.bind(_));
        $("[draggable!=true]", _.$slideTrack).on("dragstart", _.preventDefault);
        $(window).on("load.slick.slick-" + _.instanceUid, _.setPosition);
        $(document).on("ready.slick.slick-" + _.instanceUid, _.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.show();
        }
        if (_.options.autoplay === true) {
            _.autoPlay();
        }
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        if (event.keyCode === 37 && _.options.accessibility === true) {
            _.changeSlide({
                data: {
                    message: "previous"
                }
            });
        } else if (event.keyCode === 39 && _.options.accessibility === true) {
            _.changeSlide({
                data: {
                    message: "next"
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $("img[data-lazy]", imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr("data-lazy"), imageToLoad = document.createElement("img");
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 1
                    }, 200);
                };
                imageToLoad.src = imageSource;
                image.css({
                    opacity: 0
                }).attr("src", imageSource).removeAttr("data-lazy").removeClass("slick-loading");
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = rangeStart + _.options.slidesToShow;
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find(".slick-slide").slice(rangeStart, rangeEnd);
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-slide");
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find(".slick-cloned").slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find(".slick-cloned").slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass("slick-loading");
        _.initUI();
        if (_.options.lazyLoad === "progressive") {
            _.progressiveLazyLoad();
        }
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: "next"
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.paused = false;
        _.autoPlay();
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        _.$slider.trigger("afterChange", [ _, index ]);
        _.animating = false;
        _.setPosition();
        _.swipeLeft = null;
        if (_.options.autoplay === true && _.paused === false) {
            _.autoPlay();
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: "previous"
            }
        });
    };
    Slick.prototype.preventDefault = function(e) {
        e.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function() {
        var _ = this, imgCount, targetImage;
        imgCount = $("img[data-lazy]", _.$slider).length;
        if (imgCount > 0) {
            targetImage = $("img[data-lazy]", _.$slider).first();
            targetImage.attr("src", targetImage.attr("data-lazy")).removeClass("slick-loading").load(function() {
                targetImage.removeAttr("data-lazy");
                _.progressiveLazyLoad();
                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }
            }).error(function() {
                targetImage.removeAttr("data-lazy");
                _.progressiveLazyLoad();
            });
        }
    };
    Slick.prototype.refresh = function() {
        var _ = this, currentSlide = _.currentSlide;
        _.destroy();
        $.extend(_, _.initials);
        _.init();
        _.changeSlide({
            data: {
                message: "index",
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass("slick-slide");
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on("click.slick", _.selectHandler);
        }
        _.setSlideClasses(0);
        _.setPosition();
        _.$slider.trigger("reInit", [ _ ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === "boolean") {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }
        _.unload();
        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == "left" ? Math.ceil(position) + "px" : "0px";
        y = _.positionProp == "top" ? Math.ceil(position) + "px" : "0px";
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = "translate(" + x + ", " + y + ")";
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = "translate3d(" + x + ", " + y + ", 0px)";
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: "0px " + _.options.centerPadding
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding + " 0px"
                });
            }
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children(".slick-slide").length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5e3 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children(".slick-slide").length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children(".slick-slide").width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: "relative",
                    right: targetLeft,
                    top: 0,
                    zIndex: 800,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: "relative",
                    left: targetLeft,
                    top: 0,
                    zIndex: 800,
                    opacity: 0
                });
            }
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: 900,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css("height", targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function(option, value, refresh) {
        var _ = this;
        _.options[option] = value;
        if (refresh === true) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }
        _.$slider.trigger("setPosition", [ _ ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? "top" : "left";
        if (_.positionProp === "top") {
            _.$slider.addClass("slick-vertical");
        } else {
            _.$slider.removeClass("slick-vertical");
        }
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = "OTransform";
            _.transformType = "-o-transform";
            _.transitionType = "OTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = "MozTransform";
            _.transformType = "-moz-transform";
            _.transitionType = "MozTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = "webkitTransform";
            _.transformType = "-webkit-transform";
            _.transitionType = "webkitTransition";
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = "msTransform";
            _.transformType = "-ms-transform";
            _.transitionType = "msTransition";
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = "transform";
            _.transformType = "transform";
            _.transitionType = "transition";
        }
        _.transformsEnabled = _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        _.$slider.find(".slick-slide").removeClass("slick-active").attr("aria-hidden", "true").removeClass("slick-center");
        allSlides = _.$slider.find(".slick-slide");
        if (_.options.centerMode === true) {
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
                    _.$slides.slice(index - centerOffset, index + centerOffset + 1).addClass("slick-active").attr("aria-hidden", "false");
                } else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2).addClass("slick-active").attr("aria-hidden", "false");
                }
                if (index === 0) {
                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass("slick-center");
                } else if (index === _.slideCount - 1) {
                    allSlides.eq(_.options.slidesToShow).addClass("slick-center");
                }
            }
            _.$slides.eq(index).addClass("slick-center");
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
                _.$slides.slice(index, index + _.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false");
            } else if (allSlides.length <= _.options.slidesToShow) {
                allSlides.addClass("slick-active").attr("aria-hidden", "false");
            } else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass("slick-active").attr("aria-hidden", "false");
                } else {
                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false");
                }
            }
        }
        if (_.options.lazyLoad === "ondemand") {
            _.lazyLoad();
        }
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) {
            _.options.centerMode = false;
        }
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }
                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr("id", "").attr("data-slick-index", slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass("slick-cloned");
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr("id", "").attr("data-slick-index", slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass("slick-cloned");
                }
                _.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                    $(this).attr("id", "");
                });
            }
        }
    };
    Slick.prototype.setPaused = function(paused) {
        var _ = this;
        if (_.options.autoplay === true && _.options.pauseOnHover === true) {
            _.paused = paused;
            _.autoPlayClear();
        }
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is(".slick-slide") ? $(event.target) : $(event.target).parents(".slick-slide");
        var index = parseInt(targetElement.attr("data-slick-index"));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.$slider.find(".slick-slide").removeClass("slick-active").attr("aria-hidden", "true");
            _.$slides.eq(index).addClass("slick-active").attr("aria-hidden", "false");
            if (_.options.centerMode === true) {
                _.$slider.find(".slick-slide").removeClass("slick-center");
                _.$slides.eq(index).addClass("slick-center");
            }
            _.asNavFor(index);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }
        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }
        if (sync === false) {
            _.asNavFor(index);
        }
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }
        if (_.options.autoplay === true) {
            clearInterval(_.autoPlayTimer);
        }
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }
        _.animating = true;
        _.$slider.trigger("beforeChange", [ _, _.currentSlide, animSlide ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$dots.hide();
        }
        _.$slider.addClass("slick-loading");
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }
        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? "left" : "right";
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? "left" : "right";
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? "right" : "left";
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return "left";
            } else {
                return "right";
            }
        }
        return "vertical";
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount;
        _.dragging = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) {
            return false;
        }
        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger("edge", [ _, _.swipeDirection() ]);
        }
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            switch (_.swipeDirection()) {
              case "left":
                slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                _.slideHandler(slideCount);
                _.currentDirection = 0;
                _.touchObject = {};
                _.$slider.trigger("swipe", [ _, "left" ]);
                break;

              case "right":
                slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                _.slideHandler(slideCount);
                _.currentDirection = 1;
                _.touchObject = {};
                _.$slider.trigger("swipe", [ _, "right" ]);
                break;
            }
        } else {
            if (_.touchObject.startX !== _.touchObject.curX) {
                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || "ontouchend" in document && _.options.swipe === false) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf("mouse") !== -1) {
            return;
        }
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }
        switch (event.data.action) {
          case "start":
            _.swipeStart(event);
            break;

          case "move":
            _.swipeMove(event);
            break;

          case "end":
            _.swipeEnd(event);
            break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }
        swipeDirection = _.swipeDirection();
        if (swipeDirection === "vertical") {
            return;
        }
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === "right" || _.currentSlide >= _.getDotCount() && swipeDirection === "left") {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }
        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $(".slick-cloned", _.$slider).remove();
        if (_.$dots) {
            _.$dots.remove();
        }
        if (_.$prevArrow && typeof _.options.prevArrow !== "object") {
            _.$prevArrow.remove();
        }
        if (_.$nextArrow && typeof _.options.nextArrow !== "object") {
            _.$nextArrow.remove();
        }
        _.$slides.removeClass("slick-slide slick-active slick-visible").attr("aria-hidden", "true").css("width", "");
    };
    Slick.prototype.unslick = function() {
        var _ = this;
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.options.infinite !== true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.removeClass("slick-disabled");
            _.$nextArrow.removeClass("slick-disabled");
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass("slick-disabled");
                _.$nextArrow.removeClass("slick-disabled");
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass("slick-disabled");
                _.$prevArrow.removeClass("slick-disabled");
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass("slick-disabled");
                _.$prevArrow.removeClass("slick-disabled");
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true");
            _.$dots.find("li").eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false");
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (document[_.hidden]) {
            _.paused = true;
            _.autoPlayClear();
        } else {
            _.paused = false;
            _.autoPlay();
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i = 0, ret;
        for (i; i < l; i++) {
            if (typeof opt == "object" || typeof opt == "undefined") _[i].slick = new Slick(_[i], opt); else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != "undefined") return ret;
        }
        return _;
    };
});